import varianceAnalysisConstants from "./../constants"
// let xlsx = require('xlsx');
let styledxlsx = require('sheetjs-style');

import { validateFileExtension , validateExcelHeaders, getAvailableRoles} from '../utils/helper';
import { BULK_APPROVE_REJECT , BULK_REGIONAL_COMMENTARY, ROLES , ROLE_LABEL_MAPPING , VIEW_ONLY, AMOUNT_TYPES, MATERIALITY_REQUEST_TYPES, FILTER_APPROVAL_STATUS } from '../utils/constants';
import { validateBulkApprove } from '../utils/bulkApproveValidation';
import { formatVarianceActivityLogEntries } from '../utils/activityLogHelpers';
import { storeGet } from '@/store/store-utils';
import { Chart, LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale } from 'chart.js';
Chart.register(LineController, LineElement, PointElement, Title, Tooltip, CategoryScale, LinearScale);


const helpers = {
  getReportingTypeLabel(type) {
    const { REPORTING_TYPES } = varianceAnalysisConstants;
    if (type === REPORTING_TYPES.PL || type === REPORTING_TYPES.PL_LABEL) {
      return REPORTING_TYPES.PL_LABEL;
    }
    if (type === REPORTING_TYPES.BS || type === REPORTING_TYPES.BS_LABEL) {
      return REPORTING_TYPES.BS_LABEL;
    }
    return type || "N/A";
  },
  openRevenueDetailsDialog(client) {
    this.selectedRevenueDetail = client;
    this.revenueDetailDialog = true;
  },
  getIntersectHandler(v) {
    return (entries) => entries[0]?.isIntersecting && this.handleIntersect(v.__index);
  },
/**
* Generalized JV commentary validation for local/regional, actual/forecast.
* @param {Object} commentaryData
* @param {String} key - varianceAnalysisConstants.JV_COMMENTARY.ACTUAL or .FORECAST
* @param {String} stageKey - varianceAnalysisConstants.STAGES.STAGE_LOCAL or .STAGE_REGIONAL
* @param {String} workflowFlag - varianceAnalysisConstants.WORKFLOWS_STATUS.IS_LOCAL_ENABLED or .IS_REGIONAL_ENABLED
* @returns {Boolean}
*/
isJVCommentaryValid( commentaryData, key, stageKey, workflowFlag, workflows ) {
  try {
    const wf = workflows || {};
    const isLocalEnabled = wf.islocalenabled || false;
    const isRegionalEnabled = wf.isregionalenabled || false;
    // Special case: both workflows disabled, but commentary exists and stage matches
  if (
    !isLocalEnabled &&
    !isRegionalEnabled &&
    commentaryData[key] &&
    Object.keys(commentaryData[key]).length !== 0 &&
    [varianceAnalysisConstants.STAGES.COMMENTARY_AWAITING, varianceAnalysisConstants.STAGES.COMMENTARY_NIL_VALUE, varianceAnalysisConstants.STAGES.IMMATERIAL_VARIANCE, varianceAnalysisConstants.STAGES.COMMENTARY_NOT_IN_SCOPE].includes(commentaryData[varianceAnalysisConstants.STAGES.STAGE_LOCAL])
  ) {
    return true;
  }
    return (
      commentaryData[key] &&
      Object.keys(commentaryData[key]).length !== 0 &&
      [varianceAnalysisConstants.STAGES.COMMENTARY_AWAITING, varianceAnalysisConstants.STAGES.COMMENTARY_NIL_VALUE, varianceAnalysisConstants.STAGES.IMMATERIAL_VARIANCE, varianceAnalysisConstants.STAGES.COMMENTARY_NOT_IN_SCOPE].includes(commentaryData[stageKey]) &&
      wf[workflowFlag]
    );
  } catch (error) {
    console.error("Error in isJVCommentaryValid:", error);
    return false;
  }
},
  localCommentary1Count(v) {
    if (!v.commentary1) return '';
    const label = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approval Reason');
    const reason = v.approvereason || '-';
    const commentary = v.commentary1;
    const truncated = commentary.length > 250 ? commentary.substring(0, 250) + '...' : commentary;
    return `${truncated}<br><strong>${label}:</strong><br>${reason}`;
  },

  localCommentary2Count(v) {
    if (!v.commentary2) return '';
    const label = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approval Reason');
    const reason = v.approvereason || '-';
    const commentary = v.commentary2;
    const truncated = commentary.length > 250 ? commentary.substring(0, 250) + '...' : commentary;
    return `${truncated}<br><strong>${label}:</strong><br>${reason}`;
  },

  regionalCommentary1Count(v) {
    if (!v.regionalcommentary1) return '';
    const label = this.$nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approval Reason');
    const reason = v.regionalapprovereason || '-';
    const commentary = v.regionalcommentary1;
    const truncated = commentary.length > 250 ? commentary.substring(0, 250) + '...' : commentary;
    return `${truncated}<br><strong>${label}:</strong><br>${reason}`;
  },
  isJVCommentaryValidForLocal(commentaryData, key, workflows) {
return this.isJVCommentaryValid(
  commentaryData,
  key,
  varianceAnalysisConstants.STAGES.STAGE_LOCAL,
  varianceAnalysisConstants.WORKFLOWS_STATUS.IS_LOCAL_ENABLED,
  workflows
);
  },
  isJVCommentaryValidForRegional(commentaryData, key, workflows) {
    // Only show in regional if not valid for local
    if (
      this.isJVCommentaryValidForLocal(
        commentaryData,
        key,
        workflows
      )
    ) {
      return false;
    }
    return this.isJVCommentaryValid(
      commentaryData,
      key,
      varianceAnalysisConstants.STAGES.STAGE_REGIONAL,
      varianceAnalysisConstants.WORKFLOWS_STATUS.IS_REGIONAL_ENABLED,
      workflows
    );
  }, 
  isActualJVCommentaryValidForLocal(commentaryData, workflows) {
    return this.isJVCommentaryValidForLocal(commentaryData, varianceAnalysisConstants.JV_COMMENTARY.ACTUAL, workflows);
  },
  isForecastJVCommentaryValidForLocal(commentaryData, workflows) {
    return this.isJVCommentaryValidForLocal(commentaryData, varianceAnalysisConstants.JV_COMMENTARY.FORECAST, workflows);
  },
  isActualJVCommentaryValidForRegional(commentaryData, workflows) {
    return this.isJVCommentaryValidForRegional(commentaryData, varianceAnalysisConstants.JV_COMMENTARY.ACTUAL, workflows);
  },
  isForecastJVCommentaryValidForRegional(commentaryData, workflows) {
    return this.isJVCommentaryValidForRegional(commentaryData, varianceAnalysisConstants.JV_COMMENTARY.FORECAST, workflows);
  },
regionalCommentary2Count(v) {
    if (!v.regionalcommentary2) return '';
    const label = this.$nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Regional Approval Reason');
    const reason = v.regionalapprovereason || '-';
    const commentary = v.regionalcommentary2;
    const truncated = commentary.length > 250 ? commentary.substring(0, 250) + '...' : commentary;
    return `${truncated}<br><strong>${label}:</strong><br>${reason}`;
  },
  commentaryChart(str1,str2){
    const combinedLength = (str1 + this.$nova.labelsName('cycle_page','commentary_local_approver_label','Local Approval Reason') +str2).length;
    return combinedLength > 250;
  },
  toggleViewFun() {
    this.isCommentaryView = !this.isCommentaryView;
    if (this.isCommentaryView) {
      this.toggletableview = 1;
    } else {
      this.toggletableview = 0;
    }
  },
  navigateView(viewKey) {
    // viewKey: 'listru' = 0, 'period' = 1, 'network' = 2, 'dashboard' = 3
    const viewMap = {
      'listru': 0,
      'period': 1,
      'network': 2,
      'dashboard': 3
    };
    if (Object.prototype.hasOwnProperty.call(viewMap, viewKey)) {
      this.toggleview = viewMap[viewKey];
      this.loadContent();
    }
  },
  
  /**
   * Toggle expand/collapse for a navigation item
   * Preserves scroll position to prevent scroll jumping
   * @param {Object} item - The item to expand/collapse
   */
  toggleExpand(item) {
    if (!this.hasChildren(item)) return;
    
    // Capture current scroll position before making changes
    const scrollY = window.scrollY;
    
    let childarray = item.glcode_detail.children;
    let subchild = item.glcode_detail.subsequent_children;
    if (childarray.some(childId => this.expandedIds.has(childId))) {
      this.expandedIds = new Set(
        [...this.expandedIds].filter(id => !subchild.includes(id))
      );
    } else {
      this.expandedIds = new Set([...this.expandedIds, ...childarray]);
    }
    
    // Restore scroll position after Vue updates the DOM
    this.$nextTick(() => {
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    });
  },
  computeMultiRoleUsers() {
    // Reset multiRoleUsers set
    this.multiRoleUsers.clear();
    // If SOD (Segregation of Duties) feature is disabled, exit early
    if (!this.isSodEnabled) return;

    // Gather all role user arrays from your data
    const roleArrays = [
      this.commentaryrudata.submitter,
      this.commentaryrudata.approver,
      this.commentaryrudata.regional_approver,
      this.commentaryrudata.manager
    ];

    // Flatten all user IDs from all roles into a single array
    const allUserIds = roleArrays?.flatMap(roleArray => roleArray || []);

    // Count how many roles each user has
    const userRoleCounts = new Map();
    allUserIds?.forEach(userId => {
      userRoleCounts.set(userId, (userRoleCounts.get(userId) || 0) + 1);
    });

    // Add users with multiple roles (count > 1) to multiRoleUsers set
    userRoleCounts?.forEach((count, userId) => {
      if (count > 1) this.multiRoleUsers.add(userId);
    });
  },
  
  /**
   * Toggle expand/collapse all navigation items
   * Preserves scroll position to prevent scroll jumping
   */
  toggleExpandAll() {
    // Capture current scroll position before making changes
    const scrollY = window.scrollY;
    
    if (this.isAllExpanded) {
      this.expandedIds = new Set();
    } else {
      this.expandedIds = new Set(
        this.filteredcommentarydataRaw()[0].map(item => item.glcode_detail.code)
      );
    }
    this.isAllExpanded = !this.isAllExpanded;
    
    // Restore scroll position after Vue updates the DOM
    this.$nextTick(() => {
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    });
  },
  async generateAIsummery(select, type, apltype) {
    if (this.isThresholdExceedJVSummarisation) {
      this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
      return;
    }
    try {
      if (type === 'One') {
        this.loadingtext1 = true;
      } else {
        this.loadingtext2 = true;
      }
      const cycleId = this.commentarycycledata._id;
      const glcodeId = select.glcode_detail._id;
      const type_of_data = apltype;
      const url = '/v2/ai/generate-commentary-summary';

      const response = await this.axios.post(url, {
        cycle: cycleId,
        type_of_data,
        glcode: glcodeId,
        feature_name: this.summaryStatus?.name,
      });

      // Status check and toast error if failure
      if (response?.data?.status && response.data.status !== 'success') {
        this.$store.commit('sbError', response.data.message || 'AI summary generation failed.');
        return;
      }

      if (response) {
        this.fullText = response.data.message;
        this.isTyping = true;

        if (type === 'One') {
          this.summaryAiProforma = '';
          this.aitext = '';
        } else {
          this.summaryAiForecast = '';
          this.aitext = '';
        }

        this.index = 0;
        this.shouldStop = false;
        this.typeEffectsummary(type);
      } else {
        throw new Error(response.data.message || 'Unknown error');
      }
    } catch (error) {
      this.$store.commit('sbError', error.message || 'Unknown error!');
      console.error('Error:', error);
    } finally {
      this.loadingtext1 = false;
      this.loadingtext2 = false;
    }
  },

  async generateAI(select,type,apltype) {    
    try {
        if (this.isThresholdExceedLocalCommentary) {
          this.$store.commit('sbError', 'Threshold exceeded. Gen AI Commentary is disabled.');
          return;
        }
        if (type === 'One') {
          this.loadingtext1 = true;
        } else {
          this.loadingtext2 = true;
        } 
        const clientId = this.$store.state.client;
        const cycleId = this.commentarycycledata._id;
        const glcodeId = select.glcode_detail._id;
        const type_of_data = apltype;
        const url = '/v2/ai/generate-commentary';

        const response = await this.axios.post(url, {
            cycle: cycleId,
            type_of_data,
            glcode: glcodeId,
            client: clientId,
            feature_name: this.localCommentaryStatus?.name,
        });
        // Status check and toast error if failure
        if (response?.data?.status && response.data.status !== 'success') {
          this.$store.commit('sbError', response.data.message || 'AI summary generation failed.');
          return;
        }
        
        if (response) {
            this.fullText = response?.data?.message?.content || response?.data?.message || '';
            if (!this.fullText || typeof this.fullText !== 'string') {
              throw new Error('Invalid or empty AI message');
            }
            this.isTyping = true;
            if (type === 'One') {
              this.selectedcommentary.commentary1 = "";
              this.aitext = "";
            } else {
              this.selectedcommentary.commentary2 = "";
              this.aitext = "";
            }
            this.index = 0;
            this.shouldStop = false;
            this.typeEffect(type);
        } else {
            throw new Error(response.data.message || "Unknown error");
        }
    } catch (error) {
        this.$store.commit("sbError", error.message || "Unknown error!");
        console.error("Error:", error);
    } finally {
        this.loadingtext1 = false;
        this.loadingtext2 = false;
    }
  },
  typeEffect(type) {
    if (this.shouldStop || this.index >= this.fullText.length) {
      this.isTyping = false;
      return;
    }
    if (type === 'One') {
    this.aitext += this.fullText[this.index];
    this.selectedcommentary.commentary1 += this.fullText[this.index];
    this.index++;
    } else {
    this.aitext += this.fullText[this.index];
    this.selectedcommentary.commentary2 += this.fullText[this.index];
    this.index++;
    }
    this.typingFrame = requestAnimationFrame(() => {
      setTimeout(() => this.typeEffect(type), this.speed);
    });
  },
  shouldHighlightUser(userId){
   return this.multiRoleUsers.has(userId);
  },
  getChipClass(userId) {
    if (!this.shouldHighlightUser(userId)) return '';
    return this.userid === userId
      ? varianceAnalysisConstants.SOD.STYLE.HIGHTLIGHT_SELF
      : varianceAnalysisConstants.SOD.STYLE.HIGHTLIGHT_MULTI_ROLE;
  },
  getIconColor(userId) {
    if (this.shouldHighlightUser(userId)) return varianceAnalysisConstants.SOD.STYLE.RED;
    return this.userid === userId ? varianceAnalysisConstants.SOD.STYLE.WHITE : undefined;
  },

  typeEffectsummary(type){
    if (this.shouldStop || this.index >= this.fullText.length) {
      this.isTyping = false;
      return;
    }
    if (type === 'One') {
    this.aitext += this.fullText[this.index];
    this.summaryAiProforma += this.fullText[this.index];
    this.index++;
    } else {
    this.aitext += this.fullText[this.index];
    this.summaryAiForecast += this.fullText[this.index];
    this.index++;
    }
    this.typingFrame = requestAnimationFrame(() => {
      setTimeout(() => this.typeEffectsummary(type), this.speed);
    });
    
  },
    async generateAIRevenue(select, type, apltype) {
    if (this.isThresholdExceedJVSummarisation) {
      this.$store.commit('sbError', 'Threshold exceeded. Gen AI summarisation is disabled.');
      return;
    }
    try {
      if (type === 'One') {
             this.revenueAILoadingProforma = true;
         } else {
             this.revenueAILoadingForecast = true;
         }
      const cycleId = this.commentarycycledata._id;
      const glcodeId = select.glcode_detail._id;
      const type_of_data = apltype;
      const url = '/v2/ai/generate-commentary-revenue';

      const response = await this.axios.post(url, {
        cycle: cycleId,
        type_of_data,
        glcode: glcodeId,
        feature_name: this.revenueCommentaryStatus?.name,
      });

      // Status check and toast error if failure
      if (response?.data?.status && response.data.status !== 'success') {
        this.$store.commit('sbError', response.data.message || 'AI summary generation failed.');
        return;
      }

      if (response) {
             if (type === 'One') {
                 this.revenueAIProforma = "";
             } else {
                 this.revenueAIForecast = "";
             }
             // Validate response.data.message.content
             const aiContent = response?.data?.message?.content;
             if (typeof aiContent === 'string' && aiContent.trim().length > 0) {
               this.revenueAIResponseText = aiContent;
             } else {
               this.revenueAIResponseText = "";
               this.$store.commit('sbError', 'AI response is empty or invalid.');
               return;
             }
             this.isTyping = true;
             this.index = 0;
             this.shouldStop = false;
             this.typeEffectRevenue(type);
      }
    } catch (error) {
      this.$store.commit('sbError', error.message || 'Unknown error!');
      console.error('Error:', error);
    } finally {
       this.revenueAILoadingProforma = false;
       this.revenueAILoadingForecast = false;
    }
  },
  
  typeEffectRevenue(type) {
   if (this.shouldStop || this.index >= this.revenueAIResponseText.length) {
       this.isTyping = false;
       return;
   }

   if (type === 'One') {
       this.revenueAIProforma += this.revenueAIResponseText[this.index];
   } else {
       this.revenueAIForecast += this.revenueAIResponseText[this.index];
   }
   this.aitext += this.revenueAIResponseText[this.index];
   this.index++;

   this.typingFrame = requestAnimationFrame(() => {
       setTimeout(() => this.typeEffectRevenue(type), this.speed);
   });
},

  /**
   * Handle row intersection for virtual scrolling (legacy support)
   * Now primarily used as fallback - main lazy loading uses scroll events
   * @param {Number} idx - Index of the intersecting row
   */
  handleIntersect(idx) {
    // Only load more when near the end - simplified approach
    if (idx >= (this.endIndex - 3) && this.endIndex < this.visibleItems.length) {
      this.loadMoreRows();
    }
  },

  /**
   * Setup scroll-based lazy loading for the table
   * Call this in mounted() to enable automatic row loading on scroll
   */
  setupLazyLoading() {
    // Debounce flag to prevent rapid firing
    this._lazyLoadDebounce = null;
    this._lazyLoadScrollHandler = this.handleLazyLoadScroll.bind(this);
    
    // Add scroll listener to window (page-level scrolling)
    window.addEventListener('scroll', this._lazyLoadScrollHandler, { passive: true });
    
    // Also try to add to any scrollable container
    this.$nextTick(() => {
      const container = document.querySelector('.v-card__text');
      if (container) {
        container.addEventListener('scroll', this._lazyLoadScrollHandler, { passive: true });
        this._lazyLoadContainer = container;
      }
    });
  },

  /**
   * Cleanup lazy loading listeners
   * Call this in beforeDestroy()
   */
  cleanupLazyLoading() {
    if (this._lazyLoadScrollHandler) {
      window.removeEventListener('scroll', this._lazyLoadScrollHandler);
      if (this._lazyLoadContainer) {
        this._lazyLoadContainer.removeEventListener('scroll', this._lazyLoadScrollHandler);
      }
    }
    if (this._lazyLoadDebounce) {
      clearTimeout(this._lazyLoadDebounce);
    }
  },

  /**
   * Handle scroll events for lazy loading
   * Checks if user has scrolled near the bottom and loads more rows
   */
  handleLazyLoadScroll() {
    // Debounce to prevent rapid firing
    if (this._lazyLoadDebounce) return;
    
    this._lazyLoadDebounce = setTimeout(() => {
      this._lazyLoadDebounce = null;
      
      // Check if we have more items to load
      if (!this.visibleItems || this.endIndex >= this.visibleItems.length) {
        return;
      }
      
      // Calculate scroll position
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Also check container-level scroll if applicable
      const container = this._lazyLoadContainer;
      let isNearBottom = false;
      const bottomThreshold = varianceAnalysisConstants.REPORTING_UNIT.LAZY_LOAD_BOTTOM_THRESHOLD_PX;
      
      if (container && container.scrollHeight > container.clientHeight) {
        // Container-level scrolling
        const containerScrollTop = container.scrollTop;
        const containerHeight = container.clientHeight;
        const containerScrollHeight = container.scrollHeight;
        isNearBottom = containerScrollTop + containerHeight >= containerScrollHeight - bottomThreshold;
      } else {
        // Page-level scrolling
        isNearBottom = scrollTop + windowHeight >= documentHeight - bottomThreshold;
      }
      
      if (isNearBottom) {
        this.loadMoreRows();
      }
    }, varianceAnalysisConstants.REPORTING_UNIT.LAZY_LOAD_DEBOUNCE_MS);
  },

  /**
   * Load more rows at the bottom (simple append, no scroll adjustment needed)
   * This is a simplified version that just extends endIndex without moving startIndex
   */
  loadMoreRows() {
    // Prevent loading if already at the end
    if (!this.visibleItems || this.endIndex >= this.visibleItems.length) {
      return;
    }
    
    // Simple: just extend endIndex by incrementBy (default 20-25 rows)
    const newEndIndex = Math.min(
      this.endIndex + this.incrementBy,
      this.visibleItems.length
    );
    
    // Only update if there's actually more to load
    if (newEndIndex > this.endIndex) {
      this.endIndex = newEndIndex;
      // Keep startIndex at 0 to preserve all loaded rows (no removal from top)
      // This prevents choppy behavior when scrolling
    }
  },

  /**
   * Legacy loadBelow - now just calls loadMoreRows for backward compatibility
   */
  loadBelow() {
    this.loadMoreRows();
  },

  /**
   * Legacy loadAbove - disabled since we now keep all rows from the start
   * Keeping startIndex at 0 means we don't need to load above
   */
  loadAbove() {
    // No-op: We keep all rows from the beginning now
    // This prevents choppy scrolling when scrolling up
  },

  /**
   * Find the scrollable container for the table (kept for other uses)
   * @returns {Element|Window} The scrollable container
   */
  getScrollContainer() {
    // Try v-data-table__wrapper first (Vuetify table wrapper)
    let container = document.querySelector(".v-data-table__wrapper");
    if (container && container.scrollHeight > container.clientHeight) {
      return container;
    }
    // Try v-card__text as it's a common parent container
    container = document.querySelector(".v-card__text");
    if (container && container.scrollHeight > container.clientHeight) {
      return container;
    }
    // Fall back to window/document scrolling
    return document.documentElement || document.body;
  },
  hasChildren(item) {
    const childArray = item?.glcode_detail?.children;
    return item?.glcode_detail?.children?.length && childArray.some(childId => (this.filteredcommentarydata.some(c => c.glcode_detail.code === childId)));
  },
  isExpanded(item) {
      let childarray = item.glcode_detail.children;
      return childarray.some(childId => this.expandedIds.has(childId));
  },
  resetPage() {
    this.page = 1;
  },
  setPageCount(d) {
    this.pagecount = d;
  },
  openSubmitDialog(dt, type, /* editmode param kept for backward compatibility */) {
    this.bulksubmit = false;
    this.commentarytype = type;
    this.commentarySubmitDialogueViewMode = false;
    this.replaceExistingCommentFlag = false;
    this.selectedcommentary = { ...dt };
    this.selectedcommentary.__submittedCommentary1 = dt.commentary1;
    this.selectedcommentary.__submittedCommentary2 = dt.commentary2;
    this.selectedcommentary.__submittedRegionalCommentary1 = dt.regionalcommentary1;
    this.selectedcommentary.__submittedRegionalCommentary2 = dt.regionalcommentary2;
    this.readActivityLog(dt._id);
    
    // Determine editmode based on type - only 'view' mode should be non-editable
    // The editmode parameter from RUDataTable passes 'approver' flag which shouldn't affect edit mode
    const isViewMode = type === varianceAnalysisConstants.ACTIONS.VIEW;
    const effectiveEditMode = isViewMode ? false : true;
    
    // collapse local commentary section while adding/viewing/approving regional commentary
    if (type === varianceAnalysisConstants.ACTIONS.ADD_REGIONAL_COMMENTARY || 
        type === varianceAnalysisConstants.ACTIONS.APPROVE_REGIONAL ||
        this.isregionalapprover) {
      this.isLocalCommentaryCollapsed = true; // Collapse by default for regional actions
      this.isLocalCommentaryReasonCollapsed = true;
    } else {
      this.isLocalCommentaryCollapsed = false; // Expand by default for local actions
      this.isLocalCommentaryReasonCollapsed = false;
    }
    if (type === varianceAnalysisConstants.ACTIONS.ADD_LOCAL_COMMENTARY || type === varianceAnalysisConstants.ACTIONS.ADD_REGIONAL_COMMENTARY || type === varianceAnalysisConstants.ACTIONS.VIEW) {
      this.getTrend(dt.glcode);
      this.commantorydialog = true;
      // NOTE: DO NOT convert jv_commentary1/2 to strings here - keep as objects for validation
      // Formatting happens in handleAddLocalCommentaryDataSetup / handleAddRegionalCommentaryDataSetup

      // If workflows are disabled, show JV commentary in both fields 
      if (!this.workflows.isworkflowsenabled) {
        this.selectedcommentary.commentary1 = this.formatJvCommentary(this.selectedcommentary.jv_commentary1) || "";
        this.selectedcommentary.commentary2 = this.formatJvCommentary(this.selectedcommentary.jv_commentary2) || "";
      }
      // Local commentary handling
      if (type === varianceAnalysisConstants.ACTIONS.ADD_LOCAL_COMMENTARY) {
       this.handleAddLocalCommentaryDataSetup(dt);
      }

      // Regional commentary handling
      if (type === varianceAnalysisConstants.ACTIONS.ADD_REGIONAL_COMMENTARY) {
        this.handleAddRegionalCommentaryDataSetup(dt);
      }
      // Set summary fields and request flags
      this.summaryAiProforma = this.selectedcommentary.summarycommentary1 || "";
      this.summaryAiForecast = this.selectedcommentary.summarycommentary2 || "";
      this.requestcommentarylocalcontrolvsProforma = this.selectedcommentary?.saved_var1_cross_control || false;
      this.requestcommentarylocalmanagementvsProforma = this.selectedcommentary?.saved_var2_cross_control || false;
      this.requestcommentaryregionalcontrolvsProforma = false;
      this.requestcommentaryregionalmanagementvsProforma = false;
      this.requestcommentarylocalcontrolvsForecast = this.selectedcommentary?.saved_var1_cross_management || false;
      this.requestcommentarylocalmanagementvsForecast = this.selectedcommentary?.saved_var2_cross_management || false;
      this.requestcommentaryregionalcontrolvsForecast = false;
      this.requestcommentaryregionalmanagementvsForecast = false;
    } else if (type === varianceAnalysisConstants.ACTIONS.APPROVE_LOCAL || type === varianceAnalysisConstants.ACTIONS.APPROVE_REGIONAL || type === varianceAnalysisConstants.ACTIONS.VIEW) {
      this.getTrend(dt.glcode);
      this.commantorydialog = true;
      if (type === varianceAnalysisConstants.ACTIONS.APPROVE_REGIONAL) {
        // if(!this.selectedcommentary.regionalcommentary1) this.selectedcommentary.regionalcommentary1 = this.selectedcommentary.commentary1;
        // if(!this.selectedcommentary.regionalcommentary2) this.selectedcommentary.regionalcommentary2 = this.selectedcommentary.commentary2;
      }
    } else if (type === varianceAnalysisConstants.ACTIONS.REQUEST_LOCAL || type === varianceAnalysisConstants.ACTIONS.REQUEST_REGIONAL) {
      this.requestcommentarydialog = true;
      //old workflows code 
      this.requestcommentarylocalcontrol = false;
      this.requestcommentarylocalmanagement = false;
      this.requestcommentaryregionalcontrol = false;
      this.requestcommentaryregionalmanagement = false;
      //new workflows code 
      this.requestcommentarylocalcontrolvsProforma = false;
      this.requestcommentarylocalmanagementvsProforma = false;
      this.requestcommentaryregionalcontrolvsProforma = false;
      this.requestcommentaryregionalmanagementvsProforma = false;
      this.requestcommentarylocalcontrolvsForecast = false;
      this.requestcommentarylocalmanagementvsForecast = false;
      this.requestcommentaryregionalcontrolvsForecast = false;
      this.requestcommentaryregionalmanagementvsForecast = false;
    }
    if (!effectiveEditMode) {
      // View mode: format JV for display in commentary fields
      if (dt.stage_local === 0) {
        this.selectedcommentary.commentary1 = this.formatJvCommentary(this.selectedcommentary.jv_commentary1) || this.selectedcommentary.savedcommentary1 || this.selectedcommentary.commentary1 || "";
        this.selectedcommentary.commentary2 = this.formatJvCommentary(this.selectedcommentary.jv_commentary2) || this.selectedcommentary.savedcommentary2 || this.selectedcommentary.commentary2 || "";
      }
      this.commentarySubmitDialogueViewMode = true
    }
  },
  toggleLocalCommentaryCollapse() {
    this.isLocalCommentaryCollapsed = !this.isLocalCommentaryCollapsed;
  },
  toggleLocalCommentaryReasonCollapse() {
    this.isLocalCommentaryReasonCollapsed = !this.isLocalCommentaryReasonCollapsed;
  },
  formatJvCommentary(jvCommentary) {
    if (typeof jvCommentary === 'object' && jvCommentary !== null) {
      return Object.entries(jvCommentary)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n');
    }
    return jvCommentary || '';
  },
  handleAddLocalCommentaryDataSetup: function (selectedData) {
    try {
      // If local workflow is enabled and stage is valid for JV pre-population, show JV commentary in local box
      // Valid stages: 0 (Awaiting), 3 (Nil Value), 4 (Immaterial Variance), 5 (Not In Scope)
      const validStagesForLocalJV = [
        varianceAnalysisConstants.STAGES.COMMENTARY_AWAITING,
        varianceAnalysisConstants.STAGES.COMMENTARY_NIL_VALUE,
        varianceAnalysisConstants.STAGES.IMMATERIAL_VARIANCE,
        varianceAnalysisConstants.STAGES.COMMENTARY_NOT_IN_SCOPE
      ];
      if (this.workflows.islocalenabled && validStagesForLocalJV.includes(selectedData.stage_local) && this.selectedcommentary.jv_commentary1) {
        this.selectedcommentary.commentary1 = this.formatJvCommentary(this.selectedcommentary.jv_commentary1);
        this.selectedcommentary.commentary2 = this.formatJvCommentary(this.selectedcommentary.jv_commentary2);
      } else {
        // Otherwise, show saved or existing local commentary
        this.selectedcommentary.commentary1 = this.selectedcommentary.savedcommentary1 || this.selectedcommentary.commentary1 || "";
        this.selectedcommentary.commentary2 = this.selectedcommentary.savedcommentary2 || this.selectedcommentary.commentary2 || "";
      }
      // If local workflow is disabled, clear commentary fields (unless both are disabled)
      if (!this.workflows.islocalproformaenabled && (this.workflows.islocalenabled || this.workflows.isregionalenabled)) {
        this.selectedcommentary.commentary1 = '';
      }
      if (!this.workflows.islocalforecastenabled && (this.workflows.islocalenabled || this.workflows.isregionalenabled)) {
        this.selectedcommentary.commentary2 = '';
      }

    } catch (error) {
      console.error("Error in handleAddLocalCommentaryDataSetup: ", error);
      this.$store.commit("sbError", error?.message || error || "Unknown error!");
    }
  },
  handleAddRegionalCommentaryDataSetup:function(selectedData){
    try {
     let approvalstr = this.selectedcommentary.approvereason || "";
     const stageRegional = selectedData?.stage_regional ?? this.selectedcommentary.stage_regional ?? 0;

        // If local workflow is disabled, regional enabled, and JV commentary exists, show JV commentary in regional box
        // Valid stages: 0 (Awaiting), 3 (Nil Value), 4 (Immaterial Variance), 5 (Not In Scope)
        const validStagesForRegionalJV = [
          varianceAnalysisConstants.STAGES.COMMENTARY_AWAITING,
          varianceAnalysisConstants.STAGES.COMMENTARY_NIL_VALUE,
          varianceAnalysisConstants.STAGES.IMMATERIAL_VARIANCE,
          varianceAnalysisConstants.STAGES.COMMENTARY_NOT_IN_SCOPE
        ];
        if (!this.workflows.islocalenabled && this.workflows.isregionalenabled && validStagesForRegionalJV.includes(stageRegional)) {
          if (this.selectedcommentary.jv_commentary1) {
            this.selectedcommentary.regionalcommentary1 = this.formatJvCommentary(this.selectedcommentary.jv_commentary1);
          } 
          if (this.selectedcommentary.jv_commentary2) {
            this.selectedcommentary.regionalcommentary2 = this.formatJvCommentary(this.selectedcommentary.jv_commentary2);
          }
        } else {
          // Otherwise, append local commentary and approval reason as before
          if (!this.selectedcommentary.regionalcommentary1 || stageRegional === 0) {
            if (this.selectedcommentary.commentary1 && this.workflows.isregionalproformaenabled)
              this.selectedcommentary.regionalcommentary1 = this.selectedcommentary.commentary1 + ". " + approvalstr;
            else if (this.workflows.isregionalproformaenabled)
              this.selectedcommentary.regionalcommentary1 = approvalstr;
            else
              this.selectedcommentary.regionalcommentary1 = '';
          }
          if (!this.selectedcommentary.regionalcommentary2 || stageRegional === 0) {
            if (this.selectedcommentary.commentary2 && this.workflows.isregionalforecastenabled)
              this.selectedcommentary.regionalcommentary2 = this.selectedcommentary.commentary2 + ". " + approvalstr;
            else if (this.workflows.isregionalforecastenabled)
              this.selectedcommentary.regionalcommentary2 = approvalstr;
            else
              this.selectedcommentary.regionalcommentary2 = '';
          }
          if (!this.workflows.isregionalproformaenabled) {
            this.selectedcommentary.regionalcommentary1 = '';
          }
          if (!this.workflows.isregionalforecastenabled) {
            this.selectedcommentary.regionalcommentary2 = '';
          }
          // Special case for commentary2 with no threshold crossed
          if (this.selectedcommentary.commentary2 &&
              !this.selectedcommentary.var2_cross_control &&
              !this.selectedcommentary.var2_cross_management &&
              !this.selectedcommentary.var2_cross_management_regional &&
              !this.selectedcommentary.var2_cross_control_regional
            ) {
              this.selectedcommentary.regionalcommentary2 = this.selectedcommentary.commentary2;
              if (
                typeof this.selectedcommentary.approvereason === 'string' &&
                this.selectedcommentary.approvereason?.trim() !== ''
              ) {
                this.selectedcommentary.regionalcommentary2 += '  ' + this.selectedcommentary.approvereason;
              }
          }
        }
    } catch (error) {
      console.error("Error in handleAddRegionalCommentaryDataSetup: ", error);
      this.$store.commit("sbError", error?.message || error || "Unknown error!");
    }
  },
  uploadAttachmentFile(id) {
    if (this.attachmentfileloading === false) {
      this.attachmentfileloading = true;
      this.commentaryloading = true;
      this.attachmentfilepercentage = 0;
      let file = this.attachmentfile || {};
      let fileUpDetil = {};
      this.$nova.uploadFile(this.axios, file, {
        progressfunction: (e) => {
          let p = (e.loaded * 100) / e.total;
          this.attachmentfilepercentage = Math.round(p);
          // console.log(this.attachmentfilepercentage);
        },
      })
        .then((dt) => {
          if (dt.data.status === "success") {
            fileUpDetil = dt.data.data[0];
            // Build filter with optional reporting_type for Balance Sheet
            const attachFilter = { cycletype: this.cycletype };
            if (this.reportingType) {
              attachFilter.reporting_type = this.reportingType;
            }
            return this.axios.post("/v3/varianceanalysis/analysis/attachfile/" + id, { data: { upload: fileUpDetil._id }, filter: attachFilter });
          } else throw new Error("Unable to upload file");
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.selectedcommentary.upload = fileUpDetil._id;
            this.commentarydata[this.selectedcommentary.__key].upload = fileUpDetil._id;
            this.commentarydatajson[this.selectedcommentary.glcode].upload = fileUpDetil._id;
            // console.log(this.selectedcommentary);
            this.commantorydialog = false;
            this.$store.commit("sbSuccess", "File Uploaded");
          } else throw new Error(dt.data.message || "Error storing file");
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
        })
        .finally(() => {
          this.attachmentfile = null;
          this.attachmentfileloading = false;
          this.commentaryloading = false;
          this.commantorydialog = true;
        });
    }
  },
  resolveMultiselectCommentaryItem(id) {
    if (id == null) {
      return null;
    }
    if (this.commentarydatajsonById && this.commentarydatajsonById[id]) {
      return this.commentarydatajsonById[id];
    }
    const idStr = String(id);
    if (this.commentarydatajsonById) {
      const matchKey = Object.keys(this.commentarydatajsonById).find((key) => String(key) === idStr);
      if (matchKey) {
        return this.commentarydatajsonById[matchKey];
      }
    }
    return (this.commentarydata || []).find((item) => item && String(item._id) === idStr) || null;
  },

  getAggregatedMultiselectThresholdFlags() {
    const flags = {
      var1_cross_control: false,
      var1_cross_management: false,
      var2_cross_control: false,
      var2_cross_management: false,
      var1_cross_control_regional: false,
      var1_cross_management_regional: false,
      var2_cross_control_regional: false,
      var2_cross_management_regional: false,
    };
    (this.multiselectdata || []).forEach((id) => {
      const item = this.resolveMultiselectCommentaryItem(id);
      if (!item) {
        return;
      }
      flags.var1_cross_control = flags.var1_cross_control || Boolean(item.var1_cross_control);
      flags.var1_cross_management = flags.var1_cross_management || Boolean(item.var1_cross_management);
      flags.var2_cross_control = flags.var2_cross_control || Boolean(item.var2_cross_control);
      flags.var2_cross_management = flags.var2_cross_management || Boolean(item.var2_cross_management);
      flags.var1_cross_control_regional = flags.var1_cross_control_regional || Boolean(item.var1_cross_control_regional);
      flags.var1_cross_management_regional = flags.var1_cross_management_regional || Boolean(item.var1_cross_management_regional);
      flags.var2_cross_control_regional = flags.var2_cross_control_regional || Boolean(item.var2_cross_control_regional);
      flags.var2_cross_management_regional = flags.var2_cross_management_regional || Boolean(item.var2_cross_management_regional);
    });
    return flags;
  },

  performBulkTask(dt, type) {
    if (type === 'request') {
      // Allow request commentary if:
      // - Local approver with local workflow enabled, OR
      // - Regional approver with regional workflow enabled
      // Note: Button visibility uses ispendinglocalruapproval but action should check workflow enabled status
      const canLocalApproverRequest = this.isapprover && this.workflows.islocalenabled;
      const canRegionalApproverRequest = this.isregionalapprover && this.workflows.isregionalenabled;
      
      if (canLocalApproverRequest || canRegionalApproverRequest) {
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.selectedcommentary = dt;
        this.bulksubmit = true;
        this.bulktype = type;
        this.requestcommentarydialog = true;
        return; // Early return to prevent bulksubmit being set again below
      }
    }
    else if (type === 'addlocal') {
      if (this.ispreparer && this.workflows.islocalenabled) {
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.bulkcommentall = false;
        this.bulkcommentreplace = false;
        this.isGlMandatoryRequestFlag = false;
        this.replaceExistingCommentFlag = false;
        
        // OR threshold flags across selection so Mandatory/Optional matches any raised flag.
        const aggregatedFlags = this.getAggregatedMultiselectThresholdFlags();
        const firstId = this.multiselectdata && this.multiselectdata.length > 0 ? this.multiselectdata[0] : null;
        if (firstId) {
          const firstItem = this.resolveMultiselectCommentaryItem(firstId);
          if (firstItem) {
             this.selectedcommentary = {
               ...firstItem,
               ...aggregatedFlags,
               stage: firstItem.stage !== undefined ? firstItem.stage : firstItem.__stage,
               commentary1: '',
               commentary2: '',
               regionalcommentary1: '',
               regionalcommentary2: '',
             };
          } else {
             this.selectedcommentary = { ...aggregatedFlags };
          }
        } else {
          this.selectedcommentary = {};
        }

        // Check if ALL selected items are non-mandatory (stages 3, 4) - only then show the voluntary checkbox
        const allNonMandatory = this.multiselectdata.every((id) => {
          let glItem = this.resolveMultiselectCommentaryItem(id);
          return glItem && [3, 4].indexOf(glItem.__stage) > -1;
        });
        this.isGlMandatoryRequestFlag = allNonMandatory;

        for (let id of this.multiselectdata) {
          let glItem = this.resolveMultiselectCommentaryItem(id);
          if (glItem && ((glItem.commentary1 && String(glItem.commentary1).trim() !== '') || (glItem.commentary2 && String(glItem.commentary2).trim() !== '') || (glItem.regionalcommentary1 && String(glItem.regionalcommentary1).trim() !== '') || (glItem.regionalcommentary2 && String(glItem.regionalcommentary2).trim() !== ''))) {
            this.replaceExistingCommentFlag = true;
          }
        }
        this.commantorydialog = true;
      }
    }
    else if (type === 'approvelocal') {
      if(this.isRegionalCommentaryAutomationEnabled){
        const allSelectedCommentariesReadyApproval = this.multiselectdata?.every((id) => {
          let glItem = this.resolveMultiselectCommentaryItem(id);
          return glItem?.stage_local === 1; 
        }) ?? false;
        if(!allSelectedCommentariesReadyApproval){
          this.showErrorMessageDialog = true;
          this.errorMessageDialogContent = varianceAnalysisConstants.MESSAGES.SELECT_VALID_GLS
          this.bulksubmit = false;
          return;
        }
      }
      if (this.workflows.islocalenabled) {
        this.commantorydialog = true;
        this.selectedcommentary = {};
      }
    }
    else if (type === 'addregional') {
      if (this.workflows.isregionalenabled) {
        this.requestcommentarylocalcontrolvsProforma = false;
        this.requestcommentarylocalmanagementvsProforma = false;
        this.requestcommentaryregionalcontrolvsProforma = false;
        this.requestcommentaryregionalmanagementvsProforma = false;
        this.requestcommentarylocalcontrolvsForecast = false;
        this.requestcommentarylocalmanagementvsForecast = false;
        this.requestcommentaryregionalcontrolvsForecast = false;
        this.requestcommentaryregionalmanagementvsForecast = false;
        this.bulkcommentall = false;
        this.bulkcommentreplace = false;
        const aggregatedFlags = this.getAggregatedMultiselectThresholdFlags();
        const firstItem = this.multiselectdata?.length
          ? this.resolveMultiselectCommentaryItem(this.multiselectdata[0])
          : null;
        this.selectedcommentary = firstItem
          ? {
              ...firstItem,
              ...aggregatedFlags,
              commentary1: '',
              commentary2: '',
              regionalcommentary1: '',
              regionalcommentary2: '',
            }
          : { ...aggregatedFlags };
        this.commantorydialog = true;
      }
    }
    else if (type === 'approveregional') {
      if (this.workflows.isregionalenabled) {
        this.commantorydialog = true;
        this.selectedcommentary = {};
      }
    }
    this.bulksubmit = true;
    this.bulktype = type;
    this.commentarySubmitDialogueViewMode = false
  },
  setFilter(k, value) {
    if (this.$refs.childfilter) {
        this.$refs.childfilter.setValue(k, value);
    }
  },
  listenfilter(data) {
    // this.setReportingUnit()
    if (data.key === "selectedrole") this.changeRole(data.value);
    else if (Object.prototype.hasOwnProperty.call(this, data.key)) {
      this[data.key] = data.value;

      // Sync the change to reportingUnitFilter and Vuex Store instantly
      // This ensures that when navigating back, we restore the *latest* selected filter, not the old initial state.
      if (!this.reportingUnitFilter) this.reportingUnitFilter = {};

      // EXCEPTION: When inside RU detail view (isReportingUnitClicked is true),
      // we do NOT want to overwrite the saved hierarchy filters (network/region/country)
      // with the specific values from the selected RU. 
      // We want to keep them as 'all' (or whatever they were before clicking the row)
      // so that navigating BACK restores the correct list view state.
      const isHierarchyKey = ['selectednetwork', 'selectedregion', 'selectedcountry', 'selectedreportingunit'].includes(data.key);
      const shouldUpdateStoredFilter = !(this.isReportingUnitClicked && isHierarchyKey);

      if (shouldUpdateStoredFilter) {
        this.$set(this.reportingUnitFilter, data.key, data.value);

        const isActual = (this.cycletype === 'actual' || this.cycletype === 'Actual');
        const mutation = isActual ? "setActualFilters" : "setForecastFilters";
        const appName = this.appname || 'varianceanalysis'; // Fallback if appname is missing
        
        this.$store.commit(`${appName}/${mutation}`, this.reportingUnitFilter);
      }
    }
    // Always load content when reload is explicitly set (true or false)
    // reload=true forces fresh data, reload=false uses cache if available
    if (data.reload !== undefined) {
      // Debounce loadContent calls to prevent rapid Apply clicks from triggering multiple API calls
      if (this._listenfilterDebounce) {
        clearTimeout(this._listenfilterDebounce);
      }
      
      // Fix: Set loading state immediately for better UX to avoid "No Data" state flicker
      if (data.reload) {
        this.isReportingUnitdataloading = true;
        // Do NOT set this.loading = true here, as it blocks loadContent guard check
      }

      this._listenfilterDebounce = setTimeout(() => {
        this._listenfilterDebounce = null;
        this.loadContent(data.reload);
      }, 100);
    }
  },
  changeRole(t) {
    this.selectedrole = t;
    localStorage.setItem("commentary_role", this.selectedrole);
  },
  toggleSubCategory(d) {
    if (this.parentgls.indexOf(d) > -1) {
      let index = this.expandedsubcategory.indexOf(d);
      // console.log(index);
      if (index === -1) this.expandedsubcategory.push(d);
      else this.expandedsubcategory.splice(index, 1);
    }
  },
  confirmSendEmailReminder() {
    // Handle both reporting units mode and cycles mode
    if (this.emailReminderMode === 'cycles') {
      this.executeSendEmailReminderForCycles();
    } else {
      this.sendEmailReminderForSelectedCycle(this.reportingUnitsForMailReminder);
    }
    this.confirmEmailReminderDialog = false;
    if (this.$refs.ruList) {
      this.$refs.ruList.selectedReportingUnits = [];
    }
    this.reportingUnitsForMailReminder = [];
    this.emailReminderMode = 'reportingUnits'; // Reset to default
  },
  cancelEmailReminder() {
    this.confirmEmailReminderDialog = false;
    this.emailReminderMode = 'reportingUnits'; // Reset to default
  },
  showEmailReminderConfirm() {
    if (this.reportingUnitsForMailReminder.length > 0) {
      this.confirmEmailReminderDialog = true;
    } else {
      this.$store.commit("sbError", "No reporting units selected for email reminder");
    }
  },
  refreshData() {
    //this.$store.state={'actualcycle':{"reportingUnitsList":[],"networkList":[],'regionList':[],'countryList':[]}}
    this.selectedrole = localStorage.getItem("commentary_role");
    if (localStorage.getItem("commentary_custom_filter")) {
      this.customfilter = (localStorage.getItem("commentary_custom_filter") || null).split(",") || [];
    } else {
      this.customfilter = []
    }
    this.customfilterstoggle = localStorage.getItem("commentary_custom_filter_toggle") === "true" ? true : false;
    if (Object.keys(this.rolelist).indexOf(this.selectedrole) === -1) this.changeRole("submitter");
    this.userid = this.$store.state.user.id;
    this.multiselectdata = [];
    this.ispreparer = false;
    this.isapprover = false;
    this.isregionalapprover = false;
    this.bulksubmit = false;
    this.ismanager = false;
    this.isviewonly = false;
    // Create a copy to avoid mutating the original constant array
    if (this.cycletype === "Actual") this.bulksubmitcolumns = [...this.$constants.BULK_FILE_TEMPLATES.BULK_SUBMIT_COLUMNS_ACTUAL];
    else if (this.cycletype === "Forecast") this.bulksubmitcolumns = [...this.$constants.BULK_FILE_TEMPLATES.BULK_SUBMIT_COLUMNS_FORECAST];
    this.lastActionsOnGL = { 'localaction': { type: 'none' }, 'regionalaction': { type: 'none' } }
  },
  loadContent(reload = false, sync = false, synctype = 'automatic') {
    // Allow if not loading OR if it's a forced reload (which might have pre-set loading to true)
    if (!this.loading || reload) {

      // Clear table filters on full reload
      if (reload) {
        this.tableApiFilters = {};
      }

      this.loading = true
      this.resetPage();
      this.multiselectdata = [];
      this.isFilteredData = true
      this.pagination_page = 0
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Month is zero-based, so add 1
      const day = currentDate.getDate();
      let hours = currentDate.getHours();
      const minutes = currentDate.getMinutes();
      const amPM = hours >= 12 ? 'PM' : 'AM';
      const presentTime = `${day}-${month}-${year} ${hours}:${minutes} ${amPM}`;
      //if(this.selectedperiod === "all") return this.loadPeriod();
      this.saveFilterStatus();
      if (this.toggleview === 0 && this.selectedreportingunit === "all" && this.selectedperiod !== 'all') return this.loadReportingUnit(reload, false);
      else if (this.toggleview === 3 && this.selectedreportingunit === "all") return this.loadMultipleReportingUnit();
      else if (this.selectedperiod === 'all') { this.toggleview = 1; return this.loadPeriod(reload, sync, synctype) }
      else if (this.selectedreportingunit && this.selectedreportingunit !== 'all') return this.loadData(reload);
      else if (this.selectednetwork === "all") return this.loadNetwork(reload, sync, synctype);
      else if (this.selectedregion === "all") return this.loadRegion(reload, presentTime);
      else if (this.selectedcountry === "all") return this.loadCountry(reload, presentTime);
      this.isFilteredData = true
      this.loading = false
    } else {
      console.log('[loadContent] Guard BLOCKED - loading was already true');
    }
  },
  approveLocalRU() {
    this.ruapprovaltype = "local";
    //Don't change allignment for this text
    this.rulevelapprovenote = `Based on my review, I confirm that I have documented and I am satisfied that:\n \nAll explanations of variances above control thresholds are in line with my knowledge, understanding, consideration of contradictory evidence and follow-up procedures as needed; Variances below control thresholds are in line with my expectations. Have retained sufficient evidence to support my conclusions.`;
    this.ruapprovaldialog = true;
  },
  approveRegionalRU() {
    this.ruapprovaltype = "regional";
    //Don't change allignment for this text
    this.rulevelapprovenote = `Based on my review, I confirm that I have documented and I am satisfied that:\n \n
  All explanations of variances above control thresholds are in line with my knowledge, understanding, consideration of contradictory evidence and follow-up procedures as needed; Variances below control thresholds are in line with my expectations. Have retained sufficient evidence to support my conclusions.`
    this.ruapprovaldialog = true;
  },
  approveRU() {
    this.ruapprovalloading = true;
    let url = "/v3/varianceanalysis/analysis/rulevelapproval/";
    let d = [];
    if (this.ruapprovaltype === "local") d = this.selectedlocalapproval;
    else if (this.ruapprovaltype === "regional") d = this.selectedregionalapproval;
    // Build filter with optional reporting_type for Balance Sheet
    const ruApprovalFilter = { type: this.ruapprovaltype, cycleids: d, cycletype: this.cycletype };
    if (this.reportingType) {
      ruApprovalFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { filter: ruApprovalFilter, data: { approvalcomment: this.rulevelapprovenote } }).then(dt => {
      if (dt.data.status === "success") {
        this.selectedlocalapproval = [];
        this.selectedregionalapproval = [];
        this.loadContent(true);
        this.$store.commit("sbSuccess", "RU level approval done");
      }
      else throw new Error(dt.data.message || "Error loading download list");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.ruapprovaldialog = false;
      this.ruapprovalloading = false;
    });
  },
  clearMultiselectData() {
    this.multiselectdata = [];
  },
  readBulkSubmit() {
    let file = this.bulksubmitfiledatafile; 
    this.bulksubmitfiledataList = [];
    if ((file || {}).name && !this.bulksubmitloading) {
      this.bulksubmitfiledataerror = false;
      this.bulksubmitloading = true;
      let commentary1Index = 11;
      let commentary2Index = 20;
      let ext = ((file || {}).name || "").split(".").pop();
      Promise.resolve().then(() => {
        if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new Error("Only xlsx,xls,xlsm,xlsb file extension supported");
        return this.$nova.readExcelFile(file, "TOP SHEET");
      }).then(dt => {
        // Determine expected columns dynamically based on reportingType, mirroring downloadExcel logic
        const { ACTUAL } = varianceAnalysisConstants.CYCLE_TYPES;
        const bulkTemplates = this.$constants.BULK_FILE_TEMPLATES;
        
        let columnTemplate = [];
        if (this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL_BS 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST_BS;
        } else {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST;
        }

        const excelColumns = [...columnTemplate].map((label) => {
            if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
               // Special handling for Balance Sheet headers that might be renamed
               // We should check if the uploaded headers contain the new names OR the original names
               // But here we are building the "Expected" columns
               
               // If existing labelsName customization returns distinct value use it
               let customLabel = "";
               if(label === AMOUNT_TYPES.ACTUAL_AMOUNT) {
                 customLabel = this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual');
                 // Only append " Amount" if the label doesn't already end with it to avoid duplication if user configured label is "Actual Amount"
                 if (!customLabel.endsWith("Amount")) customLabel += " Amount";
                 return customLabel;
               } 
               if(label === AMOUNT_TYPES.PROFORMA_AMOUNT) {
                 customLabel = this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma');
                 if (!customLabel.endsWith("Amount")) customLabel += " Amount";
                 return customLabel;
               }
               if(label === AMOUNT_TYPES.FORECAST_AMOUNT) {
                 customLabel = this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast');
                 if (!customLabel.endsWith("Amount")) customLabel += " Amount";
                 return customLabel;
               }
               
               return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
            } else {
               return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
            }
        });

        // let excelColumns = [...this.bulksubmitcolumns]; // Previous static reference
        excelColumns.splice(-2, 2);
        const expectedColumns = ["", ...excelColumns];
        
        // Find header row dynamically
        let headerRowIndex = -1;
        const glCodeLabel = this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, "GL Code");
        
        // Search first 10 rows for header
        for(let rowIndex = 0; rowIndex < Math.min(dt.length, 10); rowIndex++) {
            if(dt[rowIndex] && (dt[rowIndex][1] === glCodeLabel || dt[rowIndex][1] === "GL Code")) {
                headerRowIndex = rowIndex;
                break;
            }
        }
        
        // Fallback to index 4 if not found (legacy behavior) or if found at 4
        const uploadedColumns = headerRowIndex !== -1 ? dt[headerRowIndex] : (dt[4] || []);
        
        // Validate headers using common function
        validateExcelHeaders(uploadedColumns, expectedColumns);
        
        // If validation passes, continue with processing
        let gllist = [];
        let uploaddata = {};
        let finaldata = {};
          let haserror = false;
          for (let i = headerRowIndex + 1; i < dt.length; i++) {
            if (i > headerRowIndex) {
              const el = dt[i];
              let glcode = (el[1] || "").toString();
              let ndt = el;
              gllist.push(glcode);
              uploaddata[glcode] = ndt;
            }
          }
          for (let i = 0; i < this.commentarydata.length; i++) {
            const el = this.commentarydata[i];
            let glcode = (el.glcode || "").toString();
            let code = (el.glcode_detail?.code || "").toString();
            if (gllist.indexOf(code) > -1) {
              finaldata[code] = {}
              if (uploaddata[code][commentary1Index] !== "null" && uploaddata[code][commentary1Index] !== "undefined") {
                finaldata[code].commentary1 = uploaddata[code][commentary1Index];
              }
              if (uploaddata[code][commentary2Index] !== "null" && uploaddata[code][commentary2Index] !== "undefined") {

                finaldata[code].commentary2 = uploaddata[code][commentary2Index];
              }
              finaldata[code].ignore = false;
              finaldata[code].message = "";
              let isValid = true;
              let isCommentary1Required = false;
              let isCommentary2Required = false;
              if (!(this.workflows.lcp || this.workflows.lmp)) {
                delete finaldata[code].commentary1
              }
              if (!(this.workflows.lcf || this.workflows.lmf)) {
                delete finaldata[code].commentary2
              }
              if ((this.ispreparer && (this.workflows.lcp || this.workflows.lmp) && (el.var1_cross_control || el.var1_cross_management || el.var1_cross_control_regional || el.var1_cross_management_regional))) {
                if (!finaldata[code].commentary1) {
                  finaldata[code].message = "Commentary1 required.";
                  isCommentary1Required = true;
                  finaldata[code].ignore = true;
                }
                else if (String(finaldata[code].commentary1).trim().length < 15) {
                  isCommentary1Required = true
                  finaldata[code].message = "Commentary1 minimum 15 characters required.";
                  finaldata[code].ignore = true;
                }
              }
              if ((this.ispreparer && (this.workflows.lcf || this.workflows.lmf) && (el.var2_cross_control || el.var2_cross_management)) || (this.isapprover && (this.workflows.rcf || this.workflows.rmf) && (el.var2_cross_control_regional || el.var2_cross_management_regional))) {
                if (!finaldata[code].commentary2) {
                  finaldata[code].message += "Commentary2 required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                } else if (String(finaldata[code].commentary2).trim().length < 15) {
                  finaldata[code].message += "Commentary2 minimum 15 characters required.";
                  finaldata[code].ignore = true;
                  isCommentary2Required = true
                }
              }
              if (!isCommentary1Required && !isCommentary2Required) {
                finaldata[code].ignore = false;
                finaldata[code].message = "Ready to upload";
              }
              if (el.stage_local === 2) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because local approve completed";
              } else if (el.stage_local === 3) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because variance is immaterial";
                isValid = false;
              } else if (el.stage_local === 4) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because no variance";
                isValid = false;
              } else if (el.__stage === 9 || el.stage_local === 5) {
                finaldata[code].ignore = true;
                finaldata[code].message = "Ignored because not in scope";
                isValid = false;
              } else if (el.__stage === 1 && finaldata[code].ignore === true) {
                finaldata[code].message = "Ignored because commentary already submitted";
              }
              finaldata[code].code = code;
              finaldata[code].glcode = glcode;
              finaldata[code].name = el.glcode_detail?.name;
              if (!code) {
                haserror = true;
                finaldata[code].error = "GL Code not found";
              } else {
                finaldata[code].__found = true;
              }
              if (!isValid) delete finaldata[code];
              // uploaddata[glcode].__found = true;
              // uploaddata[glcode].error = ""
              // uploaddata[glcode].commentary1 = el.commentary1;
              // uploaddata[glcode].commentary2 = el.commentary2;
              // if(el.var1_cross_control || el.var1_cross_management){
              //   if(!uploaddata[glcode].data[1]){
              //     uploaddata[glcode].error = "Commentary 1 is required";
              //     haserror = true;
              //   }
              // }else if(uploaddata[glcode].data[1]) {
              //   uploaddata[glcode].error = "Commentary 1 cannot be added as the variance doesn't cross the threshold limit";
              //   haserror = true;
              // }
              // if(el.var2_cross_control || el.var2_cross_management){
              //   if(!uploaddata[glcode].data[2]){
              //     if(uploaddata[glcode].error !== "") uploaddata[glcode].error = uploaddata[glcode].error + ", ";
              //     uploaddata[glcode].error = uploaddata[glcode].error + "Commentary 2 is required";
              //     haserror = true;
              //   }
              // }else if(uploaddata[glcode].data[2]) {
              //   if(uploaddata[glcode].error !== "") uploaddata[glcode].error = uploaddata[glcode].error + ", ";
              //   uploaddata[glcode].error = uploaddata[glcode].error + "Commentary 2 cannot be added as the variance doesn't cross the threshold limit";
              //   haserror = true;
              // }
            }
          }
          // for (const k in uploaddata) {
          //     if (Object.hasOwnProperty.call(uploaddata, k)) {
          //       const el = uploaddata[k];
          //       if(el.__found === false) haserror = true;
          //     }
          //   }
          this.bulksubmitfiledataerror = haserror;
          this.bulksubmitfiledata = finaldata;
          Object.keys(finaldata).forEach((key) => {
            this.bulksubmitfiledataList.push(finaldata[key]);
          })
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.bulksubmitfiledatafile = null;
        this.bulksubmitloading = false;
      });
    }
  },
  readBulkSubmitisApprover() {
    const file = this.approverBulkSubmitDataFile;
    this.approverBulkSubmitFileDataListis = [];

    if (!(file && file.name) || this.approverBulkSubmitLoading) return;

    this.bulksubmitfiledataerrorisApprover = false;
    this.approverBulkSubmitLoading = true;
    const commentary1Index = 12;
    const commentary2Index = 21;
    const ext = (file.name || "").split(".").pop();

    const isValidExtension = ["xlsx", "xls", "xlsm", "xlsb"].includes(ext);
    if (!isValidExtension) {
      this.$store.commit("sbError", "Only xlsx,xls,xlsm,xlsb file extension supported");
      this.approverBulkSubmitLoading = false;
      return;
    }

    this.$nova.readExcelFile(file, "TOP SHEET")
      .then(dt => {
        const uploadedColumns = dt[4] || [];
        
        // Get constants
        const { ACTUAL } = varianceAnalysisConstants.CYCLE_TYPES;
        const bulkTemplates = this.$constants.BULK_FILE_TEMPLATES;
        
        // Determine correct template
        let columnTemplate = [];
        if (this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL_BS 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST_BS;
        } else {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST;
        }

        // Take only the first 28 columns (indices 0-27) to match downloadExcelisApprover output
        let workingColumns = columnTemplate.slice(0, 28);
        if (this.isRegionalCommentaryAutomationEnabled && this.isapprover) {
          const itemsToMove = varianceAnalysisConstants.AUTO_SUBMISSION_COLUMNS || [];
          workingColumns.splice(23, 2, ...itemsToMove);
        }

        // Remap labels to match what was downloaded
        const remappedColumns = workingColumns.map((label) => {
          if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
             if(label === 'Actual Amount') return this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual') + " Amount";
             if(label === 'Proforma Amount') return this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma') + " Amount";
             if(label === 'Forecast Amount') return this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast') + " Amount";
             return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
          } else {
             return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
          }
        });

        // Construct expected columns
        const expectedColumns = ["", ...remappedColumns];
        
        // Validate headers using common function
        validateExcelHeaders(uploadedColumns, expectedColumns);

        const gllist = [];
        const uploaddata = {};
        const finaldata = {};
        let haserror = false;

        // Build GL list and upload data map
        for (let i = 5; i < dt.length; i++) {
          const el = dt[i];
          const glcode = (el[1] || "").toString();
          gllist.push(glcode);
          uploaddata[glcode] = el;
        }

        // Helper for commentary validation
        const isCommentaryValid = c => c && typeof c === "string" && c.trim().length >= 15;

        // Process commentary data
        for (const el of this.commentarydata) {
          const glcode = (el.glcode || "").toString();
          const code = (el.glcode_detail?.code || "").toString();

          if (!gllist.includes(code)) continue;

          const uploadRow = uploaddata[code];
          finaldata[code] = {};

          // Commentary 1
          if (
            el.commentary1 !== uploadRow[commentary1Index] &&
            uploadRow[commentary1Index] &&
            uploadRow[commentary1Index] !== "null" &&
            uploadRow[commentary1Index] !== "undefined"
          ) {
            finaldata[code].commentary1 = uploadRow[commentary1Index];
          }

          // Commentary 2
          if (
            el.commentary2 !== uploadRow[commentary2Index] &&
            uploadRow[commentary2Index] &&
            uploadRow[commentary2Index] !== "null" &&
            uploadRow[commentary2Index] !== "undefined"
          ) {
            finaldata[code].commentary2 = uploadRow[commentary2Index];
          }

          finaldata[code].ignore = false;
          finaldata[code].message = "";

          // Regional columns. Drop a field only when that regional workflow is off.
          if (!this.workflows.isregionalproformaenabled) delete finaldata[code].commentary1;
          if (!this.workflows.isregionalforecastenabled) delete finaldata[code].commentary2;

          // Validation for commentary1
          if (
            this.isapprover &&
            this.workflows.isregionalproformaenabled &&
            (el.var1_cross_control_regional || el.var1_cross_management_regional)
          ) {
            if (!finaldata[code].commentary1) {
              finaldata[code].message = "Commentary1 required.";
              finaldata[code].ignore = true;
            } else if (!isCommentaryValid(finaldata[code].commentary1)) {
              finaldata[code].message = "Commentary1 minimum 15 characters required.";
              finaldata[code].ignore = true;
            }
          }

          // Validation for commentary2
          if (
            this.isapprover &&
            this.workflows.isregionalforecastenabled &&
            (el.var2_cross_control_regional || el.var2_cross_management_regional)
          ) {
            if (!finaldata[code].commentary2) {
              finaldata[code].message += "Commentary2 required.";
              finaldata[code].ignore = true;
            } else if (!isCommentaryValid(finaldata[code].commentary2)) {
              finaldata[code].message += "Commentary2 minimum 15 characters required.";
              finaldata[code].ignore = true;
            }
          }

          // Set ready message if valid
          if (!finaldata[code].ignore) {
            finaldata[code].error = false;
            finaldata[code].message = "Ready to upload";
          }

          // Both flags can be raised while local commentary is still open.
          // Regional file upload must wait until local is approved, immaterial, or has no variance.
          if (this.workflows.islocalenabled && [-1, 0, 1].indexOf(el.stage_local) > -1) {
            finaldata[code].ignore = true;
            finaldata[code].message = BULK_REGIONAL_COMMENTARY.MESSAGES.IGNORED_LOCAL_SUBMISSION;
          }

          // Ignore based on stage
          let isValid = true;
          if (el.stage_regional === 3) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because variance is immaterial";
            isValid = false;
          } else if (el.stage_regional === 4) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because no variance";
            isValid = false;
          } else if (el.__stage === 9 || el.stage_regional === 5) {
            finaldata[code].ignore = true;
            finaldata[code].message = "Ignored because not in scope";
            isValid = false;
          } else if (el.__stage === 1 && finaldata[code].ignore === true) {
            finaldata[code].message = "Ignored because commentary already submitted";
          }

          // Add meta
          finaldata[code].code = code;
          finaldata[code].glcode = glcode;
          finaldata[code].name = el.glcode_detail?.name;

          if (!code) {
            haserror = true;
            finaldata[code].error = "GL Code not found";
          } else {
            finaldata[code].__found = true;
          }

          if (!isValid) delete finaldata[code];
        }

        this.bulksubmitfiledataerrorisApprover = haserror;
          let haserrorshow = false;
          for (const code in finaldata) {
            if (finaldata[code].error) {
              haserrorshow = true;
              break;
            }
          }
        this.bulksubmitfiledataerrorisApprover = haserrorshow;
        this.approverBulkSubmitData = finaldata;
        this.approverBulkSubmitFileDataListis = Object.values(finaldata);
      })
      .catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      })
      .finally(() => {
        this.approverBulkSubmitDataFile = null;
        this.approverBulkSubmitLoading = false;
      });
  },
  /**
   * Prepares column configuration based on user role and settings
   * @returns {Object} Column configuration
   */
  getBulkApproveColumnConfig() {
    let index = 0;
    let statusColumnIndex = 24;
    let approveReasonColumnIndex = 25;
    let rejectLocalLevel = null; // Column for LA/LP rejection target (regional approver only)
    let excelColumns = this.bulksubmitcolumns.slice(0, 28);
    if (this.isRegionalCommentaryAutomationEnabled && this.isapprover) {
      const itemsToMove = varianceAnalysisConstants.AUTO_SUBMISSION_COLUMNS || [];
      excelColumns.splice(23, 2, ...itemsToMove);
    }
    if (this.isregionalapprover) {
      index = 2;
      // For regional approver: status at 24+2=26, rejectLocalLevel at 27, approveReason at 28
      rejectLocalLevel = 25; // Column after status for rejection target (LA/LP)
      approveReasonColumnIndex = 26;
    }   
    return { index, statusColumnIndex, approveReasonColumnIndex, rejectLocalLevel, excelColumns };
  },

  /**
   * Builds upload data map from Excel rows
   * @param {Array} excelData - Raw Excel data
   * @returns {Object} Upload data map and GL list
   */
  buildUploadDataMap(excelData) {
    const gllist = [];
    const uploaddata = {};
    
    for (let i = 5; i < excelData.length; i++) {
      const el = excelData[i];
      const glcode = (el[1] || "").toString();
      gllist.push(glcode);
      uploaddata[glcode] = el;
    }
    
    return { gllist, uploaddata };
  },

  /**
   * Validates GL approval status and action
   * @param {Object} gl - GL commentary data
   * @param {Object} uploadRow - Excel row data
   * @param {Object} config - Column configuration
   * @returns {Array} Array of error messages (empty if valid)
   */
  validateGLApprovalData(gl, uploadRow, config) {
    const { index, statusColumnIndex } = config;
    const errorMessages = [];  
    const warnMessages = [];
    const hasValidStatus = 
      (this.isapprover && gl.stage_local === BULK_APPROVE_REJECT.GL_STATUS.AWAITING_APPROVAL) || 
      (this.isregionalapprover && gl.stage_regional === BULK_APPROVE_REJECT.GL_STATUS.AWAITING_APPROVAL);
    
    const hasUploadData = 
      uploadRow && 
      uploadRow[index + statusColumnIndex] &&
      String(uploadRow[index + statusColumnIndex]).trim() !== '';
    
    const hasValidAction = 
      uploadRow && 
      BULK_APPROVE_REJECT.ACTIONS.includes(
        String(uploadRow[index + statusColumnIndex]).trim().toLowerCase()
      );
    // If GL is not in awaiting approval status
    if (!hasValidStatus) {
      warnMessages.push(BULK_APPROVE_REJECT.MESSAGES.GL_NOT_IN_AWAITING_APPROVAL_STATUS);
    }
    // If no action provided but GL is valid for approval
    if (!hasUploadData && hasValidStatus) {
      warnMessages.push(BULK_APPROVE_REJECT.MESSAGES.ACTION_MISSING);
    } 
    // If invalid action provided
    if (hasUploadData && !hasValidAction) {
      warnMessages.push(BULK_APPROVE_REJECT.MESSAGES.INVALID_ACTION);
    }

    return { errorMessages, warnMessages };
  },

  /**
   * Sets approval/rejection stage based on user action
   * @param {Object} glData - GL data object to update
   * @param {string} action - User action (yes/no)
   */
  setApprovalStage(glData, action) {
    const isRejection = String(action).trim().toLowerCase() === "no" || String(action).trim().toLowerCase() === "n";
    
    if (this.isregionalapprover) {
      glData.stage_regional = isRejection ? BULK_APPROVE_REJECT.GL_STATUS.REJECTED : BULK_APPROVE_REJECT.GL_STATUS.APPROVED;
    } else {
      glData.stage_local = isRejection ? BULK_APPROVE_REJECT.GL_STATUS.REJECTED : BULK_APPROVE_REJECT.GL_STATUS.APPROVED;
      glData.stage_regional = BULK_APPROVE_REJECT.GL_STATUS.AWAITING_COMMENTARY;
    }
  },

  /**
   * Validates threshold requirements for approval
   * @param {Object} gl - GL commentary data
   * @param {Object} glData - Processed GL data
   * @returns {Array} Array of error messages
   */
  validateThresholdRequirements(gl, glData,uploadRow,config) {
    const errorMessages = [];  
    const { index, statusColumnIndex, rejectLocalLevel } = config;
    const hasValidStatus = 
      (this.isapprover && gl.stage_local === BULK_APPROVE_REJECT.GL_STATUS.AWAITING_APPROVAL) || 
      (this.isregionalapprover && gl.stage_regional === BULK_APPROVE_REJECT.GL_STATUS.AWAITING_APPROVAL);
    // check for upload data and valid action
    const hasUploadData = 
      uploadRow && 
      uploadRow[index + statusColumnIndex] &&
      String(uploadRow[index + statusColumnIndex]).trim() !== '';
    
    const hasValidAction = 
      uploadRow && 
      BULK_APPROVE_REJECT.ACTIONS.includes(
        String(uploadRow[index + statusColumnIndex]).trim().toLowerCase()
      );
    // Check if approval reason is required
    const isApproveReasonValidationRequired = hasValidStatus && hasUploadData && hasValidAction 
    if(isApproveReasonValidationRequired){
      const requiresReason = 
        (this.isapprover && (gl.var1_cross_control || gl.var2_cross_control)) || 
        (this.isregionalapprover && (gl.var1_cross_control_regional || gl.var2_cross_control_regional));
      
      if (requiresReason && !glData.approvereason) {
        errorMessages.push(BULK_APPROVE_REJECT.MESSAGES.APPROVAL_REASON_REQUIRED);
      }
   }
    // Validate rejection target for regional approver when action is reject
    if (this.isregionalapprover && hasValidStatus && hasUploadData && hasValidAction) {
      const actionValue = String(uploadRow[index + statusColumnIndex]).trim().toLowerCase();
      const isRejection = actionValue === 'no' || actionValue === 'n';
      
      if (isRejection && rejectLocalLevel !== null) {
        const rejectionTargetValue = uploadRow[index + rejectLocalLevel];
        const hasRejectionTargetData = 
          rejectionTargetValue !== null && 
          rejectionTargetValue !== undefined && 
          rejectionTargetValue !== '' &&
          String(rejectionTargetValue).trim() !== '';
        
        if (!hasRejectionTargetData) {
          errorMessages.push(BULK_APPROVE_REJECT.MESSAGES.REJECTION_TARGET_REQUIRED);
        } else {
          const rejectionValue = String(rejectionTargetValue).trim().toLowerCase();
          if (!BULK_APPROVE_REJECT.REJECTION_TARGETS.includes(rejectionValue)) {
            errorMessages.push(BULK_APPROVE_REJECT.MESSAGES.INVALID_REJECTION_TARGET);
          }
        }
      }
    }
    // Check bulk approval threshold settings
    if (!this.isbulkapprovalcrosscontrolenabled) {
      if (
        (this.isapprover && (gl.var1_cross_control || gl.var2_cross_control)) || 
        (this.isregionalapprover && (gl.var1_cross_control_regional || gl.var2_cross_control_regional))
      ) {
        errorMessages.push(BULK_APPROVE_REJECT.MESSAGES.CONTROL_THRESHOLD_EXCEEDED);
      }
    }
    
    if (!this.isbulkapprovalmanagementcontrolenabled) {
      if (
        (this.isapprover && (gl.var1_cross_management || gl.var2_cross_management)) || 
        (this.isregionalapprover && (gl.var1_cross_management_regional || gl.var2_cross_management_regional))
      ) {
        errorMessages.push(BULK_APPROVE_REJECT.MESSAGES.MANAGEMENT_THRESHOLD_EXCEEDED);
      }
    }
    
    return errorMessages;
  },

  /**
   * Creates error entry for invalid GL
   * @param {string} code - GL code
   * @param {Object} gl - GL commentary data
   * @param {Array} errorMessages - List of errors
   * @returns {Object} Error data object
   */
  createErrorEntry(code, gl, errorMessages) {
    return {
      code: code,
      glcode: gl?.glcode || code,
      name: gl?.glcode_detail?.name || BULK_APPROVE_REJECT.MESSAGES.UNKNOWN_GL,
      commentary1: gl?.commentary1 || "",
      commentary2: gl?.commentary2 || "",
      ignore: true,
      __found: !!gl,
      error: errorMessages?.join("; "),
      message: gl ? BULK_APPROVE_REJECT.MESSAGES.CANNOT_PROCESS_GL : BULK_APPROVE_REJECT.MESSAGES.GL_NOT_FOUND
    };
  },

  /**
   * Creates success entry for valid GL
   * @param {string} code - GL code
   * @param {Object} gl - GL commentary data
   * @param {Object} uploadRow - Excel row data
   * @param {Object} config - Column configuration
   * @returns {Object} Success data object
   */
  createSuccessEntry(code, gl, uploadRow, config) {
    const { index, statusColumnIndex, approveReasonColumnIndex, rejectLocalLevel } = config;
    const glData = {};
    
    // Set approval/rejection status
    this.setApprovalStage(glData, uploadRow[index + statusColumnIndex]);
    
    // Set approval reason
    if (
      uploadRow[index + approveReasonColumnIndex] !== "null" && 
      uploadRow[index + approveReasonColumnIndex] !== "undefined" && 
      uploadRow[index + approveReasonColumnIndex]
    ) {
      glData.approvereason = String(uploadRow[index + approveReasonColumnIndex]).trim();
    }
    
    // Set rejection target for regional approver (LA/LP)
    if (
      this.isregionalapprover && 
      rejectLocalLevel !== null &&
      uploadRow[index + rejectLocalLevel] &&
      String(uploadRow[index + rejectLocalLevel]).trim() !== ''
    ) {
      glData.rejection_target = String(uploadRow[index + rejectLocalLevel]).trim().toLowerCase();
    } else {
      glData.rejection_target = '';
    }
    
    // Set basic info
    glData.ignore = false;
    glData.message = BULK_APPROVE_REJECT.MESSAGES.READY_TO_UPLOAD;
    glData.code = code;
    glData.glcode = gl.glcode;
    glData.name = gl.glcode_detail?.name;
    glData.commentary1 = gl.commentary1;
    glData.commentary2 = gl.commentary2;
    glData.__found = true;
    
    return glData;
  },

  /**
   * Processes a single GL for bulk approval
   * @param {Object} gl - GL commentary data
   * @param {Object} uploaddata - Upload data map
   * @param {Object} config - Column configuration
   * @returns {Object|null} Processed GL data or null if skipped
   */
  processGLForBulkApproval(gl, uploaddata, config) {
    const code = (gl.glcode_detail?.code || "").toString();
    // Check if GL exists in uploaded file
    if (!uploaddata[code]) {
      return null; // Skip this GL
    }  
    // Validate GL status and action
    const validationErrors = this.validateGLApprovalData(gl, uploaddata[code], config);
    
    if (validationErrors?.errorMessages?.length > 0) {
      return this.createErrorEntry(code, gl, validationErrors?.errorMessages);
    }
      // If there are warnings (missing/invalid action), create warning entry
    if (validationErrors?.warnMessages?.length > 0) {
      const glData = {
        code: code,
        glcode: gl.glcode,
        name: gl.glcode_detail?.name,
        commentary1: gl?.commentary1,
        commentary2: gl?.commentary2,
        ignore: true,
        hasWarning: true,
        warning: validationErrors?.warnMessages.join("; "),
        message: validationErrors?.warnMessages.join("; "),
        rejection_target: config.rejectLocalLevel !== null ? (String(uploaddata[code][config.index + config.rejectLocalLevel] ?? '').trim().toLowerCase() || '') : '',
        __found: true
      };
      return glData;
    }
    // Create success entry
    const glData = this.createSuccessEntry(code, gl, uploaddata[code], config);
    // Validate threshold requirements
    const thresholdErrors = this.validateThresholdRequirements(gl, glData,uploaddata[code],config);
    
    if (thresholdErrors.length > 0) {
      glData.ignore = true;
      glData.error = thresholdErrors.join("; ");
      glData.message = thresholdErrors.join("; ") + BULK_APPROVE_REJECT.MESSAGES.BULK_APPROVE_NOT_ALLOWED;
      // Clear the warning since we now have an error
      delete glData.warning;
      delete glData.hasWarning;
    }
    
    return glData;
  },

  /**
   * Adds missing GL codes from Excel that don't exist in system
   * @param {Array} gllist - List of GL codes from Excel
   * @param {Object} finaldata - Final processed data
   */
  addMissingGLEntries(gllist, finaldata) {
    for (const glcode of gllist) {
      if (!Object.keys(finaldata).includes(glcode)) {
        finaldata[glcode] = this.createErrorEntry(glcode, null, ["GL Code not found in system"]);
      }
    }
  },

  /**
   * Main method to read and process bulk approval file
   */

  readBulkApproveLocal() {
    const file = this.bulkapprovelocalfiledatafile;
    
    if (!file?.name || this.bulkapprovelocalloading) {
      return;
    }
    
    this.bulkapprovelocalfiledataerror = false;
    this.bulkapprovelocalloading = true;
    
    Promise.resolve()
      .then(() => {
        // Step 1: Validate file extension
        validateFileExtension(file);
        return this.$nova.readExcelFile(file, "TOP SHEET");
      })
      .then(excelData => {
        // Step 2: Get column configuration
        // Get constants from varianceAnalysisConstants
        const { ACTUAL } = varianceAnalysisConstants.CYCLE_TYPES;
        const bulkTemplates = this.$constants.BULK_FILE_TEMPLATES;
        
        let columnTemplate = [];
        if (this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL_BS 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST_BS;
        } else {
            columnTemplate = this.cycletype === ACTUAL 
            ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL 
            : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST;
        }
        
        // Take only the first 28 columns (indices 0-27) to match downloadExcelisApprover output
        let excelColumns = columnTemplate.slice(0, 28);
        if (this.isRegionalCommentaryAutomationEnabled && this.isapprover) {
          const itemsToMove = varianceAnalysisConstants.AUTO_SUBMISSION_COLUMNS || [];
          excelColumns.splice(23, 2, ...itemsToMove);
        }

        const config = {
          excelColumns: excelColumns
        };
        
        // Step 3: Validate headers
        const expectedHeaders = [
          "", 
          ...config.excelColumns.map((label) => {
            if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
               if(label === AMOUNT_TYPES.ACTUAL_AMOUNT) return this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual') + " Amount";
               if(label === AMOUNT_TYPES.PROFORMA_AMOUNT) return this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma') + " Amount";
               if(label === AMOUNT_TYPES.FORECAST_AMOUNT) return this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast') + " Amount";
               return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
            } else {
               return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
            }
          })
        ];
        validateExcelHeaders(excelData[4] || [], expectedHeaders);       
        // Step 4: Build upload data map
        const { gllist, uploaddata } = this.buildUploadDataMap(excelData);
        // Step 5: Process each GL
        const finaldata = {};
        let haserror = false;
        
        // Re-get config for processing logic, as we need indices too. 
        // We override excelColumns in the config object to ensure it matches what we validated against.
        const processConfig = this.getBulkApproveColumnConfig();
        processConfig.excelColumns = excelColumns; 

        for (const gl of this.commentarydata) {
          const processedGL = this.processGLForBulkApproval(gl, uploaddata, processConfig);

          if (processedGL) {
            const code = gl.glcode_detail?.code || "";
            finaldata[code] = processedGL;
            
            if (processedGL.error) {
              haserror = true;
            }
          }
        }          
        // Step 6: Add missing GL entries
        this.addMissingGLEntries(gllist, finaldata);
        if (Object.keys(finaldata).some(key => !finaldata[key].__found)) {
          haserror = true;
        }
        
        // Step 7: Update state
        this.bulkapprovelocalfiledataerror = haserror;
        this.bulkapprovelocalfiledata = finaldata;
      })
      .catch(err => {
        this.$store.commit("sbError", err?.message || err || "Unknown error!");
      })
      .finally(() => {
        this.bulkapprovelocalfiledatafile = null;
        this.bulkapprovelocalloading = false;
      });
  },
  processClientbyclientUploadFile(type) {
    let file = this.uploadclientbyblientfile;
    if ((file || {}).name && !this.uploadrevenuecommentaryloading && !this.uploadnetsalescommentaryloading) {
      this.uploadrevenuecommentaryloading = true;
      this.uploadnetsalescommentaryloading = true;
      let ext = ((file || {}).name || "").split(".").pop();
      Promise.resolve().then(() => {
        if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new "Only xlsx,xls,xlsm,xlsb file extension supported";
        return this.$nova.readExcelFile(file, "TOP SHEET");
      }).then(dt => {
        if (JSON.stringify(dt[4] || []) === JSON.stringify(["", ...this.clientbyclient_headers.map(el => el.text)])) {
          let cllist = [];
          let uploaddata = {};
          let finaldata = [];
          this.uploadclientbyclienterror = false;
          for (let i = 4; i < dt.length; i++) {
            if (i > 4) {
              const el = dt[i];
              let cl_code = (el[1] || "").toString();
              let ndt = el;
              cllist.push(cl_code);
              uploaddata[cl_code] = ndt;
            }
          }
          let cbcdata = this.clientbyclientdata_revenue;
          if (type === "netsales") cbcdata = this.clientbyclientdata_netsales;
          for (let i = 0; i < cbcdata.length; i++) {
            const el = cbcdata[i];
            let cl_code = (el.cl_code || "").toString();
            let t = { ...el };
            if (cllist.indexOf(cl_code) > -1) {
              if (el.commentary1 !== uploaddata[cl_code][6]) {
                t.commentary1 = uploaddata[cl_code][6];
              }
              if (el.commentary2 !== uploaddata[cl_code][9]) {
                t.commentary2 = uploaddata[cl_code][9];
              }
               // Commentary validation commented for now 
              // if (!t.commentary1 || t.commentary1.trim().length < 15) {
              //   t.error = `${this.actual_label} vs ${this.proforma_shortform_label} commentary required (min 15 chars)`;
              // } else if (!t.commentary2 || t.commentary2.trim().length < 15) {
              //  t.error = `${this.actual_label} vs ${this.forcast_shortform_label} commentary required (min 15 chars)`;
              // }
            } else {
              this.uploadclientbyclienterror = true;
              t.error = "Client code not found";
            }
            finaldata.push(t)
          }
          if (type === 'revenue') {
            this.uploadfiledata_revenue = finaldata;
            this.uploadfiledata_netsales = [];
          } else if (type === 'netsales') {
            this.uploadfiledata_revenue = [];
            this.uploadfiledata_netsales = finaldata;
          }
        } else throw new Error("Columns " + ["", ...this.clientbyclient_headers.map(el => el.text)].join(', ') + " are required in the same order");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.uploadclientbyblientfile = null;
        this.uploadrevenuecommentaryloading = false;
        this.uploadnetsalescommentaryloading = false;
      });
    }
  },
  addCommentary() {
    let url = "/v3/varianceanalysis/analysis/addcommentary/" + this.selectedcommentary._id;
    let isVolunterySubmit = false
    let id = this.selectedcommentary._id;
    let dta = []
    if (this.ispreparer && !this.bulksubmit) {
      if ([3, 4, 5].indexOf(this.selectedcommentary?.stage_local) > -1) {
        isVolunterySubmit = true
      }
    }
    if (this.bulksubmit) {
      id = this.multiselectdata;
      // this.previewBulkCommentary(false);
      // this.previewBulkAddCommentary.forEach(item=>{
      //   if(item.ignore === false && this.ispreparer){
      //     dta.push({_id:item.id,commentary1:item.commentary1,commentary2:item.commentary2,isvolunterysubmit:false})
      //   }
      //   else if(item.ignore === false && this.isapprover){
      //     dta.push({_id:item.id,commentary1:item.regionalcommentary1,commentary2:item.regionalcommentary2,isvolunterysubmit:false})
      //   }
      // })
      // if(dta.length === 0){
      //   this.$store.commit("sbError", "No valid GL(s) or Commentary found to submit");
      //   return;
      // }
      url = "/v3/varianceanalysis/analysis/addbulkcommentary"
    }
    const isShortOrEmpty = (text) => !text || String(text).trim().length < 15;
    const isShortOnly = (text) => text && String(text).trim().length > 0 && String(text).trim().length < 15;

    // For bulk, re-OR threshold flags across selection so mandatory checks stay accurate.
    if (this.bulksubmit) {
      Object.assign(this.selectedcommentary || {}, this.getAggregatedMultiselectThresholdFlags());
    }

    const isProformaMandatory = this.ispreparer && (this.selectedcommentary.var1_cross_control || this.selectedcommentary.var1_cross_management);
    const preparerProformaNeeded = isProformaMandatory
      ? isShortOrEmpty(this.selectedcommentary?.commentary1)
      : isShortOnly(this.selectedcommentary?.commentary1);
    const isForecastMandatory = this.ispreparer && (this.selectedcommentary.var2_cross_control || this.selectedcommentary.var2_cross_management);
    const preparerForecastNeeded = isForecastMandatory
      ? isShortOrEmpty(this.selectedcommentary?.commentary2)
      : isShortOnly(this.selectedcommentary?.commentary2);
    const isRegionalProformaMandatory = this.isapprover && (this.selectedcommentary.var1_cross_management_regional || this.selectedcommentary.var1_cross_control_regional);
    const approverProformaNeeded = isRegionalProformaMandatory
      ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary1)
      : isShortOnly(this.selectedcommentary?.regionalcommentary1);
    const isRegionalForecastMandatory = this.isapprover && (this.selectedcommentary.var2_cross_management_regional || this.selectedcommentary.var2_cross_control_regional);
    const approverForecastNeeded = isRegionalForecastMandatory
      ? isShortOrEmpty(this.selectedcommentary?.regionalcommentary2)
      : isShortOnly(this.selectedcommentary?.regionalcommentary2);

    let thresholdcross = {};
    if (this.ispreparer) thresholdcross = { crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma, crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast, crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma, crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast }
    else if (this.isapprover) thresholdcross = { crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma, crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast, crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma, crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast }
    if (this.ispreparer && !(thresholdcross.crosscontrolthresholdvsproforma || thresholdcross.crossmanagementthresholdvsproforma || thresholdcross.crosscontrolthresholdvsforecast || thresholdcross.crossmanagementthresholdvsforecast) && !this.bulksubmit && !(this.selectedcommentary.var1_cross_control || this.selectedcommentary.var1_cross_management || this.selectedcommentary.var2_cross_control || this.selectedcommentary.var2_cross_management) && (this.selectedcommentary.stage_local === 3 || this.selectedcommentary.stage_local === 4)) {
      this.$store.commit("sbError", "Voluntary commentary submission reason is required.");
    } else if (this.ispreparer && (thresholdcross.crosscontrolthresholdvsproforma || thresholdcross.crossmanagementthresholdvsproforma || thresholdcross.crosscontrolthresholdvsforecast || thresholdcross.crossmanagementthresholdvsforecast) && !this.bulksubmit && !(this.selectedcommentary.var1_cross_control || this.selectedcommentary.var1_cross_management || this.selectedcommentary.var2_cross_control || this.selectedcommentary.var2_cross_management) && (this.selectedcommentary.stage_local === 3 || this.selectedcommentary.stage_local === 4) && ((!this.selectedcommentary.commentary1 || (this.selectedcommentary.commentary1 && String(this.selectedcommentary.commentary1).trim().length < 15)) && (!this.selectedcommentary.commentary2 || (this.selectedcommentary.commentary2 && String(this.selectedcommentary.commentary2).trim().length < 15)))) {
      this.$store.commit("sbError", "Minimum one commentary is required and should be minimum 15 characters");
    } else if (this.isapprover && !(thresholdcross.crosscontrolthreshold || thresholdcross.crossmanagementthreshold) && !this.bulksubmit && !(this.selectedcommentary.var1_cross_control_regional || this.selectedcommentary.var1_cross_management_regional || this.selectedcommentary.var2_cross_control_regional || this.selectedcommentary.var2_cross_management_regional) && (this.selectedcommentary.stage_regional === 3 || this.selectedcommentary.stage_regional === 4)) {
      this.$store.commit("sbError", "Voluntary commentary submission reason is required.");
    } else if (this.isapprover && (thresholdcross.crosscontrolthreshold || thresholdcross.crossmanagementthreshold) && !this.bulksubmit && !(this.selectedcommentary.var1_cross_control_regional || this.selectedcommentary.var1_cross_management_regional || this.selectedcommentary.var2_cross_control_regional || this.selectedcommentary.var2_cross_management_regional) && (this.selectedcommentary.stage_regional === 3 || this.selectedcommentary.stage_regional === 4) && ((!this.selectedcommentary.commentary1 || (this.selectedcommentary.commentary1 && String(this.selectedcommentary.commentary1).trim().length < 15)) || (!this.selectedcommentary.commentary2 || (this.selectedcommentary.commentary2 && String(this.selectedcommentary.commentary2).trim().length < 15)))) {
      this.$store.commit("sbError", "Minimum one commentary is required and should be minimum 15 characters");
    } else if (preparerProformaNeeded || approverProformaNeeded) {
      this.$store.commit("sbError", `${this.cycletype === 'Actual' ? this.actual_label : this.forcast_shortform_label} Vs ${this.proforma_shortform_label} commentary is required and should be minimum 15 characters.`);
    } else if (preparerForecastNeeded || approverForecastNeeded) {
      this.$store.commit("sbError", `${this.cycletype === 'Actual' ? this.actual_label : this.forcast_shortform_label} Vs ${this.forcast_shortform_label} commentary is required and should be minimum 15 characters.`);
    } else {
      this.commentaryloading = true;
      this.selectedcommentary.commentary1 = String(this.selectedcommentary?.commentary1 ?? '').trim();
      this.selectedcommentary.commentary2 = String(this.selectedcommentary?.commentary2 ?? '').trim();
      dta = { commentary1: this.selectedcommentary?.commentary1, commentary2: this.selectedcommentary?.commentary2, isvolunterysubmit: isVolunterySubmit };
      if (this.isapprover) {
        this.selectedcommentary.regionalcommentary1 = String(this.selectedcommentary?.regionalcommentary1 ?? '').trim();
        this.selectedcommentary.regionalcommentary2 = String(this.selectedcommentary?.regionalcommentary2 ?? '').trim();
        dta = { regionalcommentary1: this.selectedcommentary.regionalcommentary1, regionalcommentary2: this.selectedcommentary.regionalcommentary2 };
      }
      // Build filter with optional reporting_type for Balance Sheet
      const saveFilter = { 
        regional: this.isapprover, 
        cycletype: this.cycletype, 
        all: this.bulkcommentall, 
        replace: this.bulkcommentreplace, 
        ...thresholdcross, 
        reportingunit: this.selectedreportingunit 
      };
      if (this.reportingType) {
        saveFilter.reporting_type = this.reportingType;
      }
      this.axios.post(url, { id: id, filter: saveFilter, data: dta }).then(dt => {
        if (dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Commentary added");
          this.commantorydialog = false;
          if (this.bulksubmit) {
            this.loadContent(true);
          }
          else {
            let data = dt.data.data[0] || [];
            if (this.isapprover) {
              this.commentarydata[this.selectedcommentary.__key].regionalcommentary1 = this.selectedcommentary.regionalcommentary1 || "";
              this.commentarydata[this.selectedcommentary.__key].regionalcommentary2 = this.selectedcommentary.regionalcommentary2 || "";
              this.commentarydata[this.selectedcommentary.__key].stage_regional = 1;
              if (this.workflows.rcp) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_control_regional = data.var1_cross_control_regional || false;
              }
              if (this.workflows.rmp) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_management_regional = data.var1_cross_management_regional || false;
              }
              if (this.workflows.rcf) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_control_regional = data.var2_cross_control_regional || false;
              }
              if (this.workflows.rmf) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_management_regional = data.var2_cross_management_regional || false;
              }
            } else {
              this.commentarydata[this.selectedcommentary.__key].commentary1 = this.selectedcommentary.commentary1;
              this.commentarydata[this.selectedcommentary.__key].savedcommentary1 = "";
              this.selectedcommentary.savedcommentary1 = "";
              this.commentarydata[this.selectedcommentary.__key].commentary2 = this.selectedcommentary.commentary2;
              this.commentarydata[this.selectedcommentary.__key].savedcommentary2 = "";
              this.selectedcommentary.savedcommentary2 = "";
              this.commentarydata[this.selectedcommentary.__key].stage_local = 1;

              if (this.workflows.lcp) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_control = data.var1_cross_control || false;
              }
              if (this.workflows.lmp) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_management = data.var1_cross_management || false;
              }
              if (this.workflows.lcf) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_control = data.var2_cross_control || false;
              }
              if (this.workflows.lmf) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_management = data.var2_cross_management || false;
              }
            }
          }
        }
        else throw new Error(dt.data.message || "Error adding commentary");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.commentaryloading = false;
      })
    }
  },
  handleDialogClose() {
    this.showErrorMessageDialog = false;
    this.errorMessageDialogContent = '';
  },
  saveCommentary() {
    this.commentaryloading = true;
    let thresholdcross = {}
    if (this.ispreparer) thresholdcross = { crosscontrolthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma, crosscontrolthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast, crossmanagementthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma, crossmanagementthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast }
    let url = "/v3/varianceanalysis/analysis/addcommentary/" + this.selectedcommentary._id;
    let id = this.selectedcommentary._id;
    if (this.bulksubmit) {
      id = this.multiselectdata;
      url = "/v3/varianceanalysis/analysis/addbulkcommentary"
    }
    // Build filter with optional reporting_type for Balance Sheet
    const saveCommentaryFilter = { save: true, cycletype: this.cycletype, all: this.bulkcommentall, replace: this.bulkcommentreplace, reportingunit: this.commentaryrudata?._id };
    if (this.reportingType) {
      saveCommentaryFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, {id: id, filter: saveCommentaryFilter, data: {commentary1: String(this.selectedcommentary?.commentary1 ?? '').trim(), commentary2: String(this.selectedcommentary?.commentary2 ?? '').trim(),summarycommentary1:String(this.summaryAiProforma ?? '').trim() , summarycommentary2: String(this.summaryAiForecast ?? '').trim(),...thresholdcross}}).then(dt => {        if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Commentary saved");
        if (this.bulksubmit) {
          this.loadContent(true);
        }
        else {
          let data = dt.data.data[0] || [];
          this.commentarydata[this.selectedcommentary.__key].savedcommentary1 = this.selectedcommentary?.commentary1;
          this.selectedcommentary.savedcommentary1 = this.selectedcommentary?.commentary1;
          this.commentarydata[this.selectedcommentary.__key].savedcommentary2 = this.selectedcommentary?.commentary2;
          this.selectedcommentary.savedcommentary2 = this.selectedcommentary?.commentary2;
          this.commentarydata[this.selectedcommentary.__key].summarycommentary1 = this.summaryAiProforma;
          this.selectedcommentary.summarycommentary1 = String(this.summaryAiProforma ?? '').trim();
          this.commentarydata[this.selectedcommentary.__key].summarycommentary2 = String(this.summaryAiForecast ?? '').trim();
          this.selectedcommentary.summarycommentary2 = String(this.summaryAiForecast ?? '').trim();
         
          if (this.workflows.lcp) {
            this.commentarydata[this.selectedcommentary.__key].saved_var1_cross_control = data.saved_var1_cross_control || false;
          }
          if (this.workflows.lmp) {
            this.commentarydata[this.selectedcommentary.__key].saved_var1_cross_management = data.saved_var1_cross_management || false;
          }
          if (this.workflows.lcf) {
            this.commentarydata[this.selectedcommentary.__key].saved_var2_cross_control = data.saved_var2_cross_control || false;
          }
          if (this.workflows.lmf) {
            this.commentarydata[this.selectedcommentary.__key].saved_var2_cross_management = data.saved_var2_cross_management || false;
          }
        }
      }
      else throw new Error(dt.data.message || "Error adding commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.commentaryloading = false;
    })
  },
  getDownloadPeriodList() {
    let dt = [];
    for (const k in this.periodlist) {
      if (Object.hasOwnProperty.call(this.periodlist, k)) {
        const el = this.periodlist[k];
        if (k !== "all") dt.push(el);
      }
    }
    dt = dt.reverse((a, b) => (a.number || 100) - (b.number || 100));
    this.downloadperiodlist = dt;
  },
  getDownloadAllRUlist() {
    this.allrudownloaddialog = true;
    this.allrudownloadloading = true;
    const payload = {
        cycletype: this.cycletype, 
        type: 'allruexcel_' + this.cycletype.toLowerCase(),
        reporting_type: this.reportingType
    };
    
    this.$store.dispatch('varianceanalysis/reports/fetchDataReportList', payload).then(dt => {
      if (dt.data.status === "success") {
        this.allrudownloadlist = dt.data.data;
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        for (const i of this.allrudownloadlist) {
          let mn = i.period_detail.number
          i.period_detail.month = months[mn - 1];
        }
      }
    }).finally(() => {
      // console.log(this.selectedperiod);
      this.getAllyears()
      this.allRUDownloadPeriod = this.selectedperiod;
      this.allRUDownloadYear = this.selectedyear;
      if (this.allRUDownloadPeriod === "all") this.allRUDownloadPeriod = null;
      if (this.allRUDownloadYear === "all") this.allRUDownloadYear = null;
      // console.log(this.allRUDownloadPeriod);
      this.allrudownloadloading = false;
    })
  },
  downloadAllRU(id) {
    this.allrudownloadloading = true;
    const payload = { 
        period: [this.allRUDownloadPeriod], 
        cycletype: this.cycletype, 
        type: 'allruexcel_' + this.cycletype.toLowerCase(),
        reporting_type: this.reportingType,
        id: id
    };

    this.$store.dispatch('varianceanalysis/reports/fetchDataReportFiltered', payload).then(dt => {
      if (dt.data.status === "success") {
        this.getDownloadAllRUlist();
        let download_data = dt.data.data[0] || {};
        if (id && download_data.upload) this.$nova.downloadFile(undefined, {}, "/v3/varianceanalysis/analysis/download/" + download_data._id);
      }
    }).finally(() => {
      this.allrudownloadloading = false;
    })
  },
  getDownloadAllRUcyclelist() {
    this.allrucycledownloaddialog = true;
    this.allrucycledownloadloading = true;
    const payload = {
        cycletype: this.cycletype, 
        type: 'allrucycle_' + this.cycletype.toLowerCase(),
        reporting_type: this.reportingType
    };
    
    this.$store.dispatch('varianceanalysis/reports/fetchCycleReportList', payload).then(dt => {
      if (dt.data.status === "success") {
        this.allrucycledownloadlist = dt.data.data;
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        for (const i of this.allrucycledownloadlist) {
          let mn = i.period_detail.number
          i.period_detail.month = months[mn - 1];
        }
      }
    }).finally(() => {
      // console.log(this.selectedperiod);
      this.getAllyears()
      this.allRUcycleDownloadPeriod = this.selectedperiod;
      this.allRUDownloadYear = this.selectedyear;
      if (this.allRUcycleDownloadPeriod === "all") this.allcycleRUDownloadPeriod = null;
      if (this.allRUDownloadYear === "all") this.allRUDownloadYear = null;
      // console.log(this.allRUDownloadPeriod);
      this.allrucycledownloadloading = false;
    })
  },
  pdfdownloadRUcycleGenerate() {
    this.rucyclepdfdownloadloading = true;
    let url = "/v3/varianceanalysis/analysis/downloadpdf/" + this.commentarycycledata._id + '/c/' + this.$store.state.client;
    this.axios.post(url, { filter: { reporting_type: this.reportingType, cycletype: this.cycletype } }).then(dt => {
      if (dt.data.status === "success") {
        this.getpdfFun();
        let download_data = dt.data.data[0] || {};
        if (download_data.upload) this.$nova.downloadFile(undefined, {}, "/v3/varianceanalysis/analysis/download/" + download_data._id);
      }
      else throw new Error(dt.data.message || "Error generating download");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.rucyclepdfdownloadloading = false;
    })
  },
  downloadAllRUcycle(id) {
    this.allrucycledownloadloading = true;
    const payload = { 
        period: [this.allRUDownloadPeriod], 
        cycletype: this.cycletype, 
        type: 'allrucycle_' + this.cycletype.toLowerCase(),
        reporting_type: this.reportingType,
        id: id
    };
    
    this.$store.dispatch('varianceanalysis/reports/fetchCycleReportFiltered', payload).then(dt => {
      if (dt.data.status === "success") {
        this.getDownloadAllRUcyclelist();
        let download_data = dt.data.data[0] || {};
        if (id && download_data.upload) this.$nova.downloadFile(undefined, {}, "/v3/varianceanalysis/analysis/download/" + download_data._id);
      }
    }).finally(() => {
      this.allrucycledownloadloading = false;
    })
  },
  bulkUploadCommentaryByGLisApprover() {
    this.approverBulkSubmitLoading = true;
    let url = "/v3/varianceanalysis/analysis/addbulkfileuploadregionalcommentary";
    let ndt = [];
    for (const k in this.approverBulkSubmitData) {
      const el = this.approverBulkSubmitData[k];
      if (el.ignore === false) {
        ndt.push({ glcode: el.glcode, regionalcommentary1: el.commentary1, regionalcommentary2: el.commentary2, });
      }
    }
    // Build filter with optional reporting_type for Balance Sheet
    const bulkApproverFilter = { cycletype: this.cycletype, cycle: this.commentarycycledata._id, reportingunit: this.selectedreportingunit, period: this.selectedperiod };
    if (this.reportingType) {
      bulkApproverFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { data: ndt, filter: bulkApproverFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Bulk Commentary added");
        this.approverBulkSubmitPop = false;
        this.loadContent(true);
      }
      else throw new Error(dt.data.message || "Error adding bulk commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.approverBulkSubmitLoading = false;
      this.approverBulkSubmitData = false;
    })

  },
  bulkUploadCommentaryByGL(isBulk = false) {
    this.bulksubmitloading = true;
    let url = "/v3/varianceanalysis/analysis/bulkaddcommentarybygl";
    let ndt = [];
    for (const k in this.bulksubmitfiledata) {
      if (Object.hasOwnProperty.call(this.bulksubmitfiledata, k)) {
        const el = this.bulksubmitfiledata[k];
        // console.log(el);
        if (el.ignore === false) {
          if (isBulk && el.isvolunterysubmit === true) {
            ndt.push({
              glcode: el.glcode,
              commentary1: el.commentary1,
              commentary2: el.commentary2,
              "crosscontrolthresholdvsproforma": el.saved_var1_cross_control,
              "crosscontrolthresholdvsforecast": el.saved_var2_cross_control,
              "crossmanagementthresholdvsproforma": el.saved_var1_cross_management,
              "crossmanagementthresholdvsforecast": el.saved_var2_cross_management
            });
          } else {
            ndt.push({ glcode: el.glcode, commentary1: el.commentary1, commentary2: el.commentary2, });
          }
        }
      }
    }
    // Build filter with optional reporting_type for Balance Sheet
    const bulkCommentaryFilter = { cycletype: this.cycletype, cycle: this.commentarycycledata._id, reportingunit: this.selectedreportingunit, period: this.selectedperiod };
    if (this.reportingType) {
      bulkCommentaryFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { data: ndt, filter: bulkCommentaryFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Bulk Commentary added");
        this.bulksubmitdialog = false;
        this.loadContent(true);
      }
      else throw new Error(dt.data.message || "Error adding bulk commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.bulksubmitloading = false;
      this.previewBulkAddCommentarydialog = false
    })
  },
  bulkUploadApproveLocalCommentaryByGL() {
    this.bulkapprovelocalloading = true;
    let role = 'localapprover';
    if (this.isregionalapprover) role = 'regionalapprover'
    let url = "/v3/varianceanalysis/analysis/bulkapprovelocalcommentarybygl";
    let ndt = [];
    // console.log(this.bulkapprovelocalfiledata);
    for (const k in this.bulkapprovelocalfiledata) {
      if (Object.hasOwnProperty.call(this.bulkapprovelocalfiledata, k)) {
        const el = this.bulkapprovelocalfiledata[k];
        // console.log(el);
        if (el.ignore === false && this.isapprover) {
          ndt.push({ glcode: el.glcode, approvereason: el.approvereason, stage_local: el.stage_local, stage_regional: el.stage_regional });
        } else if (el.ignore === false && this.isregionalapprover) {
          // Transform rejection_target: 'lp' -> 'local_preparer', 'la' -> 'local_approver'
          const rejectionTarget = BULK_APPROVE_REJECT.REJECTION_TARGET_MAP[el.rejection_target] || '';
          ndt.push({ 
            glcode: el.glcode, 
            regionalapprovereason: el.approvereason, 
            stage_regional: el.stage_regional,
            rejection_target: rejectionTarget
          });
        }
      }
    }
    // Build filter with optional reporting_type for Balance Sheet
    const bulkApproveFilter = { cycletype: this.cycletype, cycle: this.commentarycycledata._id, reportingunit: this.selectedreportingunit, period: this.selectedperiod };
    if (this.reportingType) {
      bulkApproveFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { data: ndt, role: role, filter: bulkApproveFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Bulk commentary approve/reject completed");
        this.bulkapprovelocaldialog = false;
        this.loadContent(true);
      }
      else throw new Error(dt.data.message || "Error bulk approve/reject of commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.bulkapprovelocalloading = false;
    })
  },
  uploadclientbyclientCommentary(type) {
    this.uploadrevenuecommentaryloading = true;
    this.uploadnetsalescommentaryloading = true;
    let url = "/v3/varianceanalysis/analysis/bulkaddclientbyclientcommentary";
    let ndt = [];
    let uploaddata = this.uploadfiledata_revenue;
    if (type === "netsales") uploaddata = this.uploadfiledata_netsales;
    // console.log(this.bulksubmitfiledata);
    for (const i of uploaddata) {
      ndt.push({ _id: i._id, cl_code: i.cl_code, commentary1: i.commentary1, commentary2: i.commentary2 });
    }
    // Build filter with optional reporting_type for Balance Sheet
    const clientByClientFilter = { cycletype: this.cycletype, type: type, cycle: this.commentarycycledata._id, reportingunit: this.selectedreportingunit, period: this.selectedperiod };
    if (this.reportingType) {
      clientByClientFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { data: ndt, filter: clientByClientFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Bulk client by client commentary uploaded");
        this.uploadrevenuecommentarydialog = false;
        this.uploadnetsalescommentarydialog = false;
        this.clientbyclientdialog_revenue = false;
        this.clientbyclientdialog_netsales = false;
        this.uploadnetsalescommentarydialog = false;
        if (type === "revenue") this.getRevenueData({ cycle: this.commentarycycledata._id });
        else if (type === "netsales") this.getNetSalesData({ cycle: this.commentarycycledata._id });
      }
      else throw new Error(dt.data.message || "Error adding bulk client by client commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.uploadrevenuecommentaryloading = false;
      this.uploadnetsalescommentaryloading = false;
    })
  },
  getPreviousCycleList() {
    if (this.workflows.islocalenabled) {
      this.previouscyclelistdialog = true;
      this.previouscyclelistloading = true;
      this.previouscyclelist = [];
      let url = "/v3/varianceanalysis/analysis/getpreviouscycle";
      // Build filter with optional reporting_type for Balance Sheet
      const prevCycleListParams = { cycletype: this.cycletype, reportingunit: this.selectedreportingunit, period: this.selectedperiod };
      if (this.reportingType) {
        prevCycleListParams.reporting_type = this.reportingType;
      }
      this.apiGet(url, prevCycleListParams).then(dt => {
        if (dt.data.status === "success") {
          this.previouscyclelist = dt.data.data || [];
        }
        else throw new Error(dt.data.message || "Error loading previous cycles");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.previouscyclelistloading = false;
      })
    }
  },
  /**
   * Sends email reminders for selected reporting unit cycles
   * @param {Object|Array} reportingUnits - Either a single reporting unit object or an array of reporting unit objects containing cycle information
   * @returns {Promise<void>}
   */
  sendEmailReminderForSelectedCycle: async function (reportingUnits) {
    // Handle both single reporting unit or array of reporting units
    const reportingUnitsArray = Array.isArray(reportingUnits) ? reportingUnits : [reportingUnits];
    // Validate input
    if (!reportingUnitsArray.length) {
      console.error('No reporting units provided');
      return;
    }
    try {
      const url = "/v3/varianceanalysis/analysis/emailReminderForSelectedCycles";
      const response = await this.axios.post(url, {
        data: [{
          cycle: reportingUnitsArray
        }]
      });

      // Check if the response is successful
      if (!response || response.data.status !== 'success') {
        throw new Error(`Failed to send email reminder, status: ${response.data.status || 'unknown'}`);
      }
      if (!response.data.data.length) {
        this.$store.commit("sbError", "No email reminders sent. Please check the selected reporting units.");
        return;
      }
      // Success message indicating the number of cycles
      const cycleCount = reportingUnitsArray.length;
      this.$store.commit(
        "sbSuccess",
        `Email reminder${cycleCount > 1 ? 's' : ''} sent successfully`
      );
      this.reportingUnitsForMailReminder = [];

    } catch (error) {
      console.error('Failed to send email reminder:', error);
      this.$store.commit("sbError", error.message || 'Failed to send email reminder');
    }
  },
  /**
   * Shows confirmation dialog for sending email reminders for cycles selected via checkboxes
   * Called from RUViewToolbar when clicking the multi-email reminder button
   * Uses the selectedlocalapproval array which contains cycle IDs
   */
  sendEmailReminderForSelectedCycles: function () {
    const cycleIds = this.selectedlocalapproval || [];
    if (!cycleIds.length) {
      this.$store.commit("sbError", "No cycles selected for email reminder");
      return;
    }
    // Set mode to cycles and show confirmation dialog
    this.emailReminderMode = 'cycles';
    this.confirmEmailReminderDialog = true;
  },
  /**
   * Executes the API call to send email reminders for selected cycles
   * Called after user confirms in the dialog
   * @returns {Promise<void>}
   */
  executeSendEmailReminderForCycles: async function () {
    const cycleIds = this.selectedlocalapproval || [];
    if (!cycleIds.length) {
      this.$store.commit("sbError", "No cycles selected for email reminder");
      return;
    }
    this.emailreminderdialogloading = true;
    try {
      const url = "/v3/varianceanalysis/analysis/emailReminderForSelectedCycles";
      const response = await this.axios.post(url, {
        data: [{
          cycle: cycleIds
        }]
      });

      if (!response || response.data.status !== 'success') {
        throw new Error(`Failed to send email reminder, status: ${response.data.status || 'unknown'}`);
      }
      if (!response.data.data.length) {
        this.$store.commit("sbError", "No email reminders sent. Please check the selected cycles.");
        return;
      }
      const cycleCount = cycleIds.length;
      this.$store.commit(
        "sbSuccess",
        `Email reminder${cycleCount > 1 ? 's' : ''} sent successfully for ${cycleCount} cycle${cycleCount > 1 ? 's' : ''}`
      );
      // Clear selections after successful send
      this.selectedlocalapproval = [];
    } catch (error) {
      console.error('[helpers.js] Failed to send email reminder for selected cycles:', error);
      this.$store.commit("sbError", error.message || 'Failed to send email reminder');
    } finally {
      this.emailreminderdialogloading = false;
    }
  },
  getPreviousCycleData(id) {
    this.previouscycledatadialog = true;
    this.previouscycledataloading = true;
    this.previouscycledata = [];
    let url = "/v3/varianceanalysis/analysis/getpreviouscycledata";
    // Build filter with optional reporting_type for Balance Sheet
    const prevCycleParams = { cycletype: this.cycletype, cycle: id, reportingunit: this.selectedreportingunit };
    if (this.reportingType) {
      prevCycleParams.reporting_type = this.reportingType;
    }
    this.apiGet(url, prevCycleParams).then(dt => {
      if (dt.data.status === "success") {
        this.previouscyclemetadata = (dt.data.data[0] || {}).metadata || {};
        this.previouscycledata = (dt.data.data[0] || {}).data || [];
        // console.log(this.previouscycledata);
        this.previouscycledatatoupload = [];
        this.prevcommentaryselect = [];
        for (const i of this.previouscycledata) {
          // console.log(this.commentarydatajson[i.glcode]);
          if (this.commentarydatajson[i.glcode]) {
            let t = { ...(this.commentarydatajson[i.glcode] || {}) }
            t.commentary1 = i.commentary1 || "";
            t.commentary2 = i.commentary2 || "";
            t.glcode = i.glcode;
            if (!this.commentarydatajson[i.glcode].commentary1 && !this.commentarydatajson[i.glcode].commentary2 && !this.commentarydatajson[i.glcode].savedcommentary1 && !this.commentarydatajson[i.glcode].savedcommentary2 && this.commentarydatajson[i.glcode].stage_local === 0) t.import = true;
            if (t.import) this.prevcommentaryselect.push(i.glcode);
            this.previouscycledatatoupload.push(t)
          }
        }
      }
      else throw new Error(dt.data.message || "Error loading previous cycles");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.previouscycledataloading = false;
    })
  },
  uploadPreviousCycleCommentary() {
    this.previouscycledataloading = true;
    this.previouscycledata = [];
    let url = "/v3/varianceanalysis/analysis/uploadpreviouscycledata";
    let ndt = [];
    for (const i of this.previouscycledatatoupload) {
      if (i.import && this.prevcommentaryselect.indexOf(i.glcode) > -1) ndt.push({ glcode: i.glcode, commentary1: i.commentary1, commentary2: i.commentary2 })
    }
    // Build filter with optional reporting_type for Balance Sheet
    const uploadPrevFilter = { cycletype: this.cycletype, period: this.selectedperiod, reportingunit: this.selectedreportingunit };
    if (this.reportingType) {
      uploadPrevFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { data: ndt, filter: uploadPrevFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.previouscycledatadialog = false;
        this.previouscyclelistdialog = false;
        this.$store.commit("sbSuccess", "Commentary saved");
        this.loadContent(true);
      }
      else throw new Error(dt.data.message || "Error adding previous cycle commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.previouscycledataloading = false;
    })
  },
  requestCommentary() {
    let gls = [];
    let notInScopeGLs = []
    if (this.bulksubmit) {
      gls = this.multiselectdata;
      gls.forEach((glid => {
        let glItem = this.commentarydata.find((item) => item._id === glid);
        if ([9].indexOf(glItem.__stage) > -1) {
          notInScopeGLs.push(glid)
        }
      }));
    }
    else {
      if ([9].indexOf(this.selectedcommentary.__stage) > -1) {
        notInScopeGLs.push(this.selectedcommentary._id)
      }
      gls = [this.selectedcommentary._id];
    }
    this.requestcommentaryloading = true;
    let level = "local";
    let fltr = { level: level, cycletype: this.cycletype, cycle: this.commentarycycledata._id, gls: gls, notinscopegls: notInScopeGLs, crosscontrollocalthresholdvsproforma: this.requestcommentarylocalcontrolvsProforma, crossmanagementlocalthresholdvsproforma: this.requestcommentarylocalmanagementvsProforma, crosscontrollocalthresholdvsforecast: this.requestcommentarylocalcontrolvsForecast, crossmanagementlocalthresholdvsforecast: this.requestcommentarylocalmanagementvsForecast };
    // Add reporting_type for Balance Sheet tab
    if (this.reportingType) {
      fltr.reporting_type = this.reportingType;
    }
    if (this.isregionalapprover) {
      level = "regional";
      fltr.level = level;
      fltr.crosscontrolregionalthresholdvsproforma = this.requestcommentaryregionalcontrolvsProforma;
      fltr.crosscontrolregionalthresholdvsforecast = this.requestcommentaryregionalcontrolvsForecast;
      fltr.crossmanagementregionalthresholdvsproforma = this.requestcommentaryregionalmanagementvsProforma;
      fltr.crossmanagementregionalthresholdvsforecast = this.requestcommentaryregionalmanagementvsForecast;
    }
    if ((level === "local" &&
      !(fltr.crosscontrollocalthresholdvsforecast ||
        fltr.crosscontrollocalthresholdvsproforma ||
        fltr.crossmanagementlocalthresholdvsproforma ||
        fltr.crossmanagementlocalthresholdvsforecast)) ||
      (level === "regional" &&
        !(fltr.crosscontrolregionalthresholdvsproforma ||
          fltr.crosscontrolregionalthresholdvsforecast ||
          fltr.crossmanagementregionalthresholdvsproforma ||
          fltr.crossmanagementregionalthresholdvsforecast))) {
      // If none are selected, then throw the error message and return
      this.$store.commit("sbError", "Reason for request for commentary is mandatory");
      this.requestcommentaryloading = false;
    } else {
      let url = "/v3/varianceanalysis/analysis/requestcommentary";
      this.axios.post(url, { filter: fltr }).then(dt => {
        if (dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Request Success. Commentary will be requested only for GL's are in 'Approved' , 'Immaterial Variance', 'Not In Scope' and 'Nil Value'.");
          this.requestcommentarydialog = false;
          if (this.bulksubmit) {
            this.loadContent(true);
          }
          else {
            this.commentarycycledata.local_ru_approve = false;
            this.commentarycycledata.regional_ru_approve = false;
            this.commentarydata[this.selectedcommentary.__key].stage_local = 0;
            this.commentarydata[this.selectedcommentary.__key].requestsubmit = true;
            if (this.requestcommentarylocalcontrolvsProforma) {
              this.commentarydata[this.selectedcommentary.__key].var1_cross_control = true;
            }
            if (this.requestcommentarylocalcontrolvsForecast) {
              this.commentarydata[this.selectedcommentary.__key].var2_cross_control = true;
            }
            if (this.requestcommentarylocalmanagementvsProforma) {
              this.commentarydata[this.selectedcommentary.__key].var1_cross_management = true;
            }
            if (this.requestcommentarylocalmanagementvsForecast) {
              this.commentarydata[this.selectedcommentary.__key].var2_cross_management = true;
            }
            if (this.isregionalapprover) {
              this.commentarydata[this.selectedcommentary.__key].stage_regional = 0;
              this.commentarydata[this.selectedcommentary.__key].requestsubmit = true;
              if (this.requestcommentaryregionalcontrolvsProforma) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_control_regional = true;
              }
              if (this.requestcommentaryregionalcontrolvsForecast) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_control_regional = true;
              }
              if (this.requestcommentaryregionalmanagementvsProforma) {
                this.commentarydata[this.selectedcommentary.__key].var1_cross_management_regional = true;
              }
              if (this.requestcommentaryregionalmanagementvsForecast) {
                this.commentarydata[this.selectedcommentary.__key].var2_cross_management_regional = true;
              }
            }
            this.loadContent(true);
          }
        }
        else throw new Error(dt.data.message || "Error requesting commentary");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.requestcommentaryloading = false;
      })
    }
  },
  /**
   * Validates selected GLs for bulk approval eligibility
   * Uses RU-level flags (bulkapprove_control, bulkapprove_management) and GL-level threshold flags
   * 
   * @param {string} role - 'approver' for local, 'regionalapprover' for regional
   * @returns {Object} - { valid: boolean, invalidGLs: Array, errorMessage: string }
   */
  validateBulkApproveSelection(role) {
    // Get selected GL objects from commentarydata using multiselectdata IDs
    const selectedGLs = this.multiselectdata
      .map(id => this.commentarydata.find(item => item._id === id))
      .filter(Boolean);

    if (selectedGLs.length === 0) {
      return {
        valid: false,
        invalidGLs: [],
        errorMessage: 'No valid GLs selected for bulk approval',
      };
    }

    // Get RU configuration for bulk approve flags
    const reportingUnit = {
      bulkapprove_control: Boolean(this.commentaryrudata?.bulkapprove_control || this.isbulkapprovalcrosscontrolenabled),
      bulkapprove_management: Boolean(this.commentaryrudata?.bulkapprove_management || this.isbulkapprovalmanagementcontrolenabled),
    };

    // Validate using the utility function
    const validationResult = validateBulkApprove(selectedGLs, reportingUnit, role);

    return validationResult;
  },
  approveCommentary() {
    this.commentaryloading = true;
    let url = "/v3/varianceanalysis/analysis/approvecommentary";
    let id = this.selectedcommentary._id;
    let dta = {};
    let role = 'approver'
    if (this.isregionalapprover) {
      role = 'regionalapprover'
    }

    // ===== BULK APPROVE VALIDATION =====
    // Validate selected GLs before making API call for bulk operations
    if (this.bulksubmit) {
      const validationResult = this.validateBulkApproveSelection(role);
      if (!validationResult.valid) {
        this.$store.commit('sbError', validationResult.errorMessage);
        // Log invalid GLs for debugging
        if (validationResult.invalidGLs && validationResult.invalidGLs.length > 0) {
          console.warn('[helpers]: Bulk approve validation failed. Invalid GLs:', 
            validationResult.invalidGLs.map(item => ({
              code: item.glCode,
              reason: item.reason
            }))
          );
        }
        this.commentaryloading = false;
        return;
      }
    }

    if (this.bulksubmit) {
      id = this.multiselectdata;
      url = "/v3/varianceanalysis/analysis/approvebulkcommentary"
      if (this.bulktype === 'approvelocal') { dta = { approvereason: this.selectedcommentary.approvereason } }
      else if (this.isregionalapprover) { dta = { regionalapprovereason: this.selectedcommentary.regionalapprovereason } }
    } else {
      if (this.commentarytype === 'approvelocal') dta = { approvereason: this.selectedcommentary.approvereason };
      else if (this.isregionalapprover) dta = { regionalapprovereason: this.selectedcommentary.regionalapprovereason };
    }
    let performregional = false;
    // Build filter with optional reporting_type for Balance Sheet
    const approveFilter = { 
      cycletype: this.cycletype, 
      level: (this.commentarytype === 'approvelocal') ? 'local' : 'regional', 
      reportingunit: (this.toggleview === 3) ? this.commentarycycledatalist[this.selectedcommentary.cycle]?.reportingunit_detail?._id : this.selectedreportingunit, 
      period: (this.toggleview === 3) ? this.commentarycycledatalist[this.selectedcommentary.cycle]?.period : this.selectedperiod 
    };
    if (this.reportingType) {
      approveFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { id: id, role: role, filter: approveFilter, data: dta }).then(dt => {
      if (dt.data.status === "success") {
        this.commantorydialog = false;
        if (this.bulksubmit) {
          this.$store.commit("sbSuccess", "Bulk commentary approved");
          this.loadContent(true);
        }
        else {
          this.$store.commit("sbSuccess", "Commentary approved");
          if (this.commentarytype === "approvelocal") {
            // Check for flag and proceed for auto regional commentary approval flow
             if (this.isRegionalCommentaryAutomationEnabled) {
              // Set stage_regional to 1 (awaiting approval) as backend has submitted regional commentary
              this.commentarydata[this.selectedcommentary.__key].stage_regional = 1;
            } else if (this.selectedcommentary.stage_regional === 0) {
              performregional = true;
            }
            this.commentarydata[this.selectedcommentary.__key].stage_local = 2;
            this.commentarydata[this.selectedcommentary.__key].approvereason = this.selectedcommentary.approvereason;
            this.commentarydata[this.selectedcommentary.__key].regionalcommentary1 = this.selectedcommentary.regionalcommentary1 || '';
            this.commentarydata[this.selectedcommentary.__key].regionalcommentary2 = this.selectedcommentary.regionalcommentary2 || '';
            this.commentarydata[this.selectedcommentary.__key].approvereason = this.selectedcommentary.approvereason;
          } else {
            this.commentarydata[this.selectedcommentary.__key].stage_regional = 2;
            this.commentarydata[this.selectedcommentary.__key].regionalapprovereason = this.selectedcommentary.regionalapprovereason;
          }
        }
        if (this.toggleview === 3) {
          this.loadMultipleReportingUnit()
        }
        this.$nextTick(() => {
          if (performregional) this.openSubmitDialog(this.commentarydata[this.selectedcommentary.__key], 'addregional')
        })
      }
      else throw new Error(dt.data.message || "Error approving commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.commentaryloading = false;
    })
  },
  /**
   * Reject commentary - handles both single and bulk rejection
   * @param {string} rejectTarget - The rejection target ('local_approver' or 'local_preparer') for regional approver rejections
   */
  rejectCommentary(rejectTarget) {
    this.commentaryloading = true;
    let url = "/v3/varianceanalysis/analysis/rejectcommentary";
    let id = this.selectedcommentary._id;
    let dta = {};
    let role = 'approver'
    if (this.isregionalapprover) role = "regionalapprover"

    // ===== BULK REJECT VALIDATION =====
    // Validate selected GLs before making API call for bulk operations
    if (this.bulksubmit) {
      const validationResult = this.validateBulkApproveSelection(role);
      if (!validationResult.valid) {
        this.$store.commit('sbError', validationResult.errorMessage);
        // Log invalid GLs for debugging
        if (validationResult.invalidGLs && validationResult.invalidGLs.length > 0) {
          console.warn('[helpers]: Bulk reject validation failed. Invalid GLs:', 
            validationResult.invalidGLs.map(item => ({
              code: item.glCode,
              reason: item.reason
            }))
          );
        }
        this.commentaryloading = false;
        return;
      }
    }

    if (this.bulksubmit) {
      id = this.multiselectdata;
      url = "/v3/varianceanalysis/analysis/rejectbulkcommentary"
      if (this.bulktype === 'approvelocal') { dta = { rejectreason: this.selectedcommentary.approvereason } }
      else if (this.isregionalapprover) { dta = { rejectreason: this.selectedcommentary.regionalapprovereason, rejection_target: rejectTarget } }
    } else {
      if (this.commentarytype === 'approvelocal') dta = { rejectreason: this.selectedcommentary.approvereason };
      else if (this.isregionalapprover) dta = { rejectreason: this.selectedcommentary.regionalapprovereason, rejection_target: rejectTarget };
    }
    // Build filter with optional reporting_type for Balance Sheet
    const rejectFilter = { 
      cycletype: this.cycletype, 
      level: (this.commentarytype === 'approvelocal') ? 'local' : 'regional', 
      reportingunit: (this.toggleview === 3) ? this.commentarycycledatalist[this.selectedcommentary.cycle]?.reportingunit_detail?._id : this.selectedreportingunit, 
      period: (this.toggleview === 3) ? this.commentarycycledatalist[this.selectedcommentary.cycle]?.period : this.selectedperiod 
    };
    if (this.reportingType) {
      rejectFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { id: id, role: role, filter: rejectFilter, data: dta }).then(dt => {
      if (dt.data.status === "success") {
        this.commantorydialog = false;
        if (this.bulksubmit) {
          this.$store.commit("sbSuccess", "Bulk commentary rejected");
          this.loadContent(true);
        }
        else {
          this.$store.commit("sbSuccess", "Commentary rejected");
          if (this.commentarytype === "approvelocal") {
            this.commentarydata[this.selectedcommentary.__key].stage_local = -1;
            this.commentarydata[this.selectedcommentary.__key].rejectreason = this.selectedcommentary.approvereason;
          } else {
            this.commentarydata[this.selectedcommentary.__key].stage_regional = -1;
            this.commentarydata[this.selectedcommentary.__key].regionalrejectreason = this.selectedcommentary.regionalapprovereason;
          }
        }
        if (this.toggleview === 3) {
          this.loadMultipleReportingUnit()
        }
      }
      else throw new Error(dt.data.message || "Error rejecting commentary");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.commentaryloading = false;
    })
  },
  setapprovelocalids(d) {
    this.selectedlocalapproval = d;
  },
  setapproveregionalids(d) {
    this.selectedregionalapproval = d;
  },
  setReportingUnitsForMailReminder(reportingUnits) {
    this.reportingUnitsForMailReminder = reportingUnits;
  },
  // addComment() {
  //   this.commentsloading = true;
  //   let data = {comment: this.commentsdata, data: this.selectedcommentary._id || ''}
  //   if(this.commentslevel === "ru") data = {comment: this.commentsdata, data: this.selectedreportingunit || ''};
  //   this.axios.post("/v3/varianceanalysis/analysis/addcomment", {filter: {level: this.commentslevel}, data: [data]}).then(dt => {
  //     if(dt.data.status === "success"){
  //       if(dt.data.data.length > 0){
  //         this.$store.commit("sbSuccess", "Comment Added");
  //         if(this.commentslevel === "ru"){
  //           this.commentarymetadata.comments = this.commentarymetadata.comments || [];
  //           this.commentarymetadata.comments.push(dt.data.data[0]);
  //         }else{
  //           this.selectedcommentary.comments = this.selectedcommentary.comments || [];
  //           this.selectedcommentary.comments.push(dt.data.data[0]);
  //           this.addeditresponseheader = this.selectedcommentary;
  //         }
  //         this.commentsdata='';
  //         this.commentserror='';
  //       }else throw new Error ("error adding comment");
  //     }else{
  //       if (dt.data.data.length > 0){
  //         if(dt.data.data[0].index0) this.addeditinforownererror = dt.data.data[0].index0;
  //       }
  //       throw new Error (dt.data.message);
  //     }
  //   }).catch(err => {
  //     this.$store.commit("sbError", err.message || err || "Unknown error!");
  //     console.log(err);
  //   }).finally(() => {
  //     this.commentsloading = false;
  //   })
  // },
  // markCommentAsRead(x, level) {
  //   if((x.comments || []).length > 0){
  //     let commentkey = x.comments.length -1;
  //     let comment = x.comments[commentkey]; 
  //     let nid = x._id;
  //     if(level === "ru") nid = this.selectedreportingunit;
  //     if((comment.readby || []).indexOf(this.$store.state.user.id) === -1){
  //       this.axios.post("/v3/varianceanalysis/analysis/markcommentasread/"+nid, {filter: {level: level}}).then(dt => {
  //         if(dt.data.status === "success" && dt.data.response.nModified > 0){
  //           this.selectedcommentary.comments[commentkey].readby.push(this.$store.state.user.id);
  //         }else throw new Error (dt.data.message);
  //       }).catch(err => {
  //         this.$store.commit("sbError", err.message || err || "Unknown error!");
  //         console.log(err);
  //       }).finally(() => {
  //         this.commentsloading = false;
  //       })
  //     }
  //   }
  // },
  getTrend(gl) {
    this.commentaryloading = true;
    this.perioddata = [];
    this.trendchartdataset = [];
    // console.log(this.commentarycycledatalist[this.selectedcommentary.cycle]);
    const clientId = this.$store?.state?.client || this.$store?.state?.user?.client || '';
    // Build filter with optional reporting_type for Balance Sheet
    const trendFilter = {
      cycletype: this.cycletype,
      glcode: gl,
      year: this.selectedyear,
      period: this.selectedperiod,
      reportingunit: (this.toggleview === 3)
        ? this.commentarycycledatalist[this.selectedcommentary.cycle]?.reportingunit_detail?._id
        : this.selectedreportingunit,
    };
    if (this.reportingType) {
      trendFilter.reporting_type = this.reportingType;
    }
    const payload = {
      filter: trendFilter,
    };

    if (clientId) {
      payload.client = clientId;
    }

    this.axios.post("/v3/varianceanalysis/analysis/gettrend/", payload).then(dt => {
      if (dt.data.status === "success") {
        let trenddata = [];
        let months = [];
        let trendchartdata = {};
        // Custom colors: Forecast-#4285F4, Actual-#00C2C2, Proforma-#8EA0B4
        let colors = ["#00C2C2", "#8EA0B4", "#4285F4"];
        let head1 = this.cycletype;
        let head2 = "Proforma";
        let head3 = (this.cycletype === 'Actual') ? 'Forecast' : 'Previous Forecast';

        for (const i of dt.data.data) {
          months.push((i.period_detail || {}).name);
          trenddata.push({ number: (i.period_detail || {}).number, name: (i.period_detail || {}).name, amount1: i.amount1, amount2: i.amount2, amount3: i.amount3, amount1heading: head1, amount2heading: head2, amount3heading: head3 })
          trendchartdata[head1] = trendchartdata[head1] || { label: head1, data: [], backgroundColor: colors[0], borderColor: colors[0] };
          trendchartdata[head1].data.push(i.amount1.toFixed(0) || 0);
          trendchartdata[head2] = trendchartdata[head2] || { label: head2, data: [], backgroundColor: colors[1], borderColor: colors[1] };
          trendchartdata[head2].data.push(i.amount2.toFixed(0) || 0);
          trendchartdata[head3] = trendchartdata[head3] || { label: head3, data: [], backgroundColor: colors[2], borderColor: colors[2] };
          trendchartdata[head3].data.push(i.amount3.toFixed(0) || 0);
        }
        if (trendchartdata[head2]) this.trendchartdataset.push(trendchartdata[head2]);
        if (trendchartdata[head1]) this.trendchartdataset.push(trendchartdata[head1]);
        if (trendchartdata[head3]) this.trendchartdataset.push(trendchartdata[head3]);
        // Mixed bar + line chart
        const mixedDatasets = [];
        this.trendchartdataset.forEach((ds) => {
          mixedDatasets.push({
            ...ds,
            type: 'bar',
            order: 2
          });
          if (ds.label === head1) {
            mixedDatasets.push({
              ...ds,
              type: 'line',
              fill: false,
              tension: 0.25,
              borderWidth: 2,
              pointRadius: 3,
              pointBackgroundColor: '#193541',
              pointBorderColor: '#193541',
              borderColor: '#193541',
              order: 1
            });
          }
        });

        const chartconfig = {
          type: 'line',
          data: {
            labels: months,
            datasets: mixedDatasets
          },
          options: {
            responsive: true,
            interaction: {
              mode: 'index',
              intersect: false
            },
            scales: {
              x: {
                stacked: false,
                grid: {
                  display: true,
                  drawOnChartArea: true,
                  drawTicks: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              },
              y: {
                stacked: false,
                beginAtZero: true,
                grid: {
                  display: true,
                  drawOnChartArea: true,
                  drawTicks: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            },
            plugins: {
              legend: {
                position: 'top',
                labels: {
                  filter: function(item, data) {
                    const dataset = data.datasets[item.datasetIndex];
                    return dataset.type !== 'line';
                  }
                },
                onClick: (e, legendItem, legend) => {
                  const ci = legend.chart;
                  const label = legendItem.text;
                  const isVisible = ci.isDatasetVisible(legendItem.datasetIndex);
                  ci.data.datasets.forEach((ds, i) => {
                    if (ds.label === label) {
                      if (isVisible) {
                        ci.hide(i);
                      } else {
                        ci.show(i);
                      }
                    }
                  });
                }
              },
              title: {
          display: true,
          text: ''
              },
              tooltip: {
                filter: function (tooltipItem) {
                  return tooltipItem.dataset.type === 'line' || tooltipItem.dataset.label !== head1;
                },
                callbacks: {
                  label: (ctx) => {
                    const v = ctx.parsed.y;
                    return `${ctx.dataset.label}: ${this.$nova.formatNumber(v)}`;
                  }
                }
              }
            }
          }
        };
        const targetId = this.trendchartElementId || 'trendchart';
        const canvasEl = typeof document !== 'undefined' ? document.getElementById(targetId) : null;
        if (!canvasEl) {
          console.warn(`[${this.$options?.name || 'CommentaryDialog'}]: trend chart canvas missing for id`, targetId);
          this.trendchart = null;
          return;
        }
        if (this.trendchart && typeof this.trendchart.destroy === 'function') {
          this.trendchart.destroy();
        }
        this.trendchart = new Chart(canvasEl, chartconfig);
      }
      else throw new Error(dt.data.message || "Error fetching data");
    }).catch(err => {
      const errorMessage = err.message || err || "Unknown error!";
      // Don't show error toast for "request not found" - it just means no trendline data exists
      if (errorMessage.toLowerCase().includes('request not found') || errorMessage.toLowerCase().includes('not found')) {
        console.warn('[getTrend]: No trendline data available for the selected parameters');
      } else {
        this.$store.commit("sbError", errorMessage);
        console.error('[getTrend]:', err);
      }
    }).finally(() => {
      this.commentaryloading = false;
    })
  },
  loadPeriod() {
      // API call disabled as requested
      // The application will rely on locally available period data only
      
      this.perioddata = this.periodDataList[this.selectedrole]?.[this.selectedyear]?.perioddata || [];
      if (this.perioddata.length === 1) {
          this.selectedregion = this.perioddata[0]?._id;
          //this.setFilter('selectedperiod', this.perioddata[0]?._id);
      }
      this.lastUpdatedAt = this.periodDataList[this.selectedrole]?.[this.selectedyear]?.actual_period_updated_at || "";
      this.loading = false;
      this.isReportingUnitdataloading = false;
      return Promise.resolve();
  },
  // loadNetwork(reload = false, sync = 'false', synctype = 'automatic') {
  //   this.loading = true;
  //   // this.networkdata = [];
  //   if (typeof (this.networkList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]) === 'undefined' || reload || sync) {
  //     // Build filter with optional reporting_type for Balance Sheet
  //     const networkFilter = { cycletype: this.cycletype, year: this.selectedyear, role: this.selectedrole, period: this.selectedperiod, region: this.selectedregion, country: this.selectedcountry, reportingunit: this.selectedreportingunit, sync_type: synctype, type: 'network' };
  //     if (this.reportingType) {
  //       networkFilter.reporting_type = this.reportingType;
  //     }
  //     return this.axios.post("/v3/varianceanalysis/analysis/getcommentary_analytics/", { filter: networkFilter }).then(dt => {
  //       if (dt.data.status === "success") {
  //         this.networkdata = dt.data.data || [];
  //         this.lastUpdatedAt = this.toISOConverter(dt.data.actual_network_updated_at || dt.data.forecast_network_updated_at)
  //         // if(this.networkdata.length === 1){
  //         //   //this.selectednetwork = this.networkdata[0]?._id;
  //         //  // this.setFilter('selectednetwork', this.networkdata[0]?._id);
  //         // }
  //         this.storeFilteredData(this.networkdata, true, 'network', this.lastUpdatedAt)
  //       }
  //       else throw new Error(dt.data.message || "Error fetching data");
  //     }).catch(err => {
  //       this.$store.commit("sbError", err.message || err || "Unknown error!");
  //       console.log(err);
  //     }).finally(() => {
  //       this.loading = false;
  //     })
  //   } else {
  //     this.networkdata = this.networkList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod].networkdata || [];
  //     // if(this.networkdata.length === 1){
  //     //   // this.selectednetwork = this.networkdata[0]?._id;
  //     //   //this.setFilter('selectednetwork', this.networkdata[0]?._id);
  //     // }
  //     this.lastUpdatedAt = this.networkList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod].actual_network_updated_at
  //     this.loading = false
  //   }
  // },
  loadRegion(reload = false, time) {
    this.loading = true;
    // this.regiondata = [];
    if (typeof (this.regionList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]?.[this.selectednetwork]) === 'undefined' || reload) {
      // Build filter with optional reporting_type for Balance Sheet
      const regionFilter = { cycletype: this.cycletype, year: this.selectedyear, role: this.selectedrole, network: this.selectednetwork, period: this.selectedperiod, country: this.selectedcountry, reportingunit: this.selectedreportingunit };
      if (this.reportingType) {
        regionFilter.reporting_type = this.reportingType;
      }
      return this.axios.post("/v3/varianceanalysis/analysis/getregiondata/", { filter: regionFilter }).then(dt => {
        if (dt.data.status === "success") {
          this.regiondata = dt.data.data || [];
          if (this.regiondata.length === 1) {
            this.selectedregion = this.regiondata[0]?._id;
            this.setFilter('selectedregion', this.regiondata[0]?._id);
          }
          this.storeFilteredData(this.regiondata, true, 'region', time)
          this.lastUpdatedAt = time
        }
        else throw new Error(dt.data.message || "Error fetching data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.loading = false;
        this.isReportingUnitdataloading = false;
      })
    } else {
      this.regiondata = this.regionList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]?.[this.selectednetwork].regiondata || [];
      if (this.regiondata.length === 1) {
        this.selectedregion = this.regiondata[0]?._id;
        this.setFilter('selectedregion', this.regiondata[0]?._id);
      }
      this.loading = false;
      this.isReportingUnitdataloading = false;
    }
  },
  loadCountry(reload = false) {
    //this.loading = true;
    // this.countrydata = [];
    if (typeof (this.countrylist[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]?.[this.selectednetwork]?.[this.selectedregion]?.countrydata) === 'undefined' || reload) {
      // Build filter with optional reporting_type for Balance Sheet
      const countryFilter = { cycletype: this.cycletype, year: this.selectedyear, role: this.selectedrole, network: this.selectednetwork, region: this.selectedregion, period: this.selectedperiod, reportingunit: this.selectedreportingunit, country: this.selectedcountry };
      if (this.reportingType) {
        countryFilter.reporting_type = this.reportingType;
      }
      return this.axios.post("/v3/varianceanalysis/analysis/getcountrydata/", { filter: countryFilter }).then(dt => {
        if (dt.data.status === "success") {
          this.countrydata = dt.data.data || [];
          if (this.countrydata.length === 1) {
            this.selectedcountry = this.countrydata[0]?._id;
            this.setFilter('selectedcountry', this.countrydata[0]?._id);
          }
          this.storeFilteredData(this.countrydata, true, 'country')
        }
        else throw new Error(dt.data.message || "Error fetching data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.loading = false;
        this.isReportingUnitdataloading = false;
      })
    } else {
      this.countrydata = this.countrylist[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]?.[this.selectednetwork]?.[this.selectedregion].countrydata || [];
      if (this.countrydata.length === 1) {
        this.selectedcountry = this.countrydata[0]?._id;
        this.setFilter('selectedcountry', this.countrydata[0]?._id);
      }
      this.loading = false;
      this.isReportingUnitdataloading = false;
    }
  },
  /**
   * Load reporting units with pagination support
   * @param {boolean} reload - Force reload data from API
   * @param {boolean} loadmoredata - Load more data (infinite scroll)
   * @param {number|null} pageIndex - Explicit page index for server-side pagination (0-based)
   */
  async loadReportingUnit(reload = false, loadmoredata = false, pageIndex = null, extraFilters = {}) {
    if (!this.selectedperiod) {
      return;
    }

    const requestYear = this.selectedyear;
    const requestPeriod = this.selectedperiod;
    const requestRole = this.selectedrole;
    const requestNetwork = this.selectednetwork;
    const requestRegion = this.selectedregion;
    const requestCountry = this.selectedcountry;
    // Get type: 1) from Filter component ref, 2) from Vuex store, 3) fallback to 'all'
    const vaStore = this.$store?.state?.varianceanalysis || {};
    const storeType = this.cycletype === 'Forecast'
      ? vaStore.forecastfilter?.selectedReportingUnitType
      : vaStore.actualfilter?.selectedReportingUnitType;
    const filterComponentType = this.$refs?.childfilter?.selectedReportingUnitType;
    const requestType = filterComponentType || storeType || 'all';

    const filters = {
      cycletype: this.cycletype,
      year: requestYear,
      role: requestRole,
      network: requestNetwork,
      region: requestRegion,
      country: requestCountry,
      period: requestPeriod || '',
      type: requestType,
      ...extraFilters,
    };

    const cachedSnapshot = this.$store.getters['varianceanalysis/reportingUnitList/getNodeByFilters'](filters);
    
    // IMPORTANT: If we have extra filters (custom table filters), we must ignore the cache
    // because cache keys typically only include standardized filters (year, period, role, etc)
    // and might not account for transient table column filters.
    // If cache key logic was updated to include all properties of filters object, then this isn't needed.
    // But to be safe and ensure filters apply, force fetch.
    const hasExtraFilters = extraFilters && Object.keys(extraFilters).length > 0;

    const hasCachedData = !hasExtraFilters && Array.isArray(cachedSnapshot.data) && cachedSnapshot.data.length > 0;
    // For explicit page navigation, always fetch
    const hasExplicitPage = Number.isInteger(pageIndex) && pageIndex >= 0;
    const shouldFetch = reload || loadmoredata || hasExplicitPage || !hasCachedData || hasExtraFilters;

    const pageSize = this.perpage || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE;
    this.reportingUnitRequestToken = (this.reportingUnitRequestToken || 0) + 1;
    const currentRequestToken = this.reportingUnitRequestToken;

    if (!shouldFetch) {
      this.storeFilteredData(cachedSnapshot.data, true, 'reportingunit', undefined, {
        replace: true,
        fullData: cachedSnapshot.data,
        hasMore: cachedSnapshot.hasMore,
        paginationPage: cachedSnapshot.paginationPage,
        totalCount: cachedSnapshot.totalCount,
      });
      this.reportingunitdata = [...cachedSnapshot.data];
      this.hasMoreReportingUnits = cachedSnapshot.hasMore;
      this.pagination_page = cachedSnapshot.paginationPage;
      // Set total count from cache for pagination
      this.reportingUnitsTotalCount = cachedSnapshot.totalCount || 0;
      this.processReportingUnitsForApproval();
      this.loading = false;
      this.isRUListLoading = false;
      this.isReportingUnitdataloading = false;
      return;
    }

    this.isReportingUnitdataloading = true;
    this.isRUListLoading = true;
    if (this.reportingunitdata.length === 0) {
      this.loading = true;
    }

    if (reload) {
      this.filterData = {};
      this.reportingunitdata = [];
      this.pagination_page = 0;
      this.isDataRefreshed = true;
      this.hasMoreReportingUnits = false;
    }

    try {   
      
      await this.$store.dispatch('varianceanalysis/reportingUnitList/fetchReportingUnits', {
        axiosInstance: this.axios,
        filters,
        perPage: pageSize,
        reload,
        loadMore: loadmoredata,
        page: hasExplicitPage ? pageIndex : null,
        limit: pageSize,
      });

      if (this.reportingUnitRequestToken !== currentRequestToken) {
        return;
      }

      const updatedNode = this.$store.getters['varianceanalysis/reportingUnitList/getNodeByFilters'](filters);
      const latestBatch = this.$store.getters['varianceanalysis/reportingUnitList/getLastBatchByFilters'](filters);
      // For explicit page navigation, always replace data
      const replaceData = reload || hasExplicitPage || !loadmoredata;

      this.storeFilteredData(replaceData ? updatedNode.data : latestBatch, replaceData, 'reportingunit', undefined, {
        replace: replaceData,
        fullData: updatedNode.data,
        hasMore: updatedNode.hasMore,
        paginationPage: updatedNode.paginationPage,
        totalCount: updatedNode.totalCount,
      });

      const targetNode = this.filterData[requestRole]?.[requestYear]?.[requestPeriod]?.[requestNetwork]?.[requestRegion]?.[requestCountry];
      if (targetNode) {
        targetNode.hasMore = updatedNode.hasMore;
        targetNode.pagination_page = updatedNode.paginationPage;
        targetNode.data = [...updatedNode.data];
        targetNode.totalCount = updatedNode.totalCount;
      }

      this.reportingunitdata = [...updatedNode.data];
      this.hasMoreReportingUnits = updatedNode.hasMore;
      this.pagination_page = updatedNode.paginationPage;
      // Set total count from dedicated count API for pagination
      this.reportingUnitsTotalCount = updatedNode.totalCount || 0;
      this.processReportingUnitsForApproval();
    } catch (error) {
      if (this.reportingUnitRequestToken === currentRequestToken) {
        console.error('[Reporting Unit] Failed to load data:', error);
      }
    } finally {
      this.isReportingUnitdataloading = false;
      this.isRUListLoading = false;
      this.isDataRefreshed = false;
      if (this.reportingunitdata.length === 0) {
        this.loading = false;
      }
    }
  },
  processReportingUnitsForApproval() {
    const userId = this.userid;
    try {
      this.islocalapproverinru = false;
      this.isregionalapproverinru = false;
      this.isMailRemainderRequired = false;
      this.reportingUnitsForMailReminder = [];
      for (const unit of this.reportingunitdata) {
        // Destructure properties to avoid repeated property access
        const { reportingunit_detail, pending_local_forecast = 0, pending_local_proforma = 0,
          pending_regional_forecast = 0, pending_regional_proforma = 0 } = unit;
        // Default to false
        unit.showMailReminderButton = false;
        // Check if user is a local approver and there are pending items
        if (reportingunit_detail?.approver?.includes(userId)) {
          this.islocalapproverinru = true;
          // Show button if there are pending items to approve
          if (pending_local_forecast + pending_local_proforma > 0) {
            unit.showMailReminderButton = true;
          }
        }
        // Check if user is a regional approver and there are pending items
        if (reportingunit_detail?.regional_approver?.includes(userId)) {
          this.isregionalapproverinru = true;
          // Show button if there are pending items to approve
          if (pending_regional_forecast + pending_regional_proforma > 0) {
            unit.showMailReminderButton = true;
          }
        }
        if (unit.showMailReminderButton) {
          this.isMailRemainderRequired = true;
        }
      }
    } catch (error) {
      console.error("Error processing reporting units for approval:", error);
      this.$store.commit("sbError", "Error processing reporting units for approval: " + error.message);
    }
  },
  loadData(reload = false) {
    // Cancel any pending getreportingunitdata request before starting a new one
    // Using AbortController (modern approach recommended by Axios)
    if (this.loadDataAbortController) {
      this.loadDataAbortController.abort();
    }

    // Increment request token to track this request
    this.loadDataRequestToken = (this.loadDataRequestToken || 0) + 1;
    const currentRequestToken = this.loadDataRequestToken;

    this.loading = true;
    this.isReportingUnitdataloading = true;
    this.multiselectdata = [];
    //this.$set(this.dataObject,this.loading,true)
    this.commentarydata = [];
    // this.commentarycycledata = {};
    // this.commentarysummarydata = {};
    this.isReportingUnitClicked = true,
      this.toggleview = 0
    if (typeof this.commentarydataList[this.selectedrole]?.[this.selectedyear]?.[this.selectedperiod]?.[this.selectednetwork]?.[this.selectedregion]?.[this.selectedcountry]?.[this.selectedreportingunit] === 'undefined' || reload) {
      this.isRequestinPendingState = true

      // Build filter object for API request
      const filter = { 
        cycletype: this.cycletype, 
        reportingunit: this.selectedreportingunit, 
        period: this.selectedperiod, 
        role: this.selectedrole, 
        type: this.requestType
      };
      // Build query params with optional reporting_type for Balance Sheet
      if (this.reportingType) {
        filter.reporting_type = this.reportingType;
      }
      // Create a new AbortController for this request (modern cancellation approach)
      this.loadDataAbortController = new AbortController();
      const signal = this.loadDataAbortController.signal;

      return this.apiGet("/v3/varianceanalysis/analysis/getreportingunitdata/", filter, { signal }).then((dt) => {
        // Check if this is still the current request before processing response
        if (this.loadDataRequestToken !== currentRequestToken) {
          return;
        }
        if (dt.data.status === "success") {
          let fdt = dt.data.data[0] || {};
          this.commentarydatajson = {};
          this.commentarydatajsonById = {}
          this.commentarydatajsonByGLCode = {};
          this.commentaryrudata = fdt.reportingunit || {};
          this.isRegionalCommentaryAutomationEnabled = this.commentaryrudata?.auto_regional_commentary_submission_enabled || false;
          this.isSodEnabled = this.commentaryrudata?.sod_enabled !== false;
          this.reportingUnitType = this.commentaryrudata.type || '';
          this.workflowtext = [];
          this.workflows = { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true, "lcp_bs": true, "lmp_bs": true, "rcp_bs": true, "rmp_bs": true, "lcf_bs": true, "lmf_bs": true, "rcf_bs": true, "rmf_bs": true, "islocalenabled": true, "isregionalenabled": true, "islocalproformaenabled": true, "islocalforecastenabled": true, "isregionalproformaenabled": true, "isregionalforecastenabled": true, "isworkflowsenabled": true };
          if (!this.commentaryrudata.localcontrol_proforma) {
            this.workflows['lcp'] = false
            this.workflowtext.push("Local control proforma")
          }
          if (!this.commentaryrudata.localmanagement_proforma) {
            this.workflows['lmp'] = false
            this.workflowtext.push("Local management proforma")
          }
          if (!this.commentaryrudata.regionalcontrol_proforma) {
            this.workflows['rcp'] = false
            this.workflowtext.push("Regional control proforma")
          }
          if (!this.commentaryrudata.regionalmanagement_proforma) {
            this.workflows['rmp'] = false
            this.workflowtext.push("Regional management proforma")
          }
          if (!this.commentaryrudata.localcontrol_forecast) {
            this.workflows['lcf'] = false
            this.workflowtext.push("Local control forecast")
          }
          if (!this.commentaryrudata.localmanagement_forecast) {
            this.workflows['lmf'] = false
            this.workflowtext.push("Local management forecast")
          }
          if (!this.commentaryrudata.regionalcontrol_forecast) {
            this.workflows['rcf'] = false
            this.workflowtext.push("Regional control forecast")
          }
          if (!this.commentaryrudata.regionalmanagement_forecast) {
            this.workflows['rmf'] = false
            this.workflowtext.push("Regional management forecast")
          }
          // Balance Sheet Workflows
          if (!this.commentaryrudata.localcontrol_proforma_bs) {
            this.workflows['lcp_bs'] = false
            this.workflowtext.push("Local control proforma bs")
          }
          if (!this.commentaryrudata.localmanagement_proforma_bs) {
            this.workflows['lmp_bs'] = false
            this.workflowtext.push("Local management proforma bs")
          }
          if (!this.commentaryrudata.regionalcontrol_proforma_bs) {
            this.workflows['rcp_bs'] = false

            this.workflowtext.push("Regional control proforma bs")
          }
          if (!this.commentaryrudata.regionalmanagement_proforma_bs) {
            this.workflows['rmp_bs'] = false

            this.workflowtext.push("Regional management proforma bs")
          }
          if (!this.commentaryrudata.localcontrol_forecast_bs) {
            this.workflows['lcf_bs'] = false

            this.workflowtext.push("Local control forecast bs")
          }
          if (!this.commentaryrudata.localmanagement_forecast_bs) {
            this.workflows['lmf_bs'] = false
            this.workflowtext.push("Local management forecast bs")
          }
          if (!this.commentaryrudata.regionalcontrol_forecast_bs) {
            this.workflows['rcf_bs'] = false
            this.workflowtext.push("Regional control forecast bs")
          }
          if (!this.commentaryrudata.regionalmanagement_forecast_bs) {
            this.workflows['rmf_bs'] = false
            this.workflowtext.push("Regional management forecast bs")
          }
          this.setWorkflows();
          this.storeFilteredData(dt.data.data[0], reload, 'reportingunitdata')
          for (const i of fdt.data) {
            this.commentarydatajson[i.glcode] = i;
            this.commentarydatajsonById[i._id] = i;
            this.commentarydatajsonByGLCode[i.glcode_detail.code] = i;
            i.amount1 = i.amount1 || 0;
            i.amount2 = i.amount2 || 0;
            i.amount3 = i.amount3 || 0;
            i.varianceamount1 = i.varianceamount1 || 0;
            i.varianceamount2 = i.varianceamount2 || 0;
            i.variancepercent1 = i.variancepercent1 || 0;
            i.variancepercent2 = i.variancepercent2 || 0;
            i.glcode_detail = i.glcode_detail || {};
          }

          this.commentarycycledata = fdt.cycle || {};
          if (this.workflows.islocalenabled) {
            this.ispendinglocalruapproval = !(this.commentarycycledata.local_ru_approve || false);
          }
          if (this.workflows.isregionalenabled) {
            this.ispendingregionalruapproval = !(this.commentarycycledata.regional_ru_approve || false);
          }
          this.allgls = fdt.gllist || [];
          this.commentarysummarydata = fdt.summary || {};
          this.processCommentaryFlag();
          this.commentarydata = fdt.data || [];
          const { selectedreportingunit } = this
          this.isbulkapprovalcrosscontrolenabled = fdt.reportingunit?.bulkapprove_control;
          this.isbulkapprovalmanagementcontrolenabled = fdt.reportingunit?.bulkapprove_management;
          //this.$set(this.commentarydataList, selectedreportingunit, {'commentarycycledata':this.commentarycycledata,'commentaryrudata':this.commentaryrudata,'allgls':this.allgls,'commentrycycledata':this.commentarycycledata, 'commentarydata':this.commentarydata,'commentarysummarydata':this.commentarysummarydata,'commentarydatajson':this.commentarydatajson});
          this.$set(this.commentarydataList, selectedreportingunit, { 'fdt': fdt })
        }
        else throw new Error(dt.data.message || "Error fetching data");
      }).catch(err => {
        // Check if request was cancelled/aborted - don't show error for cancelled requests
        // AbortController throws error with name 'AbortError' or 'CanceledError' (axios wraps it)
        if (err.name === 'AbortError' || err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
          return; // Don't process cancelled requests
        }
        // Only process errors for the current request
        if (this.loadDataRequestToken !== currentRequestToken) {
          return;
        }
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        // Only clear loading state if this is still the current request
        if (this.loadDataRequestToken !== currentRequestToken) {
          return;
        }
        this.loading = false;
        //this.$set(this.dataProperty,this.loading,false)
        this.computeMultiRoleUsers();
        this.isRequestinPendingState = false
        this.isReportingUnitdataloading = false;
        // Clear the AbortController after request completes
        this.loadDataAbortController = null;
      })
    } else {
      let fdt = this.commentarydataList[this.selectedrole][this.selectedyear][this.selectedperiod][this.selectednetwork][this.selectedregion][this.selectedcountry][this.selectedreportingunit].reportingunitdata || [];
      this.commentarydatajson = {};
      this.commentarydatajsonById = {};
      for (const i of fdt.data) {
        this.commentarydatajson[i.glcode] = i;
        this.commentarydatajsonById[i._id] = i;
        i.amount1 = i.amount1 || 0;
        i.amount2 = i.amount2 || 0;
        i.amount3 = i.amount3 || 0;
        i.varianceamount1 = i.varianceamount1 || 0;
        i.varianceamount2 = i.varianceamount2 || 0;
        i.variancepercent1 = i.variancepercent1 || 0;
        i.variancepercent2 = i.variancepercent2 || 0;
        i.glcode_detail = i.glcode_detail || {};
      }
      this.commentaryrudata = fdt.reportingunit || {};
      this.workflows = { "lcp": true, "lmp": true, "rcp": true, "rmp": true, "lcf": true, "lmf": true, "rcf": true, "rmf": true, "lcp_bs": true, "lmp_bs": true, "rcp_bs": true, "rmp_bs": true, "lcf_bs": true, "lmf_bs": true, "rcf_bs": true, "rmf_bs": true, "islocalenabled": true, "isregionalenabled": true, "islocalproformaenabled": true, "islocalforecastenabled": true, "isregionalproformaenabled": true, "isregionalforecastenabled": true, "isworkflowsenabled": true };
      this.workflowtext = [];
      if (!this.commentaryrudata.localcontrol_proforma) {
        this.workflows['lcp'] = false
        this.workflowtext.push("Local control proforma")
      }
      if (!this.commentaryrudata.localmanagement_proforma) {
        this.workflows['lmp'] = false
        this.workflowtext.push("Local management proforma")
      }
      if (!this.commentaryrudata.regionalcontrol_proforma) {
        this.workflows['rcp'] = false
        this.workflowtext.push("Regional control proforma")
      }
      if (!this.commentaryrudata.regionalmanagement_proforma) {
        this.workflows['rmp'] = false
        this.workflowtext.push("Regional management proforma")
      }
      if (!this.commentaryrudata.localcontrol_forecast) {
        this.workflows['lcf'] = false
        this.workflowtext.push("Local control forecast")
      }
      if (!this.commentaryrudata.localmanagement_forecast) {
        this.workflows['lmf'] = false
        this.workflowtext.push("Local management forecast")
      }
      if (!this.commentaryrudata.regionalcontrol_forecast) {
        this.workflows['rcf'] = false
        this.workflowtext.push("Regional control forecast")
      }
      if (!this.commentaryrudata.regionalmanagement_forecast) {
        this.workflows['rmf'] = false
        this.workflowtext.push("Regional management forecast")
      }
      // Balance Sheet Workflows
      if (!this.commentaryrudata.localcontrol_proforma_bs) {
        this.workflows['lcp_bs'] = false
        this.workflowtext.push("Local control proforma bs")
      }
      if (!this.commentaryrudata.localmanagement_proforma_bs) {
        this.workflows['lmp_bs'] = false
        this.workflowtext.push("Local management proforma bs")
      }
      if (!this.commentaryrudata.regionalcontrol_proforma_bs) {
        this.workflows['rcp_bs'] = false
        this.workflowtext.push("Regional control proforma bs")
      }
      if (!this.commentaryrudata.regionalmanagement_proforma_bs) {
        this.workflows['rmp_bs'] = false
        this.workflowtext.push("Regional management proforma bs")
      }
      if (!this.commentaryrudata.localcontrol_forecast_bs) {
        this.workflows['lcf_bs'] = false
        this.workflowtext.push("Local control forecast bs")
      }
      if (!this.commentaryrudata.localmanagement_forecast_bs) {
        this.workflows['lmf_bs'] = false
        this.workflowtext.push("Local management forecast bs")
      }
      if (!this.commentaryrudata.regionalcontrol_forecast_bs) {
        this.workflows['rcf_bs'] = false
        this.workflowtext.push("Regional control forecast bs")
      }
      if (!this.commentaryrudata.regionalmanagement_forecast_bs) {
        this.workflows['rmf_bs'] = false
        this.workflowtext.push("Regional management forecast bs")
      }
      this.setWorkflows();
      this.commentarycycledata = fdt.cycle || {};
      this.ispendinglocalruapproval = !(this.commentarycycledata.local_ru_approve || false);
      this.ispendingregionalruapproval = !(this.commentarycycledata.regional_ru_approve || false);
      this.allgls = fdt.gllist || [];
      this.commentarysummarydata = fdt.summary || {};
      this.processCommentaryFlag();
      this.commentarydata = fdt.data || [];
      this.loading = false
      this.isReportingUnitdataloading = false;
    }

  },
  loadMultipleReportingUnit() {
    this.loading = true;
    this.isReportingUnitdataloading = true;
    this.commentarycycledata = {};
    this.commentarycycledatalist = {};
    this.commentaryrudata = {};
    this.commentarydatajson = {};
    this.commentarydatajsonById = {}
    this.commentarydatajsonByGLCode = {};
    // this.allgls = {};
    this.commentarydata = [];
    this.workflowtext = [];
    // this.reportingunitdata = [];
    // Build filter with optional reporting_type for Balance Sheet
    const multiRuFilter = { cycletype: this.cycletype, year: this.selectedyear, role: this.selectedrole, network: this.selectednetwork, region: this.selectedregion, country: this.selectedcountry, period: this.selectedperiod };
    if (this.reportingType) {
      multiRuFilter.reporting_type = this.reportingType;
    }
    return this.axios.post("/v3/varianceanalysis/analysis/getmultiplereportingunitdata/", { filter: multiRuFilter }).then(dt => {
      if (dt.data.status === "success") {
        let fdt = dt.data.data[0] || {};
        this.isregionalapprover = true;
        this.cyclestage = 0;
        for (const i of fdt.data) {
            this.commentarydatajson[i.glcode] = i;
            this.commentarydatajsonById[i._id] = i;
            this.commentarydatajsonByGLCode[i.glcode_detail.code] = i;
            i.amount1 = i.amount1 || 0;
            i.amount2 = i.amount2 || 0;
            i.amount3 = i.amount3 || 0;
            i.varianceamount1 = i.varianceamount1 || 0;
            i.varianceamount2 = i.varianceamount2 || 0;
            i.variancepercent1 = i.variancepercent1 || 0;
            i.variancepercent2 = i.variancepercent2 || 0;
            i.glcode_detail = i.glcode_detail || {};
          }
        this.commentaryrudata = fdt.reportingunit || {};
        // console.log(fdt.cycle);
        if (fdt.cycle instanceof Array) {
          for (const i of fdt.cycle) {
            this.commentarycycledatalist[i._id] = i;
          }
        }
        else this.commentarycycledata = fdt.cycle || {};
        // console.log(this.commentarycycledatalist);
        this.allgls = fdt.gllist || [];
        this.commentarysummarydata = fdt.summary || {};
        this.processCommentaryFlag();
        this.isregionalapprover = true;
        this.commentarydata = fdt.data || [];
        this.ispendingregionalruapproval = !(this.commentarycycledata.regional_ru_approve || false);
      }
      else throw new Error(dt.data.message || "Error fetching data");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.loading = false;
      this.isReportingUnitdataloading = false;
    })
  },
  // updateCycle(type) {
  //   this.loading = true;
  //   let successflag = false;
  //   return this.axios.post("/v3/varianceanalysis/analysis/updatecommentarycycle/", {filter: {cycle: this.commentarycycledata._id, type: type}}).then(dt => {
  //     if(dt.data.status === "success") {
  //       this.$store.commit("sbSuccess", "Commentary cycle updated");
  //       successflag = true
  //     }
  //     else throw new Error (dt.data.message || "Error updating data");
  //   }).catch(err => {
  //     this.$store.commit("sbError", err.message || err || "Unknown error!");
  //     console.log(err);
  //   }).finally(() => {
  //     this.loading = false;
  //     if(successflag) this.loadData();
  //   })
  // },
  sendApprovalReminder() {
    this.loading = true;
    return this.axios.post("/v3/varianceanalysis/analysis/sendapproverreminder/" + this.selectedreportingunit).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Reminder mail sent to approver");
      }
      else throw new Error(dt.data.message || "Error sending mail");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.loading = false;
    })
  },
  sendSubmitterReminder() {
    this.loading = true;
    return this.axios.post("/v3/varianceanalysis/analysis/sendsubmitterreminder/" + this.selectedreportingunit).then(dt => {
      if (dt.data.status === "success") {
        this.$store.commit("sbSuccess", "Reminder mail sent to preparer");
      }
      else throw new Error(dt.data.message || "Error sending mail");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.loading = false;
    })
  },
  async getNetSalesData(d) {
    this.breakdownData = []; // Clear previous data
    this.expandedGroups = []; // Reset expanded groups
    this.clientbyclientdialog_netsales = true;
    this.clientbyclientloading_netsales = true;
    this.clientbyclientdata_netsales = [];
    this.max_netsales_revenue_dialog_width = 1400;
    const payload = {
    data: [{type: "netsales"}]
  };
  try {
    const netSalesBreakupResponse = await this.axios.post("/v3/varianceanalysis/analysis/getclientbreakdowndatabygroup/" + d.cycle, payload);
    if (netSalesBreakupResponse && netSalesBreakupResponse?.data && netSalesBreakupResponse?.data?.status === "success" && netSalesBreakupResponse?.data?.data.length) {
      this.breakdownData = this.reorganizeBreakdownData(netSalesBreakupResponse?.data?.data || []);
      // Currently, we are not expanding all groups by default. Maybe uncomment if needed.
      //this.expandAllGroups(); // Expand all groups by default
      this.netSalesViewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.GROUPED; // Set view mode to grouped by default
    }else{
      this.$store.commit("sbError", "No data found for the selected cycle.");
      this.netSalesViewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.UNGROUPED; // Reset view mode if no data
    }
  } catch (err) {
    this.$store.commit("sbError", "Failed to fetch client breakdown data.");
    this.netSalesViewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.UNGROUPED; // Reset view mode on error
  }
    return this.axios.post("/v3/varianceanalysis/analysis/getnetsales/"+d.cycle).then(dt => {
      if(dt.data.status === "success") {
        this.clientbyclientdata_netsales = dt.data.data || [];
        this.clientbyclientdata_netsales.forEach(item => {
          if (this.max_netsales_revenue_dialog_width !== 1800 && ((item.commentary1 && item.commentary1.length > 100) || (item.commentary2 && item.commentary2.length > 100))) {
            this.max_netsales_revenue_dialog_width = 1800;
          }
        })
        // filter clientbyclientdata_netsales whose cl_type is both "Total" and "Subtotal"
      this.clientbyclientdata_netsales = this.filterTotalSubTotals(this.clientbyclientdata_netsales);
      this.filteredClientbyClientDataNetSales = this.clientbyclientdata_netsales.map((data) => {
        return {
          ...data,
          actual_amount: this.$nova.formatDecimalToNumber(data.actual_amount,false,true),
          forecast_amount: this.$nova.formatDecimalToNumber(data.forecast_amount,false,true),
          proforma_amount: this.$nova.formatDecimalToNumber(data.proforma_amount,false,true),
          actual_vs_proforma_variance_amount: this.$nova.formatDecimalToNumber(data.actual_vs_proforma_variance_amount,false,true),
          actual_vs_forecast_variance_amount: this.$nova.formatDecimalToNumber(data.actual_vs_forecast_variance_amount,false,true),
        };
      }).sort((a, b) => (b.actual_amount || 0) - (a.actual_amount || 0));
      }
      else throw new Error("Error fetching breakup");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.clientbyclientloading_netsales = false;
    })
  },
  filterTotalSubTotals(ungroupedDetails) {
    try {
      if (ungroupedDetails && Array.isArray(ungroupedDetails)) {
        let filteredData = ungroupedDetails.filter(item => {
          const code = item?.cl_code?.toLowerCase() || '';
          // Only filter out LOCTOT if NOT soxid or group_m
          if (!this.isSpecialRu && code === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.LOCTOT.toLowerCase()) {
            return false;
          }
           // Always filter out DESTOT, CLITOT, TOTCLI
          return code !== varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.DESTOT.toLowerCase() &&
            code !== varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.CLITOT.toLowerCase() &&
            code !== varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.TOTCLI.toLowerCase();
        });
        return filteredData;
      }
      return [];
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  reorganizeBreakdownData(data) {
    try {
      if (!Array.isArray(data) || data.length === 0) return data;
      // sort desc each item's documents by actual_amount
      this.sortDocumentsByActualAmount(data);
      const reorganizedData = [...data];
      const subtotalItem = reorganizedData.find(item => item._id && item._id.toLowerCase() === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.SUBTOTAL.toLowerCase());
      const idToClCodeMap = varianceAnalysisConstants.idToClCodeMap || {};
      this.mapSubtotalsToItems(reorganizedData, subtotalItem, idToClCodeMap);
      const subtotalDocsMap = {};
      subtotalItem?.documents?.forEach(doc => {
        if (doc?.cl_code) subtotalDocsMap[doc.cl_code] = doc;
      });

      // --- SOXID/ Group M logic: ensure LOCAL subtotal row exists ---
      this.ensureLocalSubtotalRow(reorganizedData, subtotalItem, subtotalDocsMap);
      this.moveOthersBeforeTotal(reorganizedData);
      return reorganizedData;
    } catch (error) {
      console.error("Error while reorganizing breakdown data:", error);
      return data;
    }
  },
  // Helper: Sort documents by actual_amount descending
  sortDocumentsByActualAmount(data) {
    data?.forEach(item => {
      if (Array.isArray(item?.documents)) {
        item?.documents?.sort((a, b) => (b?.actual_amount || 0) - (a?.actual_amount || 0));
      }
    });
  },
  // Helper: Map subtotal values to items using idToClCodeMap
  mapSubtotalsToItems(data, subtotalItem, idToClCodeMap) {
    if (!subtotalItem) return;
    const subtotalDocsMap = {};
    subtotalItem?.documents?.forEach(doc => {
      if (doc?.cl_code) subtotalDocsMap[doc?.cl_code] = doc;
    });
    for (const item of data) {
      const mappedClCode = idToClCodeMap[item?._id];
      if (mappedClCode && subtotalDocsMap[mappedClCode]) {
        const matchingDoc = subtotalDocsMap[mappedClCode];
        item.subtotal = {
          actual_amount: matchingDoc?.actual_amount || 0,
          proforma_amount: matchingDoc?.proforma_amount || 0,
          actual_vs_proforma_variance_amount: matchingDoc?.actual_vs_proforma_variance_amount || 0,
          commentary1: matchingDoc?.commentary1 || "",
          forecast_amount: matchingDoc?.forecast_amount || 0,
          actual_vs_forecast_variance_amount: matchingDoc?.actual_vs_forecast_variance_amount || 0,
          commentary2: matchingDoc?.commentary2 || "",
          cl_code: mappedClCode
        };
      }
    }
  },
  // Helper: Ensure LOCAL subtotal row for SOXID/Group_M
  ensureLocalSubtotalRow(data, subtotalItem, subtotalDocsMap) {
    const LOCTOT = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_CODES.LOCTOT;
    const LOCAL = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.LOCAL;
    if (!this.isSpecialRu || !subtotalItem || !subtotalDocsMap[LOCTOT]) return;
    const localIndex = data?.findIndex(item => item?._id && item?._id.toLowerCase() === LOCAL.toLowerCase());
    if (localIndex === -1) {
      const localSubtotalDoc = subtotalDocsMap[LOCTOT];
      const localSubtotalRow = {
        _id: LOCAL,
        subtotal: {
          actual_amount: localSubtotalDoc?.actual_amount || 0,
          proforma_amount: localSubtotalDoc?.proforma_amount || 0,
          actual_vs_proforma_variance_amount: localSubtotalDoc?.actual_vs_proforma_variance_amount || 0,
          commentary1: localSubtotalDoc?.commentary1 || "",
          forecast_amount: localSubtotalDoc?.forecast_amount || 0,
          actual_vs_forecast_variance_amount: localSubtotalDoc?.actual_vs_forecast_variance_amount || 0,
          commentary2: localSubtotalDoc?.commentary2 || "",
          cl_code: LOCTOT
        },
        documents: [],
        isLocalSubtotal: true
      };
      let insertIndex = data?.findIndex(item =>
        item?._id && (item?._id.toLowerCase() === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.SUBTOTAL.toLowerCase() || item?._id.toLowerCase() === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.TOTAL.toLowerCase())
      );
      if (insertIndex === -1) insertIndex = data.length;
      data.splice(insertIndex, 0, localSubtotalRow);
    }
  },
  // Helper: Move "OTHERS" row before "TOTAL"
  moveOthersBeforeTotal(data) {
    const OTHERS = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.OTHERS.toLowerCase();
    const TOTAL = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.TOTAL.toLowerCase();
    const OTHER = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.CL_TYPES.OTHER.toLowerCase();
    const othersIndex = data.findIndex(item =>
      item._id && (item._id.toLowerCase() === OTHERS || item._id.toLowerCase() === OTHER)
    );
    const totalIndex = data.findIndex(item =>
      item._id && item._id.toLowerCase() === TOTAL
    );
    if (othersIndex !== -1 && totalIndex !== -1) {
      const othersItem = data.splice(othersIndex, 1)[0];
      const newTotalIndex = data.findIndex(item =>
        item._id && item._id.toLowerCase() === TOTAL
      );
      data.splice(newTotalIndex, 0, othersItem);
    }
  },
  async getRevenueData(d) {
    // Set loading state in store
    this.$store.commit('varianceanalysis/setRevenueBreakupData', { loading: true });
    
    const payload = {
      data: [{ type: "revenue" }]
    };
    
    let breakdownData = [];
    let viewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.GROUPED;
    
    try {
      const revenueBreakupResponse = await this.axios.post("/v3/varianceanalysis/analysis/getclientbreakdowndatabygroup/" + d.cycle, payload);
      if (revenueBreakupResponse && revenueBreakupResponse?.data && revenueBreakupResponse?.data?.status === "success" && revenueBreakupResponse?.data?.data.length) {
        breakdownData = this.reorganizeBreakdownData(revenueBreakupResponse?.data?.data || []);
      } else {
        this.$store.commit("sbError", "No data found for the selected cycle.");
        viewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.UNGROUPED;
      }
    } catch (err) {
      this.$store.commit("sbError", "Failed to fetch client breakdown data.");
      viewMode = varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.VIEW_MODES.UNGROUPED;
    }
    
    return this.axios.post("/v3/varianceanalysis/analysis/getrevenue/" + d.cycle).then(dt => {
      if (dt.data.status === "success") {
        let clientbyclientdata_revenue = dt.data.data || [];
        clientbyclientdata_revenue = this.filterTotalSubTotals(clientbyclientdata_revenue);
        
        const filteredData = clientbyclientdata_revenue.map((data) => {
          return {
            ...data,
            actual_amount: this.$nova.formatNumber(data.actual_amount),
            forecast_amount: this.$nova.formatNumber(data.forecast_amount),
            proforma_amount: this.$nova.formatNumber(data.proforma_amount),
            actual_vs_proforma_variance_amount: this.$nova.formatNumber(data.actual_vs_proforma_variance_amount),
            actual_vs_forecast_variance_amount: this.$nova.formatNumber(data.actual_vs_forecast_variance_amount),
          };
        }).sort((a, b) => (b.actual_amount || 0) - (a.actual_amount || 0));
        
        // Store data in Vuex with all necessary context
        this.$store.commit('varianceanalysis/setRevenueBreakupData', {
          breakdownData: breakdownData,
          clientbyclientData: filteredData,
          clientbyclientFullData: clientbyclientdata_revenue,
          expandedGroups: [],
          viewMode: viewMode,
          loading: false,
          selectedCommentary: { ...d },
          revenueAIProforma: this.revenueAIProforma || '',
          revenueAIForecast: this.revenueAIForecast || '',
          cycleId: d.cycle,
          // Context data
          ispreparer: this.ispreparer,
          isPendingLocal: this.ispendinglocalruapproval,
          isPendingRegional: this.ispendingregionalruapproval,
          isSpecialRu: this.isSpecialRu,
          tablecolors: this.tablecolors,
          revenueAILoadingProforma: this.revenueAILoadingProforma || false,
          revenueAILoadingForecast: this.revenueAILoadingForecast || false,
          isTyping: this.isTyping || false,
          isThresholdExceedRevenueCommentary: this.isThresholdExceedRevenueCommentary || false,
          revenueCommentaryGenAiBtntab: this.revenueCommentaryGenAiBtntab || false,
          actualLabel: this.actual_label || 'Actual',
          proformaLabel: this.proforma_shortform_label || 'Proforma',
          forecastLabel: this.forcast_shortform_label || 'Forecast',
          clientTypeHeaders: this.DEMOAPPENABLED ? this.clientTypeHeadersDemoApp : this.clientTypeHeaders,
          clientByClientHeaders: this.clientbyclient_headers,
          // Metadata for breadcrumbs
          commentarycycledata: this.commentarycycledata || {},
          selectedreportingunit: this.selectedreportingunit || '',
          reportingunitdata: this.reportingunitdata || [],
        });
        
        // Navigate to commentary breakup page with cycle ID in route
        this.$router.push({
          path: `/varianceanalysis/commentary/${d.cycle}`,
          query: {
            cid: this.$store.state.client
          }
        });
      }
      else throw new Error("Error fetching breakup");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
      this.$store.commit('varianceanalysis/setRevenueBreakupData', { loading: false });
    })
  },
  toggleRevenueGroup(groupId) {
    const index = this.expandedGroups.indexOf(groupId);
    if (index === -1) {
      this.expandedGroups.push(groupId);
    } else {
      this.expandedGroups.splice(index, 1);
    }
  },
  expandAllGroups() {
    // Clear existing expanded groups
    this.expandedGroups = [];
    // Add all non-TOTAL group IDs to expanded groups
    this.expandedGroups = this.breakdownData
      .filter(item => item._id && item._id !== "TOTAL")
      .map(item => item._id);
  },
  readActivity(id) {
    this.activitylogloading = true;
    this.activitylogdialog = true;
    this.reportingunitdata = [];
    this.activitylogdata = [];
    this.axios.post("/v3/varianceanalysis/analysis/readactivity/" + id).then(dt => {
      if (dt.data.status === "success") {
        this.activitylogdata = formatVarianceActivityLogEntries(dt.data.data || [], {
          reportingType: this.reportingType || '',
          labelsName: this.$nova?.labelsName?.bind(this.$nova),
          identifyAndRemapLabelName: this.$nova?.identifyAndRemapLabelName?.bind(this.$nova),
        });
      }
      else throw new Error(dt.data.message || "Error fetching data");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.activitylogloading = false;
    })
  },
  getStageText(x) {
    if (x === -1) return "Rejected commentary";
    else if (x === 0) return "Commentary awaited";
    else if (x === 1) return "Commentary awaiting approval";
    else if (x === 2) return "Approved commentary";
    else if (x === 3) return "Nil value accounts";
    else if (x === 4) return "Immaterial variance";
    else if (x === 5) return "Not in Scope";
  },
  downloadExcelisApprover() {
    return Promise.resolve().then(() => {
      this.bulksubmitloading = true;
    }).then(() => {
      // Get column template based on cycle type and create remapped labels
      const { ACTUAL } = varianceAnalysisConstants.CYCLE_TYPES;
      const bulkTemplates = this.$constants.BULK_FILE_TEMPLATES;
      
      let columnTemplate = [];
      if (this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
          columnTemplate = this.cycletype === ACTUAL 
          ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL_BS 
          : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST_BS;
      } else {
          columnTemplate = this.cycletype === ACTUAL 
          ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL 
          : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST;
      }
      
      const remappedColumns = [...columnTemplate].map((label) => {
        if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
           if(label === 'Actual Amount') return this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual') + " Amount";
           if(label === 'Proforma Amount') return this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma') + " Amount";
           if(label === 'Forecast Amount') return this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast') + " Amount";
           return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
        } else {
           return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
        }
      });

      this.bulksubmitcolumns = remappedColumns;
      let workbook = styledxlsx.utils.book_new();
      let primarycolor = "d8e8f0";
      let heading1 = "bfffbf";
      let heading2 = (this.tablecolors.heading.a || "").toString().replaceAll("#", "").toUpperCase();
      let heading3 = (this.tablecolors.heading.b || "").toString().replaceAll("#", "").toUpperCase();
      let body1 = "E3FFE3";
      let body2 = "E8EEFF";
      let body3 = "F2E1F5";
      let scolor = "078f0e";
      let ecolor = "d11b1b";
      let runame = this.commentaryrudata?.code || "Report";
      let autoSubmissionColumns = varianceAnalysisConstants.AUTO_SUBMISSION_COLUMNS || [];
      let statementTypeLabel = "";
      if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS){
        statementTypeLabel = " - " + varianceAnalysisConstants.REPORTING_TYPES.BS_LABEL
      } else {
        statementTypeLabel = " - " + varianceAnalysisConstants.REPORTING_TYPES.PL_LABEL
      }

      // console.log(this.reportingunitlist[this.selectedreportingunit]);
      // console.log(primarycolor, this.tablecolors, heading1, heading2, heading3, body1, body2, body3);
      let dt = [
        [
          ""
        ],
        [
          "",
          { v: this.reportingunitlist[this.selectedreportingunit].name || "", s: { font: { bold: true, sz: 20 } } },
        ],
        [
          "",
          { v: this.cycletype + " - " + (this.periodlist[this.selectedperiod].name || "") + statementTypeLabel, s: { font: { bold: true, sz: 14 } } },
        ],
        [
          ""
        ],
        [
          "",
          { v: this.bulksubmitcolumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: this.bulksubmitcolumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: this.bulksubmitcolumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: this.bulksubmitcolumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
          { v: this.bulksubmitcolumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: this.bulksubmitcolumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[21], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: this.bulksubmitcolumns[22], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          ...((this.isRegionalCommentaryAutomationEnabled  && this.isapprover)
            ? [
                { v: autoSubmissionColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
                { v: autoSubmissionColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
              ]
            : [
                { v: this.bulksubmitcolumns[23], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
                { v: this.bulksubmitcolumns[24], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
              ])
          ,
          { v: this.bulksubmitcolumns[25], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: this.bulksubmitcolumns[26], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: this.bulksubmitcolumns[27], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
        ]];
      for (const v of this.filteredcommentarydata) {
          if (v.__stage === 5 || v.__stage === -2) {
          let stageLocal = ''
          let stageRegional = ''
          let localapprovereason = ''
          let regionalapprovereason = ''
          if (v.cycle) {
            stageLocal = (v.stage_local === -1) ? "No" : ((v.stage_local === 2) ? "Yes" : "")
            localapprovereason = (v.stage_local === -1) ? v.rejectreason : ((v.stage_local === 2) ? v.approvereason : "")
            stageRegional = (v.stage_regional === -1) ? "No" : ((v.stage_regional === 2) ? "Yes" : "")
            regionalapprovereason = (v.stage_regional === -1) ? v.regionalrejectreason : ((v.stage_regional === 2) ? v.regionalapprovereason : "")
            dt.push([
              "",
              v.glcode_detail?.code,
              ((v.__parent === "primary" || v.__parent === "NA") ? "" : "    ") + v.glcode_detail?.name,
              { v: this.$nova.formatCurrency(v.amount1.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
              { v: this.$nova.formatCurrency(v.amount2.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) + ((v.variancepercent1 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_control_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.var1_cross_management_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.commentary1 || "", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: v.regionalcommentary1 || ((v.commentary1 || "") + (localapprovereason || "")) || "", s: { fill: { fgColor: { rgb: body2 } } } },
              { v: this.$nova.formatCurrency(v.amount3.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: this.$nova.formatCurrency((v.variancepercent2).toFixed(1), '', false, true) + ((v.variancepercent2 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_control_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.var2_cross_management_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.commentary2 || "", s: { fill: { fgColor: { rgb: body3 } } } },
              { v: v.regionalcommentary2 || ((v.commentary2 || "") + (localapprovereason || "")) || "", s: { fill: { fgColor: { rgb: body3 } } } },
              this.getStageText(v.stage_local),
              this.getStageText(v.stage_regional),
              { v: stageLocal },
              { v: localapprovereason || "" },
              { v: stageRegional },
              { v: "" },
              { v: regionalapprovereason || "" },
            ])
          }

        }
      }
      console.log(dt,"dt");
      let worksheet = styledxlsx.utils.aoa_to_sheet(dt);
      styledxlsx.utils.book_append_sheet(workbook, worksheet, "TOP SHEET");
      styledxlsx.writeFile(workbook, `${runame}.xlsx`);
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.bulksubmitloading = false;
    })
  },
  downloadExcel() {
    // Acquire Data (reference to the HTML table)
    return Promise.resolve().then(() => {
      this.bulksubmitloading = true;
      return this.loadContent(true);
    }).then(() => {
      // Get constants from varianceAnalysisConstants
      const { ACTUAL } = varianceAnalysisConstants.CYCLE_TYPES;
      const autoSubmissionColumns = varianceAnalysisConstants.AUTO_SUBMISSION_COLUMNS || [];
      const bulkTemplates = this.$constants.BULK_FILE_TEMPLATES;
      
      // Get column template based on cycle type and create remapped labels
      let columnTemplate = [];
      if (this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
          columnTemplate = this.cycletype === ACTUAL 
          ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL_BS 
          : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST_BS;
      } else {
          columnTemplate = this.cycletype === ACTUAL 
          ? bulkTemplates.BULK_SUBMIT_COLUMNS_ACTUAL 
          : bulkTemplates.BULK_SUBMIT_COLUMNS_FORECAST;
      }
      
      const remappedColumns = [...columnTemplate].map((label) => {
        if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS) {
           if(label === 'Actual Amount') return this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual') + " Amount";
           if(label === 'Proforma Amount') return this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma') + " Amount";
           if(label === 'Forecast Amount') return this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast') + " Amount";
           return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
        } else {
           return this.$nova.identifyAndRemapLabelName(bulkTemplates.LABELS_PAGE, label)
        }
      });
      
      let workbook = styledxlsx.utils.book_new();
      let primarycolor = "d8e8f0";
      let heading1 = "bfffbf";
      let heading2 = (this.tablecolors.heading.a || "").toString().replaceAll("#", "").toUpperCase();
      let heading3 = (this.tablecolors.heading.b || "").toString().replaceAll("#", "").toUpperCase();
      let body1 = "E3FFE3";
      let body2 = "E8EEFF";
      let body3 = "F2E1F5";
      let scolor = "078f0e";
      let ecolor = "d11b1b";
      let runame = this.commentaryrudata?.code || "Report";
      let statementTypeLabel = "";
      if(this.reportingType === varianceAnalysisConstants.REPORTING_TYPES.BS){
        statementTypeLabel = " - " + varianceAnalysisConstants.REPORTING_TYPES.BS_LABEL
      } else {
        statementTypeLabel = " - " + varianceAnalysisConstants.REPORTING_TYPES.PL_LABEL
      }
      let dt = [
        [
          ""
        ],
        [
          "",
          { v: this.reportingunitlist[this.selectedreportingunit].name || "", s: { font: { bold: true, sz: 20 } } },
        ],
        [
          "",
          { v: this.cycletype + " - " + (this.periodlist[this.selectedperiod].name || "") + statementTypeLabel, s: { font: { bold: true, sz: 14 } } },
        ],
        [
          ""
        ],
        [
          "",
          { v: remappedColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: remappedColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: remappedColumns[2], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: remappedColumns[3], s: { font: { bold: true }, fill: { fgColor: { rgb: heading1 } } } },
          { v: remappedColumns[4], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[5], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[6], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[7], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[8], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[9], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[10], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[11], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[12], s: { font: { bold: true }, fill: { fgColor: { rgb: heading2 } } } },
          { v: remappedColumns[13], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[14], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[15], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[16], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[17], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[18], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[19], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[20], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[21], s: { font: { bold: true }, fill: { fgColor: { rgb: heading3 } } } },
          { v: remappedColumns[22], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          ...((this.isRegionalCommentaryAutomationEnabled  && this.isapprover)
            ? [
                { v: autoSubmissionColumns[0], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
                { v: autoSubmissionColumns[1], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
              ]
            : [
                { v: remappedColumns[23], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
                { v: remappedColumns[24], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
              ])
          ,
          { v: remappedColumns[25], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: remappedColumns[26], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } },
          { v: remappedColumns[27], s: { font: { bold: true }, fill: { fgColor: { rgb: primarycolor } } } }
        ]];
      for (const v of this.filteredcommentarydata) {
        let stageLocal = ''
        let stageRegional = ''
        let localapprovereason = ''
        let regionalapprovereason = ''
        if (v.cycle) {
          stageLocal = (v.stage_local === -1) ? "No" : ((v.stage_local === 2) ? "Yes" : "")
          localapprovereason = (v.stage_local === -1) ? v.rejectreason : ((v.stage_local === 2) ? v.approvereason : "")
          stageRegional = (v.stage_regional === -1) ? "No" : ((v.stage_regional === 2) ? "Yes" : "")
          regionalapprovereason = (v.stage_regional === -1) ? v.regionalrejectreason : ((v.stage_regional === 2) ? v.regionalapprovereason : "")
          dt.push([
            "",
            v.glcode_detail?.code,
            ((v.__parent === "primary" || v.__parent === "NA") ? "" : "    ") + v.glcode_detail?.name,
            // v.__parent1 || "", 
            { v: this.$nova.formatCurrency(v.amount1.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body1 } } } },
            { v: this.$nova.formatCurrency(v.amount2.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body2 } } } },
            { v: this.$nova.formatCurrency(v.varianceamount1.toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
            { v: this.$nova.formatCurrency((v.variancepercent1).toFixed(1), '', false, true) + ((v.variancepercent1 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount1 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body2 } } } },
            { v: v.var1_cross_control ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: v.var1_cross_management ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: v.var1_cross_control_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: v.var1_cross_management_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: v.commentary1 || "", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: v.regionalcommentary1 || "", s: { fill: { fgColor: { rgb: body2 } } } },
            { v: this.$nova.formatCurrency(v.amount3.toFixed(1), '', false, true), s: { fill: { fgColor: { rgb: body3 } } } },
            { v: this.$nova.formatCurrency(v.varianceamount2.toFixed(1), '', false, true), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
            { v: this.$nova.formatCurrency((v.variancepercent2).toFixed(1), '', false, true) + ((v.variancepercent2 !== 0) ? '%' : ''), s: { font: { color: { rgb: (v.varianceamount2 > 0) ? scolor : ecolor } }, fill: { fgColor: { rgb: body3 } } } },
            { v: v.var2_cross_control ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
            { v: v.var2_cross_management ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
            { v: v.var2_cross_control_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
            { v: v.var2_cross_management_regional ? "Yes" : "No", s: { fill: { fgColor: { rgb: body3 } } } },
            { v: v.commentary2 || "", s: { fill: { fgColor: { rgb: body3 } } } },
            { v: v.regionalcommentary2 || "", s: { fill: { fgColor: { rgb: body3 } } } },
            this.getStageText(v.stage_local),
            this.getStageText(v.stage_regional),
            { v: stageLocal },
            { v: localapprovereason || "" },
            { v: stageRegional },
            { v: "" },
            { v: regionalapprovereason || "" },
          ])
        }
      }
      // Extract Data (create a workbook object from the table)
      let worksheet = styledxlsx.utils.aoa_to_sheet(dt);
      styledxlsx.utils.book_append_sheet(workbook, worksheet, "TOP SHEET");

      // Package and Release Data (`writeFile` tries to write and save an XLSB file)
      styledxlsx.writeFile(workbook, `${runame}.xlsx`);

    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.bulksubmitloading = false;
    })

  },
  downloadRevenueCommentaryTemplate(type) {
    // Acquire Data (reference to the HTML table)
    let headertext = "Revenue Breakdown";
    let dttouse = this.clientbyclientdata_revenue;
    if (type === 'netsales') {
      headertext = "Net Sales Breakdown";
      dttouse = this.clientbyclientdata_netsales;
    }
    return Promise.resolve().then(() => {
      this.uploadnetsalescommentaryloading = true;
      this.uploadrevenuecommentaryloading = true;
    }).then(() => {
      let workbook = styledxlsx.utils.book_new();
      // console.log(this.reportingunitlist[this.selectedreportingunit]);
      // console.log(primarycolor, this.tablecolors, heading1, heading2, heading3, body1, body2, body3);
      let dt = [
        [
          ""
        ],
        [
          "",
          { v: this.reportingunitlist[this.selectedreportingunit].name || "", s: { font: { bold: true, sz: 20 } } },
        ],
        [
          "",
          { v: (this.periodlist[this.selectedperiod].name || "") + " - " + this.selectedyear + " - " + headertext, s: { font: { bold: true, sz: 14 } } },
        ],
        [
          ""
        ],
        [
          "",
          { v: this.clientbyclient_headers[0].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[1].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[2].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[3].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[4].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[5].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[6].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[7].text, s: { font: { bold: true } } },
          { v: this.clientbyclient_headers[8].text, s: { font: { bold: true } } },
        ]];
      for (const v of dttouse) {
        dt.push([
          "",
          v.cl_code,
          v.client_name,
          { v: this.$nova.formatCurrency(v.actual_amount.toFixed(1), '', false, true) },
          { v: this.$nova.formatCurrency(v.proforma_amount.toFixed(1), '', false, true) },
          { v: this.$nova.formatCurrency(v.actual_vs_proforma_variance_amount.toFixed(1), '', false, true) },
          v.commentary1,
          { v: this.$nova.formatCurrency(v.forecast_amount.toFixed(1), '', false, true) },
          { v: this.$nova.formatCurrency(v.actual_vs_forecast_variance_amount.toFixed(1), '', false, true) },
          v.commentary2,
        ])
      }

      // Extract Data (create a workbook object from the table)
      let worksheet = styledxlsx.utils.aoa_to_sheet(dt);
      styledxlsx.utils.book_append_sheet(workbook, worksheet, "TOP SHEET");

      // Package and Release Data (`writeFile` tries to write and save an XLSB file)
      styledxlsx.writeFile(workbook, "Report.xlsx");

    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.uploadnetsalescommentaryloading = false;
      this.uploadrevenuecommentaryloading = false;
    })

  },

  processCommentaryFlag: function () {
    this.ispreparer = false;
    this.isapprover = false;
    this.isregionalapprover = false;
    this.ismanager = false;
    this.isviewonly = false;
    const userRoles = getAvailableRoles(this.commentaryrudata,this.userid).map((role)=>{
      return{
        ...role,
        label:this.getRoleLabel(role.value)
      }
    })      
     // If no recognized role → viewonly
    if (!userRoles?.length) {
      this.isviewonly = true;
      this.ruRoleOptions = [];
      this.selectedRuRole = null;
      // cyclestage assignment if needed
      if (this.toggleview !== varianceAnalysisConstants.TOGGLE_STATES.DASHBOARD_VIEW) {
        this.cyclestage = this.commentarycycledata.stage;
      }
      if (this.toggleview === varianceAnalysisConstants.TOGGLE_STATES.DASHBOARD_VIEW) {
        this.isviewonly = false;
      }
      return;
    }
    this.ruRoleOptions = userRoles;
    
    // Preserve the currently selected role if it's still valid, otherwise use default
    const validRoleValues = userRoles.map(r => r.value);
    const currentRoleIsValid = this.selectedRuRole && validRoleValues.includes(this.selectedRuRole);
    const roleToApply = currentRoleIsValid ? this.selectedRuRole : (userRoles[0]?.value || '');

    this.selectedRuRole = roleToApply;
    this.applyRoleFlags(roleToApply);
    if (this.toggleview !== varianceAnalysisConstants.TOGGLE_STATES.DASHBOARD_VIEW) {
      this.cyclestage = this.commentarycycledata.stage;
    }
    if (this.toggleview === varianceAnalysisConstants.TOGGLE_STATES.DASHBOARD_VIEW) {
      this.isviewonly = false;
    }
    if ((this.commentaryrudata.submitter || []).length === 0 || (this.commentaryrudata.approver || []).length === 0 || (this.commentaryrudata.manager || []).length === 0 || (this.commentaryrudata.regional_approver || []).length === 0) this.alluserassigned = false;
    else this.alluserassigned = true;
  },
  getRoleLabel(role){
    const mapping = ROLE_LABEL_MAPPING[role] || VIEW_ONLY;
    return this.$nova.labelsName('cycle_page', mapping?.key, mapping?.default);       
  },
  /**
   * CHANGE: apply only *one* role's boolean, clearing others.
   * Also clears multiselect when switching roles.
   */
  applyRoleFlags(role) {
    // reset
    this.ispreparer = false;
    this.isapprover = false;
    this.isregionalapprover = false;
    this.ismanager = false;
    this.isviewonly = false;

    // set the chosen role
    if (role === ROLES.LOCAL_PREPARER) this.ispreparer = true;
    else if (role === ROLES.LOCAL_APPROVER) this.isapprover = true;
    else if (role === ROLES.REGIONAL_APPROVER) this.isregionalapprover = true;
    else if (role === ROLES.MANAGER) this.ismanager = true;
    else this.isviewonly = true;

    // clear any multi-select state
    this.$nextTick(() => {
     this.multiselectdata = [];
    });
  },
  pushtoExpand: function (d) {
    this.expandedsubcategory.push(d);
  },
  saveCustomFilter: function () {
    localStorage.setItem("commentary_custom_filter", this.customfilter.join(","));
    if (this.customfilter.length > 0) this.customfilterstoggle = true;
    else this.customfilterstoggle = false;
    localStorage.setItem("commentary_custom_filter_toggle", this.customfilterstoggle);
    this.customfiltersdialog = false;
  },
  setPeriod: function (d) {
    this.setFilter('selectedperiod', d)
  },
  setNetwork: function (d) {
    this.isReportingUnitClicked = true
    this.setFilter('selectednetwork', d)
  },
  setRegion: function (d) {
    this.setFilter('selectedregion', d)
  },
  setCountry: function (d) {
    this.setFilter('selectedcountry', d)
  },
  setReportingUnit: function (d) {
    this.viewTransitionDirection = 'forward';
    
    const filterRef = this.$refs.childfilter;
    const isInferred = (filterRef && filterRef.isHierarchyInferred === true);
    
    this.reportingUnitFilter = {
      selectedyear: filterRef?.selectedyear || this.selectedyear,
      selectedperiod: filterRef?.selectedperiod || this.selectedperiod,
      selectednetwork: isInferred ? "all" : (filterRef?.selectednetwork || this.selectednetwork || "all"),
      selectedregion: isInferred ? "all" : (filterRef?.selectedregion || this.selectedregion || "all"),
      selectedcountry: isInferred ? "all" : (filterRef?.selectedcountry || this.selectedcountry || "all"),
      isHierarchyInferred: false,
      selectedreportingunit: 'all',
      selectedReportingUnitType: 'all',
      toggleview: this.toggleview
    };
    this.$refs.childfilter.setPreviousFilterState({ ...this.reportingUnitFilter })
    this.isReportingUnitClicked = true
    this.commentarydata = []
    this.commentarycycledata = {}
    this.commentaryrudata = {}
    this.reportingunitdata = d?.previousLoadedRUList || []
    this.selectedreportingunit = d?.reportingunit || []
    const hierarchyContext = d?.hierarchyContext || {}
    if (this.$refs.childfilter?.registerExternalReportingUnit) {
      this.$refs.childfilter.registerExternalReportingUnit(d?.reportingunitDetail, hierarchyContext)
    }
    if (hierarchyContext.network) {
      this.selectednetwork = hierarchyContext.network
    }
    if (hierarchyContext.region) {
      this.selectedregion = hierarchyContext.region
    }
    if (hierarchyContext.country) {
      this.selectedcountry = hierarchyContext.country
    }
    this.setFilter('selectedreportingunit', d.reportingunit)
    this.$nextTick(() => {
      const filterRef = this.$refs.childfilter;
      if (!filterRef) return;
      if (typeof filterRef.handleApplyFilters === 'function') {
        filterRef.handleApplyFilters();
      } else if (typeof filterRef.setDropdowns === 'function') {
        filterRef.setDropdowns(false, true);
      }
    });
  },
  getFilterFlag: function (dt) {
    if (this.customfilterstoggle && this.customfilter.indexOf(dt.glcode) === -1) return [true, true];
    else if (this.selectedfilter.indexOf(dt?.__stage) === -1) return [true, !(dt?.__stage === 3 || dt?.__stage === 9)];
    return [false, true]
  },
  /**
   * Restore filter state when navigating back from RU detail view to RU list
   * @param {Boolean} skipReload - If true, only restores filter UI state without triggering API calls
   */
  setRportingUnitFilter(skipReload = false) {
    this.selectedreportingunit = false; // Always reset RU detail view flag
    this.toggleview = this.reportingUnitFilter?.toggleview || 0
    
    // Retrieve stored filter state based on cycle type
    let storedFilter = {};
    if (this.cycletype === 'actual' || this.cycletype === 'Actual') {
      storedFilter = (this.$store.state[this.appname] || []).previousActualFilterState || {};
    } else {
      storedFilter = (this.$store.state[this.appname] || []).previousForecastFilterState || {};
    }

    // Check if a specific Reporting Unit was selected in the stored filter
    // If yes, it implies the filter context (Network, Region, Country) might have been Auto-Selected by the RU logic.
    // In this case, we reset everything to 'all' when going back to list view.
    const wasSpecificRUSelected = storedFilter.selectedreportingunit && storedFilter.selectedreportingunit !== 'all';

    if (wasSpecificRUSelected) {
      this.reportingUnitFilter = {
        selectedcountry: 'all',
        selectedregion: 'all',
        selectednetwork: 'all',
        selectedreportingunit: 'all',
        selectedReportingUnitType: 'all',
        selectedyear: storedFilter.selectedyear || this.selectedyear || 'all',
        selectedperiod: storedFilter.selectedperiod || this.selectedperiod || 'all'
      };
    } else {
      // If no specific RU was selected (i.e. 'all'), preserve the manual Network/Region/Country selections.
      this.reportingUnitFilter = {
        ...storedFilter,
        selectedreportingunit: 'all' // Ensure RU is 'all' for list view
      };
    }
    
    // Ensure vital defaults if stored filter is empty
    if(!this.reportingUnitFilter.selectedyear) this.reportingUnitFilter.selectedyear = this.selectedyear || 'all';
    if(!this.reportingUnitFilter.selectedperiod) this.reportingUnitFilter.selectedperiod = this.selectedperiod || 'all';
    
    // Update store with the (potentially reset) filter state
    if (this.cycletype === 'actual' || this.cycletype === 'Actual') {
      this.$store.commit(this.appname + "/setActualFilters", this.reportingUnitFilter);
    } else {
      this.$store.commit(this.appname + "/setForecastFilters", this.reportingUnitFilter);
    }

    this.isReportingUnitClicked = false
    
    // Restore component state from the determined filter object
    this.selectedyear = this.reportingUnitFilter.selectedyear
    this.selectedperiod = this.reportingUnitFilter.selectedperiod

    this.selectedreportingunit = 'all'; 
    this.selectedcountry = this.reportingUnitFilter.selectedcountry || 'all';
    this.selectedregion = this.reportingUnitFilter.selectedregion || 'all'; 
    this.selectednetwork = this.reportingUnitFilter.selectednetwork || 'all';
    
    // Restore selectedReportingUnitType
    this.selectedReportingUnitType = this.reportingUnitFilter.selectedReportingUnitType || 'all';
    
    // When skipReload is true, only update filter UI without triggering API calls
    if (skipReload) {
      this.reportingUnitFilter['emit'] = false;
    } else {
      this.reportingUnitFilter['emit'] = true;
    }
    
    this.$refs.childfilter.setFilterItem(this.reportingUnitFilter)
  },
 
  storeFilteredData(data, reload, datatype, time, options = {}) {
    const { selectedrole, selectedyear, selectedperiod, selectednetwork, selectedregion, selectedcountry, selectedreportingunit } = this;

    if (datatype === 'reportingunit') {
      if (!this.filterData[selectedrole]) {
        this.$set(this.filterData, selectedrole, {});
      }
      if (!this.filterData[selectedrole][selectedyear]) {
        this.$set(this.filterData[selectedrole], selectedyear, {});
      }
      if (!this.filterData[selectedrole][selectedyear][selectedperiod]) {
        this.$set(this.filterData[selectedrole][selectedyear], selectedperiod, {});
      }
      if (!this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork]) {
        this.$set(this.filterData[selectedrole][selectedyear][selectedperiod], selectednetwork, {});
      }
      if (!this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion]) {
        this.$set(this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork], selectedregion, {});
      }
      if (!this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry] || reload === true) {
        this.$set(
          this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion],
          selectedcountry,
          { data: [], pagination_page: 0, hasMore: false }
        );
      }

      const reportingUnitNode = this.filterData[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry];
      const {
        replace = false,
        fullData = null,
        hasMore,
        paginationPage,
      } = options;

      if (reload === true) {
        reportingUnitNode.data = [];
        reportingUnitNode.pagination_page = 0;
        reportingUnitNode.hasMore = false;
      }

      if (replace) {
        const sourceData = Array.isArray(fullData)
          ? fullData
          : Array.isArray(data)
            ? data
            : [];
        reportingUnitNode.data = [...sourceData];
        if (typeof paginationPage === 'number') {
          reportingUnitNode.pagination_page = paginationPage;
        } else {
          const size = this.perpage || varianceAnalysisConstants.REPORTING_UNIT.PAGE_SIZE;
          reportingUnitNode.pagination_page = Math.ceil(sourceData.length / size);
        }
      } else if (Array.isArray(data) && data.length > 0) {
        reportingUnitNode.data = [...reportingUnitNode.data, ...data];
        if (typeof paginationPage === 'number') {
          reportingUnitNode.pagination_page = paginationPage;
        } else {
          reportingUnitNode.pagination_page = (reportingUnitNode.pagination_page || 0) + 1;
        }
    }

      if (typeof hasMore === 'boolean') {
        reportingUnitNode.hasMore = hasMore;
      }
      if (typeof paginationPage === 'number') {
        reportingUnitNode.pagination_page = paginationPage;
      }
    }
    else if (datatype === 'period') {
      if (!this.periodDataList[selectedrole]) {
        this.$set(this.periodDataList, selectedrole, {});
      }
      if (!this.periodDataList[selectedrole][selectedyear]) {
        this.$set(this.periodDataList[selectedrole], selectedyear, { 'perioddata': [], 'actual_period_updated_at': time });
      }
      this.periodDataList[selectedrole][selectedyear].perioddata = data
    }
    else if (datatype === 'network') {
      if (!this.networkList[selectedrole]) {
        this.$set(this.networkList, selectedrole, {});
      }
      if (!this.networkList[selectedrole][selectedyear]) {
        this.$set(this.networkList[selectedrole], selectedyear, {});
      }
      if (!this.networkList[selectedrole][selectedyear][selectedperiod]) {
        this.$set(this.networkList[selectedrole][selectedyear], selectedperiod, { 'networkdata': [], 'actual_network_updated_at': time });
      }
      this.networkList[selectedrole][selectedyear][selectedperiod].networkdata = data
    }
    else if (datatype === 'region') {
      if (!this.regionList[selectedrole]) {
        this.$set(this.regionList, selectedrole, {});
      }
      if (!this.regionList[selectedrole][selectedyear]) {
        this.$set(this.regionList[selectedrole], selectedyear, {});
      }
      if (!this.regionList[selectedrole][selectedyear][selectedperiod]) {
        this.$set(this.regionList[selectedrole][selectedyear], selectedperiod, {});
      }
      if (!this.regionList[selectedrole][selectedyear][selectedperiod][selectednetwork]) {
        this.$set(this.regionList[selectedrole][selectedyear][selectedperiod], selectednetwork, { 'regiondata': [], 'lastUpdatedAt': time });
      }
      this.regionList[selectedrole][selectedyear][selectedperiod][selectednetwork].regiondata = data
    }
    else if (datatype === 'country') {
      if (!this.countrylist[selectedrole]) {
        this.$set(this.countrylist, selectedrole, {});
      }
      if (!this.countrylist[selectedrole][selectedyear]) {
        this.$set(this.countrylist[selectedrole], selectedyear, {});
      }
      if (!this.countrylist[selectedrole][selectedyear][selectedperiod]) {
        this.$set(this.countrylist[selectedrole][selectedyear], selectedperiod, {});
      }
      if (!this.countrylist[selectedrole][selectedyear][selectedperiod][selectednetwork]) {
        this.$set(this.countrylist[selectedrole][selectedyear][selectedperiod], selectednetwork, {});
      }
      if (!this.countrylist[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion]) {
        this.$set(this.countrylist[selectedrole][selectedyear][selectedperiod][selectednetwork], selectedregion, { 'countrydata': [] });
      }
      this.countrylist[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion].countrydata = data
    }
    else if (datatype === 'reportingunitdata') {
      if (!this.commentarydataList[selectedrole]) {
        this.$set(this.commentarydataList, selectedrole, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear]) {
        this.$set(this.commentarydataList[selectedrole], selectedyear, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear][selectedperiod]) {
        this.$set(this.commentarydataList[selectedrole][selectedyear], selectedperiod, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork]) {
        this.$set(this.commentarydataList[selectedrole][selectedyear][selectedperiod], selectednetwork, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork]?.[selectedregion]) {
        this.$set(this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork], selectedregion, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry]) {
        this.$set(this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion], selectedcountry, {});
      }
      if (!this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry][selectedreportingunit]) {
        this.$set(this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry], selectedreportingunit, { 'reportingunitdata': [], 'lastUpdatedAt': time });
      }
      this.commentarydataList[selectedrole][selectedyear][selectedperiod][selectednetwork][selectedregion][selectedcountry][selectedreportingunit].reportingunitdata = data
    }
  },
  toISOConverter(rawDate) {
    try {
      const date = new Date(rawDate);

      // Extract date components
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // January is 0
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      // Format the date as desired (e.g., YYYY-MM-DD HH:mm:ss)
      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

      return formattedDate
    } catch (error) {
      console.error("Error:", error.message);
    }

  },
  //This method to handle select_all in filter
  select_all() {
    if (this.is_selected_all_filter) {
      this.selectedfilter = [0, 1, -1, 5, 6, -2, 7, 4, 3, 9, 'all']
    } else {
      //const index = this.selectedfilter.indexOf('all');
      this.selectedfilter = []
    }
    this.is_selected_all_filter = !this.is_selected_all_filter
  },
  readActivityLog(id) {
    this.reportingunitdata = [];
    this.activitylogdata = [];
    this.lastActionsOnGL = { "localaction": { lastAction: '' }, 'regionalaction': { lastAction: '' } }
    let localTypes = [];
    let localrejectTypes = []
    let localapproveTypes = []
    let regionalrejectTypes = []
    let regionalapproveTypes = []
    let regionalTypes = [];
    if (this.cycletype === 'Actual') {
      localrejectTypes = ['a_localreject', 'a_Localbulkreject', 'a_localfilereject'];
      localapproveTypes = ['a_localapprove', 'a_localbulkapprove', 'a_localfileapprove'];
      regionalrejectTypes = ['a_regionalreject', 'a_Regionalbulkreject', 'a_regionalfilereject'];
      regionalapproveTypes = ['a_regionalapprove', 'a_regionalbulkapprove', 'a_regionalfileapprove'];
      localTypes = ['a_localreject', 'a_localapprove', 'a_Localbulkreject', 'a_localbulkapprove', 'a_localfileapprove', 'a_localfilereject'];
      regionalTypes = ['a_regionalreject', 'a_regionalapprove', 'a_Regionalbulkreject', 'a_regionalbulkapprove', 'a_regionalfileapprove', 'a_regionalfilereject'];
    } else {
      localrejectTypes = ['f_localreject', 'f_Localbulkreject', 'f_localfilereject'];
      localapproveTypes = ['f_localapprove', 'f_localbulkapprove', 'f_localfileapprove'];
      regionalrejectTypes = ['f_regionalreject', 'f_Regionalbulkreject', 'f_regionalfilereject'];
      regionalapproveTypes = ['f_regionalapprove', 'f_regionalbulkapprove', 'f_regionalfileapprove'];
      localTypes = ['f_localreject', 'f_localapprove', 'f_Localbulkreject', 'f_localbulkapprove', 'f_localfileapprove', 'f_localfilereject'];
      regionalTypes = ['f_regionalreject', 'f_regionalapprove', 'f_Regionalbulkreject', 'f_regionalbulkapprove', 'f_regionalfileapprove', 'f_regionalfilereject'];
    }
    // Build filter with optional reporting_type for Balance Sheet
    const logsFilter = { cycletype: this.cycletype };
    if (this.reportingType) {
      logsFilter.reporting_type = this.reportingType;
    }
    this.apiGet("/v3/varianceanalysis/analysis/getlogs/" + id + "/f/Actual", logsFilter).then(dt => {
      if (dt.data.status === "success") {
        this.activitylogdata = formatVarianceActivityLogEntries(dt.data.data || [], {
          reportingType: this.reportingType || logsFilter.reporting_type || '',
          filter: logsFilter,
          labelsName: this.$nova?.labelsName?.bind(this.$nova),
          identifyAndRemapLabelName: this.$nova?.identifyAndRemapLabelName?.bind(this.$nova),
        });
        // Pick the single chronologically latest entry across the type set
        // (not one-per-type then [0], which could prefer an older approve over a newer reject).
        const getLatestEntryByTypes = (data, types) => {
          return (data || []).reduce((latest, current) => {
            if (!types.includes(current.type)) return latest;
            if (!latest || new Date(current.created_at) > new Date(latest.created_at)) {
              return current;
            }
            return latest;
          }, null);
        };
        this.lastActionsOnGL['regionalaction'] = getLatestEntryByTypes(this.activitylogdata, regionalTypes) || { lastAction: '' };
        this.lastActionsOnGL['localaction'] = getLatestEntryByTypes(this.activitylogdata, localTypes) || { lastAction: '' };
        if (localrejectTypes.includes(this.lastActionsOnGL['localaction']?.type)) {
          this.lastActionsOnGL['localaction']['lastAction'] = 'localreject'
        } else if (localapproveTypes.includes(this.lastActionsOnGL['localaction']?.type)) {
          this.lastActionsOnGL['localaction']['lastAction'] = 'localapprove'
        } else {
          this.lastActionsOnGL['localaction']['lastAction'] = ''
        }
        if (regionalrejectTypes.includes(this.lastActionsOnGL['regionalaction']?.type)) {
          this.lastActionsOnGL['regionalaction']['lastAction'] = 'regionalreject'
        } else if (regionalapproveTypes.includes(this.lastActionsOnGL['regionalaction']?.type)) {
          this.lastActionsOnGL['regionalaction']['lastAction'] = 'regionalapprove'
        }
        else {
          this.lastActionsOnGL['regionalaction']['lastAction'] = ''
        }
      }
      else throw new Error(dt.data.message || "Error fetching data");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.activitylogloading = false;
    })
  },
  manualFilterRefresh() {
    this.isFiltersDataLoading = true;
    this.$refs.childfilter.getData(true);
  },
  manualFiltersync(data) {
    this.isFiltersDataLoading = data.syncCompleted;
  },
  bulkcommentaryDialogueOpen() {
    if (this.workflows.islocalenabled) {
      // Reset state before opening dialog
      this.bulksubmitfiledatafile = null;
      this.bulksubmitfiledata = {};
      this.bulksubmitfiledataList = [];
      this.bulksubmitfiledataerror = false;
      this.bulksubmitdialog = true;
    }
  },
  bulkcommentaryDialogueOpenisApprover() {
    if (this.workflows.isregionalenabled || this.workflows.islocalenabled) {
      // Reset state before opening dialog
      this.approverBulkSubmitDataFile = null;
      this.approverBulkSubmitData = {};
      this.approverBulkSubmitFileDataListis = [];
      this.bulksubmitfiledataerrorisApprover = false;
      this.approverBulkSubmitPop = true;
    }
  },
  bulkapproveDialogueOpen() {
    if ((this.isapprover && this.workflows.islocalenabled) || (this.isregionalapprover && this.workflows.isregionalenabled)) {
      // Reset state before opening dialog
      this.bulkapprovelocalfiledatafile = null;
      this.bulkapprovelocalfiledata = {};
      this.bulkapprovelocalfiledataerror = false;
      this.bulkapprovelocaldialog = true;
    }
  },
  setWorkflows() {
    if (!this.workflows.lcp && !this.workflows.lmp && !this.workflows.lcp_bs && !this.workflows.lmp_bs) {
      this.workflows.islocalproformaenabled = false
    }
    if (!this.workflows.lcf && !this.workflows.lmf && !this.workflows.lcf_bs && !this.workflows.lmf_bs) {
      this.workflows.islocalforecastenabled = false
    }
    if (!this.workflows.rcp && !this.workflows.rmp && !this.workflows.rcp_bs && !this.workflows.rmp_bs) {
      this.workflows.isregionalproformaenabled = false
    }
    if (!this.workflows.rcf && !this.workflows.rmf && !this.workflows.rcf_bs && !this.workflows.rmf_bs) {
      this.workflows.isregionalforecastenabled = false
    }
    if (!this.workflows.islocalproformaenabled && !this.workflows.islocalforecastenabled) {
      this.workflows.islocalenabled = false
    }
    if (!this.workflows.isregionalproformaenabled && !this.workflows.isregionalforecastenabled) {
      this.workflows.isregionalenabled = false
    }
    if (!this.workflows.islocalenabled && !this.workflows.isregionalenabled) {
      this.workflows.isworkflowsenabled = false
    }
    //console.log("Setting workflows based on configuration...",this.workflows);

  },
  getAllyears() {
    this.yearsList = []
    this.year.forEach(item => {
      this.yearsList.push({ name: item.name })
    })
  },
  saveFilterStatus() {
    if (this.selectedreportingunit === 'all') {
      let newObject = {
        selectedcountry: this.$refs.childfilter?.selectedcountry || 'all',
        selectedyear: this.$refs.childfilter?.selectedyear || 'all',
        selectednetwork: this.$refs.childfilter?.selectednetwork || 'all',
        selectedperiod: this.$refs.childfilter?.selectedperiod || 'all',
        selectedregion: this.$refs.childfilter?.selectedregion || 'all',
        selectedreportingunit: this.$refs.childfilter?.selectedreportingunit || 'all'
      };
      // Get the filter status from the store
      if(this.cycletype === 'Actual'){
        let filterStatus = this.$store.state[this.appname]?.actualFilterStatus || [];
      
        // Retrieve the last object from the filter status
        let lastObject = filterStatus[filterStatus.length - 1] || {};

        // Prepare the new object


        // Check if the new object is different from the last object
        let isDifferent = Object.keys(newObject).some(key => newObject[key] !== lastObject[key]);

        // Add the new object only if it's different or if keys are missing
        if (isDifferent || Object.keys(lastObject).length === 0) {
          this.$refs.childfilter.filterStatus.push(newObject);

          // Commit the updated filter status to the store
          this.$store.commit(this.appname + "/addActualFilterStatus", newObject);
        }
      }
      else if (this.cycletype === 'Forecast') {
        let filterStatus = this.$store.state[this.appname].forecastFilterStatus || [];

        let lastObject = filterStatus[filterStatus.length - 1] || {};

        let isDifferent = Object.keys(newObject).some(key => newObject[key] !== lastObject[key]);

        if (isDifferent || Object.keys(lastObject).length === 0) {
          this.$refs.childfilter.filterStatus.push(newObject);
          this.$store.commit(this.appname + "/addForecastFilterStatus", newObject);
        }
      }

    }
  },
  backFilterStatus() {
    if ((this.cycletype === 'actual' || this.cycletype === 'Actual')) {
      this.$store.commit(this.appname + "/popActualFilterStatus");
      this.reportingUnitFilter = this.$store.state[this.appname]?.actualFilterStatus?.pop() || {};
      this.reportingUnitFilter['emit'] = true;
      this.$store.commit(this.appname + "/setActualFilters", this.reportingUnitFilter);
    } else {
      this.$store.commit(this.appname + "/popForecastFilterStatus");
      this.reportingUnitFilter = this.$store.state[this.appname]?.forecastFilterStatus?.pop() || {};
      this.reportingUnitFilter['emit'] = true;
      this.$store.commit(this.appname + "/setForecastFilters", this.reportingUnitFilter);
    }
    this.selectedreportingunit = this.reportingUnitFilter.selectedreportingunit || 'all'
    this.selectedcountry = this.reportingUnitFilter.selectedcountry || 'all'
    this.selectedregion = this.reportingUnitFilter.selectedregion || 'all'
    this.selectednetwork = this.reportingUnitFilter.selectednetwork || 'all'
    this.selectedyear = this.reportingUnitFilter.selectedyear || 'all'
    this.selectedperiod = this.reportingUnitFilter.selectedperiod || 'all'

    this.$refs.childfilter.setFilterItem(this.reportingUnitFilter)
    this.loadContent()
  },
  previewBulkCommentary(display = true) {
    this.previewBulkAddCommentary = [];
    this.bulksubmitfiledata = [];
    if (this.ispreparer || this.isapprover || this.isregionalapprover || this.isviewonly) {
      this.multiselectdata.forEach(item => {
        let data = {};
        let gldata = this.commentarydatajsonById[item];
        data.glcode = gldata?.glcode_detail?._id || '';
        data.name = gldata?.glcode_detail?.name || '';
        data.code = gldata?.glcode_detail?.code || '';
        data.ignore = false
        data.isvolunterysubmit = false
        data.message = 'Ready to submit'
        if (typeof gldata.jv_commentary1 === 'object') {
          gldata.jvcommentary1 = Object.entries(gldata.jv_commentary1)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n');
        }
        if (typeof gldata.jv_commentary2 === 'object') {
          gldata.jvcommentary2 = Object.entries(gldata.jv_commentary2)
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n');
        }

        // if(this.bulkcommentreplace === true){
        data.commentary1 = gldata.jvcommentary1 || gldata.savedcommentary1 || '';
        // }
        // else{
        //   data.commentary1= gldata.commentary1 || ''
        //   data.ignore = true;
        // }
        // if(gldata.commentary2 === '' || this.bulkcommentreplace === true){
        data.commentary2 = gldata?.jvcommentary2 || gldata.savedcommentary2 || '';
        // }
        // else{
        //   data.commentary2= gldata.commentary2 || ''
        //   data.ignore = true;
        // }

        if ((data.commentary1 === '' && this.workflows.islocalproformaenabled && (gldata.saved_var1_cross_control || gldata.saved_var1_cross_management || gldata.var1_cross_control || gldata.var1_cross_management))) {
          if (!data.commentary1 || data.commentary1 === '' || data.commentary1 === "") {
            data.message = "Commentary1 required.";
            data.ignore = true;
          } else if (String(data.commentary1).trim().length < 15) {
            data.message = "Commentary1 minimum 15 characters required.";
            data.ignore = true;
          }
        }

        if ((data.commentary2 === '' && this.workflows.islocalforecastenabled && (gldata.saved_var2_cross_control || gldata.var2_cross_control || gldata.var2_cross_management || gldata.saved_var2_cross_management))) {
          if (data.message === 'Ready to submit') data.message = ""
          if (!data.commentary2 || data.commentary2 === '') {
            data.message += "Commentary2 required.";
            data.ignore = true;
          } else if (String(data.commentary2).trim().length < 15) {
            data.message += "Commentary2 minimum 15 characters required.";
            data.ignore = true;
          }
        }

        if (gldata.stage_local === 2) {
          data.ignore = true;
          data.message = "Ignored because local approve completed";
        } else if (gldata.stage_local === 4) {
          data.saved_var1_cross_control = gldata.saved_var1_cross_control || false;
          data.saved_var2_cross_control = gldata.saved_var2_cross_control || false;
          data.saved_var1_cross_management = gldata.saved_var1_cross_management || false;
          data.saved_var2_cross_management = gldata.saved_var2_cross_management || false;
          data.isvolunterysubmit = true

          if (!gldata.saved_var1_cross_control && !gldata.saved_var1_cross_management && !gldata.saved_var2_cross_control && !gldata.saved_var2_cross_management) {
            data.ignore = true;
            data.message = "Ignored because variance is immaterial";
          }
        } else if (gldata.stage_local === 3) {
          data.saved_var1_cross_control = gldata.saved_var1_cross_control || false;
          data.saved_var2_cross_control = gldata.saved_var2_cross_control || false;
          data.saved_var1_cross_management = gldata.saved_var1_cross_management || false;
          data.saved_var2_cross_management = gldata.saved_var2_cross_management || false;
          data.isvolunterysubmit = true
          if (!gldata.saved_var1_cross_control && !gldata.saved_var1_cross_management && !gldata.saved_var2_cross_control && !gldata.saved_var2_cross_management) {
            data.ignore = true;
            data.message = "Ignored because No variance";
          }
        } else if (gldata.__stage === 9 || gldata.stage_local === 5) {
          data.ignore = true;
          data.message = "Ignored because not in scope";
        }

        this.bulksubmitfiledata.push(data)
      })
      this.previewBulkAddCommentarydialog = display
    }
    else if (this.isapprover) {
      this.multiselectdata.forEach(item => {
        let data = {};
        let gldata = this.commentarydatajsonById[item];
        data.id = item;
        data.name = gldata?.glcode_detail?.name || '';
        data.code = gldata?.glcode_detail?.code || '';
        data.ignore = false
        data.message = 'Ready to submit'
        if (gldata.regionalcommentary1 === '' || this.bulkcommentreplace === true) {
          data.commentary1 = gldata?.jv_regionalcommentary1 || this.selectedcommentary?.regionalcommentary1 || '';
        } else {
          data.commentary1 = gldata.regionalcommentary1 || ''
        }
        if (gldata.regionalcommentary2 === '' || this.bulkcommentreplace === true) {
          data.commentary2 = gldata?.jv_regionalcommentary2 || this.selectedcommentary?.regionalcommentary2 || '';
        } else {
          data.commentary2 = gldata.regionalcommentary2 || ''
        }

        if ((data.regionalcommentary1 === '' && this.workflows.isregionalproformaenabled)) {
          if (!data.regionalcommentary1 || data.regionalcommentary1 === '') {
            data.message = "Commentary1 required.";
            data.ignore = true;
          } else if (String(data.regionalcommentary1).trim().length < 15) {
            data.message = "Commentary1 minimum 15 characters required.";
            data.ignore = true;
          }
        }
        if ((data.regionalcommentary2 === '' && this.workflows.isregionalforecastenabled)) {
          if (data.message === 'Ready to submit') data.message = ""
          if (!data.regionalcommentary2 || data.regionalcommentary2 === '') {
            data.message += "Commentary2 required.";
            data.ignore = true;
          } else if (String(data.regionalcommentary2).trim().length < 15) {
            data.message += "Commentary2 minimum 15 characters required.";
            data.ignore = true;
          }
        }
        if (gldata.stage_regional === 2) {
          data.ignore = true;
          data.message = "Ignored because local approve completed";
        } else if (gldata.stage_regional === 3) {
          data.ignore = true;
          data.message = "Ignored because variance is immaterial";
        } else if (gldata.stage_regional === 4) {
          data.ignore = true;
          data.message = "Ignored because no variance";
        } else if (gldata.__stage === 9 || gldata.stage_regional === 5) {
          data.ignore = true;
          data.message = "Ignored because not in scope";
        }
        this.bulksubmitfiledata.push(data)
      })
      console.log(this.previewBulkAddCommentary)
      this.previewBulkAddCommentarydialog = display
    }
  },

  getpdfFun() {
    this.rucyclepdfdownloadloading = true;
    this.rucyclepdfdownloaddialog = true;
    let url = "/v3/varianceanalysis/analysis/downloadsinglerupdfllist";
    // Build filter with optional reporting_type for Balance Sheet
    const pdfFilter = { type: 'singleru_pdf', cycle: this.commentarycycledata._id };
    if (this.reportingType) {
      pdfFilter.reporting_type = this.reportingType;
    }
    this.axios.post(url, { filter: pdfFilter }).then(dt => {
      if (dt.data.status === "success") {
        this.rucyclepdfdownloadlist = dt.data.data;

      }
      else throw new Error(dt.data.message || "Error loading download list");
    }).catch(err => {
      this.$store.commit("sbError", err.message || err || "Unknown error!");
      console.log(err);
    }).finally(() => {
      this.rucyclepdfdownloadloading = false;
    })
  },
  downloadRUPdfFile(downloadId) {
    if (!downloadId) return;
    this.$nova.downloadFile(
      undefined,
      {},
      `/v3/varianceanalysis/analysis/download/${downloadId}`,
      '&timestamp=' + new Date().getTime()
    );
  },
  filteredcommentarydataRaw() {
    let headerlist = {};
    let headerlistarr = [];
    let expandedIds = [];
    let ungroupedGLs = [];
    let ungroupedGLsChildren = [];
    
    // Build a map of children grouped by parent code (similar to GLforMngtCommentary's setDisplayList)
    const childrenByParent = {};
    
    for (let i = 0; i < this.commentarydata.length; i++) {
      const el = this.commentarydata[i];
      el.__key = i;
      el.__code = el.glcode_detail?.code;
      el.__parent = el.glcode_detail?.parent || "NA";
      // Note: level will be set correctly during DFS traversal below
      // Do NOT use path.length here as path may contain multiple codes
      
      // Group items by their parent
      if (!childrenByParent[el.__parent]) {
        childrenByParent[el.__parent] = [];
      }
      childrenByParent[el.__parent].push(el);
      
      if (el.__parent === "primary") {
        el.__type = "header";
        el.level = 0; // Root items are level 0
        headerlist[el.__code] = el;
        headerlistarr.push(el);
        expandedIds.push(el.__code);
      } else if (el.__parent === "NA" || el?.glcode_detail?.path?.includes("NA")) {
        el.level = 0; // Ungrouped items are also level 0
        ungroupedGLs.push(el.__code);
        ungroupedGLsChildren.push(el.__code, ...el.glcode_detail?.children || []);
        // --------------------
        // TODO - This might be optional if the ordering is proper. So can be removed later
        // Ensure ungrouped GLs are at the end
        // This should occur once
        if (el.glcode_detail.order < this.$constants.UNGROUPED_GL_OFFSET) {
          el.glcode_detail.oldOrder = el.glcode_detail.order
          el.glcode_detail.order +=  this.$constants.UNGROUPED_GL_OFFSET;
        }
        // --------------------
      }

      el.__stage = 0;
      if (el.stage_local === 0) el.__stage = 0;
      else if (el.stage_local === -1) el.__stage = -1;
      else if (el.stage_local === 1) el.__stage = 1;
      else if (el.stage_regional === 0) el.__stage = 5;
      else if (el.stage_regional === -1) el.__stage = -2;
      else if (el.stage_regional === 1) el.__stage = 6;
      else if (el.stage_regional === 2 || el.stage_local === 2) el.__stage = 7;
      else if (el.stage_local === 3) el.__stage = 3;
      else if (el.stage_regional === 4) el.__stage = 4;
      else if (el.stage_regional === 5 || el.stage_local === 5) el.__stage = 9;
      else el.__stage = 4;

      el.__myaction = "view";
      if (!el.ignorecommentary) {
        if (this.ispreparer && [-1, 0, 1, 9].indexOf(el.__stage) > -1) el.__myaction = "localadd";
        else if (this.isapprover && el.__stage === 1) el.__myaction = "localapprove";
        else if (this.isapprover && [-2, 5, 6, 9].indexOf(el.__stage) > -1) el.__myaction = "regionaladd";
        else if (this.isregionalapprover && el.__stage === 6) el.__myaction = "regionalapprove";
        else if (this.ispreparer && [3, 4, 8, 9].indexOf(el.__stage) > -1 && this.workflows.islocalenabled) el.__myaction = "localvoluntary";
        else if (this.isapprover && [3, 8, 9].indexOf(el.__stage) > -1 && this.workflows.isregionalenabled) el.__myaction = "regionalvoluntary";
        else if (this.isapprover && [7, 9].indexOf(el.__stage) > -1 && this.workflows.islocalenabled) el.__myaction = "localrequest";
        else if (this.isregionalapprover && [7, 9].indexOf(el.__stage) > -1 && this.workflows.isregionalenabled) el.__myaction = "regionalrequest";
        else el.__myaction = "view";
      }
    }

    if (this.commentarydata?.length && !headerlist["NA"]) {
      headerlist["NA"] = {
        __type: "header",
        __code: "NA",
        level: 0,
        name: "Ungrouped: Other sub-schedules and further Analysis Accounts",
        glcode_detail: {
          name: "Ungrouped: Other sub-schedules and further Analysis Accounts",
          children: ungroupedGLs,
          subsequent_children: ungroupedGLsChildren,
          order: this.$constants.UNGROUPED_GL_OFFSET, // Ensure it appears at the end
        }
      };
      headerlistarr.push(headerlist["NA"]);
      expandedIds.push("NA");
    }
    this.clearMultiselectData();

    let isFilterSet = false;

    // DFS traversal result array - maintains proper parent-child adjacency
    let orderedList = [];
    // Track visited items to prevent duplicates
    const visited = new Set();

    /**
     * DFS traversal to add items in tree order (parent followed by children)
     * This ensures the tree lines connect correctly by keeping children
     * immediately after their parent in the array.
     * Uses childrenByParent map (similar to GLforMngtCommentary's gllist approach)
     * @param {Object} item - The item to process
     * @param {Number} level - The tree depth level (0 for roots)
     */
    const traverseAndAdd = (item, level) => {
      if (!item) return;
      
      // Prevent duplicate processing
      const itemCode = item.__code || item.glcode_detail?.code;
      if (visited.has(itemCode)) return;
      visited.add(itemCode);
      
      // Set the level based on tree depth (like GLforMngtCommentary.flattenTree)
      item.level = level;
      
      // Check if this item should be filtered out
      const [itemIgnore, defaultFilter] = this.getFilterFlag(item);
      if (itemIgnore) {
        if (item?.__code !== "NA" && defaultFilter) {
          isFilterSet = true;
        }
      } else {
        orderedList.push(item);
      }

      // Get children from the grouped map and sort by order (similar to GLforMngtCommentary.flattenTree)
      const children = childrenByParent[itemCode] || [];
      if (children.length > 0) {
        // Sort siblings by order before traversing
        const sortedChildren = [...children].sort((a, b) => {
          const orderA = a.glcode_detail?.order ?? Number.MAX_SAFE_INTEGER;
          const orderB = b.glcode_detail?.order ?? Number.MAX_SAFE_INTEGER;
          return orderA - orderB;
        });
        
        for (const child of sortedChildren) {
          traverseAndAdd(child, level + 1);
        }
      }
    };

    // Sort header items (roots) by order first, then traverse each tree
    headerlistarr.sort((a, b) => {
      const orderA = a.glcode_detail?.order ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.glcode_detail?.order ?? Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    });

    for (const header of headerlistarr) {
      traverseAndAdd(header, 0); // Start at level 0 for root items
    }

    // Handle orphans - items that weren't visited because their parents are missing from the data
    // This ensure data visibility even if the hierarchy is broken (e.g. missing ancestors in API response)
    for (const item of this.commentarydata) {
      // Use __code which was set earlier (corresponds to glcode_detail.code)
      if (!visited.has(item.__code)) {
        traverseAndAdd(item, 0); // Treat as root
      }
    }

    // If only NA is present, let us not show it
    if (orderedList.length === 1 && orderedList[0]?.__code === "NA") {
      orderedList = [];
    }

    // Ensure final display order follows the backend-provided order field.
    // This is applied after building the flattened list (and levels) so that
    // pagination and the table render in the intended sequence.
    // Stable tie-breaker uses original __key (input order).
    orderedList.sort((a, b) => {
      const rawOrderA = a?.glcode_detail?.order;
      const rawOrderB = b?.glcode_detail?.order;
      const orderA = Number.isFinite(Number(rawOrderA)) ? Number(rawOrderA) : Number.MAX_SAFE_INTEGER;
      const orderB = Number.isFinite(Number(rawOrderB)) ? Number(rawOrderB) : Number.MAX_SAFE_INTEGER;
      if (orderA !== orderB) return orderA - orderB;

      const keyA = Number.isFinite(Number(a?.__key)) ? Number(a.__key) : 0;
      const keyB = Number.isFinite(Number(b?.__key)) ? Number(b.__key) : 0;
      return keyA - keyB;
    });

    this.setPageCount(Math.ceil(orderedList.length / this.perpage));
    return [orderedList, expandedIds, isFilterSet];
   },

  /**
   * Common GET helper with automatic cid injection.
   * Use everywhere instead of raw this.axios.get().
   * Call as: helpers.apiGet.call(this, url, params, options)
   * Or inside helpers methods: this.apiGet(url, params, options)
   * @param {string} url - The API endpoint URL
   * @param {Object} params - Additional query parameters (cid is injected automatically)
   * @param {Object} options - Extra axios config (e.g. { signal } for AbortController)
   * @returns {Promise} Axios GET response
   */
  apiGet(url, params = {}, options = {}) {
    return storeGet(this.axios, this.$store?.state || {}, url, params, options);
  },

  getRejectTargetList(workflows, labelsName) {
    const hasLocalWorkflow = workflows.lcp || workflows.lmp || workflows.lcf || workflows.lmf || workflows.lcp_bs || workflows.lmp_bs || workflows.lcf_bs || workflows.lmf_bs;
    const targets = [
      { 
        _id: 'local_approver', 
        name: labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver') 
      },
    ];
    if (hasLocalWorkflow) {
      targets.push({ 
        _id: 'local_preparer', 
        name: labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer') 
      });
    }

    return targets;
  },
  isMaterialityRequest(type) {
    if (!type) return false;
    return MATERIALITY_REQUEST_TYPES.includes(type);
  },
  resolveApprovedStage(responseData, requestType) {
    const responseStage = responseData?.[0]?.stage;
    if (responseStage !== undefined && responseStage !== null) {
      return responseStage;
    }
    if (this.isMaterialityRequest(requestType)) {
      return FILTER_APPROVAL_STATUS.IN_PROGRESS._id;
    }
    return FILTER_APPROVAL_STATUS.APPROVED._id;
  },
};
export default helpers;
